/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		2:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "-" + ({"0":"headroom","1":"teaser","4":"form-helpers","5":"password-lost"}[chunkId]||chunkId) + "-" + {"0":"a241a74f16c85ed5dd55","1":"f418867aed9ec2b1d5a7","4":"25e96a5636e3093fb8ec","5":"97661491edf2ed8f1e61","7":"85640cb68e0bfab72daf","8":"9d1a87c19c014381ed1a"}[chunkId] + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(97);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(29)('wks');
	var uid = __webpack_require__(27);
	var Symbol = __webpack_require__(1).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(2);
	var ctx = __webpack_require__(15);
	var hide = __webpack_require__(7);
	var has = __webpack_require__(11);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(17)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(9);
	var createDesc = __webpack_require__(24);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(43);
	var toPrimitive = __webpack_require__(40);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(44);
	var defined = __webpack_require__(20);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(16);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(9).f;
	var has = __webpack_require__(11);
	var TAG = __webpack_require__(3)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	var document = __webpack_require__(1).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(16);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(46);
	var enumBugKeys = __webpack_require__(28);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(29)('keys');
	var uid = __webpack_require__(27);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(2);
	var global = __webpack_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(18) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(20);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(14);
	var TAG = __webpack_require__(3)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(1).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(18);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(48);
	var hide = __webpack_require__(7);
	var Iterators = __webpack_require__(12);
	var $iterCreate = __webpack_require__(62);
	var setToStringTag = __webpack_require__(19);
	var getPrototypeOf = __webpack_require__(45);
	var ITERATOR = __webpack_require__(3)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(66);
	var enumBugKeys = __webpack_require__(28);
	var IE_PROTO = __webpack_require__(25)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(21)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(32).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(22);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(16);
	var SPECIES = __webpack_require__(3)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(15);
	var invoke = __webpack_require__(59);
	var html = __webpack_require__(32);
	var cel = __webpack_require__(21);
	var global = __webpack_require__(1);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(14)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(26);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(8);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(54), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(17)(function () {
	  return Object.defineProperty(__webpack_require__(21)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(14);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(11);
	var toObject = __webpack_require__(30);
	var IE_PROTO = __webpack_require__(25)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(11);
	var toIObject = __webpack_require__(13);
	var arrayIndexOf = __webpack_require__(57)(false);
	var IE_PROTO = __webpack_require__(25)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);


/***/ }),
/* 49 */
/***/ (function(module, exports) {



/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(72)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(33)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78);
	var global = __webpack_require__(1);
	var hide = __webpack_require__(7);
	var Iterators = __webpack_require__(12);
	var TO_STRING_TAG = __webpack_require__(3)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49);
	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	module.exports = __webpack_require__(2).Promise;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(13);
	var toLength = __webpack_require__(39);
	var toAbsoluteIndex = __webpack_require__(73);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(15);
	var call = __webpack_require__(61);
	var isArrayIter = __webpack_require__(60);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(39);
	var getIterFn = __webpack_require__(77);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(12);
	var ITERATOR = __webpack_require__(3)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(34);
	var descriptor = __webpack_require__(24);
	var setToStringTag = __webpack_require__(19);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(7)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(3)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var macrotask = __webpack_require__(38).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(14)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(9);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(23);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(47);
	var createDesc = __webpack_require__(24);
	var toIObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(40);
	var has = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(43);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(5);
	var core = __webpack_require__(2);
	var fails = __webpack_require__(17);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(7);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(1);
	var core = __webpack_require__(2);
	var dP = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(3)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(26);
	var defined = __webpack_require__(20);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(26);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(2);
	var LIBRARY = __webpack_require__(18);
	var wksExt = __webpack_require__(76);
	var defineProperty = __webpack_require__(9).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(3);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(31);
	var ITERATOR = __webpack_require__(3)('iterator');
	var Iterators = __webpack_require__(12);
	module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(55);
	var step = __webpack_require__(64);
	var Iterators = __webpack_require__(12);
	var toIObject = __webpack_require__(13);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(33)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(18);
	var global = __webpack_require__(1);
	var ctx = __webpack_require__(15);
	var classof = __webpack_require__(31);
	var $export = __webpack_require__(5);
	var isObject = __webpack_require__(8);
	var aFunction = __webpack_require__(16);
	var anInstance = __webpack_require__(56);
	var forOf = __webpack_require__(58);
	var speciesConstructor = __webpack_require__(37);
	var task = __webpack_require__(38).set;
	var microtask = __webpack_require__(65)();
	var newPromiseCapabilityModule = __webpack_require__(22);
	var perform = __webpack_require__(35);
	var userAgent = __webpack_require__(74);
	var promiseResolve = __webpack_require__(36);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(70)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(19)($Promise, PROMISE);
	__webpack_require__(71)(PROMISE);
	Wrapper = __webpack_require__(2)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(63)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(5);
	var core = __webpack_require__(2);
	var global = __webpack_require__(1);
	var speciesConstructor = __webpack_require__(37);
	var promiseResolve = __webpack_require__(36);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(5);
	var newPromiseCapability = __webpack_require__(22);
	var perform = __webpack_require__(35);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(42);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$top = _ref.top,
	        top = _ref$top === undefined ? 0 : _ref$top,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 1000 : _ref$duration,
	        easing = _ref.easing,
	        callback = _ref.callback;
	
	    if (callback) {
	        (0, _jquery2.default)('html,body').animate({ scrollTop: top }, duration, easing, callback);
	    } else {
	        return new _promise2.default(function (resolve) {
	            (0, _jquery2.default)('html,body').animate({ scrollTop: top }, duration, easing, function () {
	                resolve();
	            });
	        });
	    }
	};
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(46);
	var hiddenKeys = __webpack_require__(28).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/*!
	 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
	 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
	 * License: MIT
	 */
	
	(function($) {
	
	  if(!$) {
	    return;
	  }
	
	  ////////////
	  // Plugin //
	  ////////////
	
	  $.fn.headroom = function(option) {
	    return this.each(function() {
	      var $this   = $(this),
	        data      = $this.data('headroom'),
	        options   = typeof option === 'object' && option;
	
	      options = $.extend(true, {}, Headroom.options, options);
	
	      if (!data) {
	        data = new Headroom(this, options);
	        data.init();
	        $this.data('headroom', data);
	      }
	      if (typeof option === 'string') {
	        data[option]();
	
	        if(option === 'destroy'){
	          $this.removeData('headroom');
	        }
	      }
	    });
	  };
	
	  //////////////
	  // Data API //
	  //////////////
	
	  $('[data-headroom]').each(function() {
	    var $this = $(this);
	    $this.headroom($this.data());
	  });
	
	}(window.Zepto || window.jQuery));

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    // return cached browser if available
	    if (browser !== undefined) {
	        return browser;
	    }
	
	    var n,
	        v,
	        app = "",
	        ua = navigator.userAgent || navigator.vendor || window.opera,
	        donotnotify = false;
	    var names = { i: 'Internet Explorer', f: 'Firefox', o: 'Opera', s: 'Apple Safari', n: 'Netscape Navigator', c: "Chrome", a: "Android", x: "Other", fb: "Facebook" };
	    // modified by SPiNNWERK:
	    //   removed: android|phone|iPad|iPhone|iPod
	    if (/bot|googlebot|facebook|slurp|wii|silk|blackberry|maxthon|maxton|mediapartners|dolfin|dolphin|adsbot|silk|bingbot|google web preview|like firefox|chromeframe|seamonkey|opera mini|min|meego|netfront|moblin|maemo|arora|camino|flot|k-meleon|fennec|kazehakase|galeon|epiphany|konqueror|rekonq|symbian|webos|coolnovo|blackberry|bb10|RIM|PlayBook|PaleMoon|QupZilla/i.test(ua)) n = "x";else if (/Trident.*rv:(\d+\.\d+)/i.test(ua)) n = "i";else if (/Trident.(\d+\.\d+)/i.test(ua)) n = "io";else if (/MSIE.(\d+\.\d+)/i.test(ua)) n = "i";else if (/Edge.(\d+\.\d+)/i.test(ua)) n = "i";else if (/OPR.(\d+\.\d+)/i.test(ua)) n = "o";else if (/Chrome.(\d+\.\d+)/i.test(ua)) n = "c";else if (/Firefox.(\d+\.\d+)/i.test(ua)) n = "f";
	    // added by SPiNNWERK:
	    //   check for Android versions
	    else if (/Android.(\d+\.?\d+)/i.test(ua)) n = "a";else if (/Version.(\d+.\d+).{0,10}Safari/i.test(ua)) n = "s";else if (/Safari.(\d+)/i.test(ua)) n = "so";else if (/Opera.*Version.(\d+\.\d+)/i.test(ua)) n = "o";else if (/Opera.(\d+\.?\d+)/i.test(ua)) n = "o";else if (/Netscape.(\d+)/i.test(ua)) n = "n";else return { n: "x", v: 0, t: names[n] };
	
	    v = parseFloat(RegExp.$1);
	
	    // do not notify very old systems since their is no up-to-date browser available
	    if (/windows.nt.5.0|windows.nt.4.0|windows.98|os x 10.4|os x 10.5|os x 10.3|os x 10.2/.test(ua)) {
	        donotnotify = "oldOS";
	    }
	
	    // do not notify firefox ESR
	    if (n == "f" && (Math.round(v) == 24 || Math.round(v) == 31)) {
	        donotnotify = "ESR";
	    }
	    // do not notify opera 12 on linux since it is the latest version
	    if (/linux|x11|unix|bsd/.test(ua) && n == "o" && v > 12) {
	        donotnotify = "Opera12Linux";
	    }
	
	    if (n == "x") {
	        return { n: "x", v: v || 0, t: names[n], donotnotify: donotnotify };
	    }
	
	    // added by SPiNNWERK:
	    //   expect we have an Safari iOS device (iPhone, iPod, iPad) parse the right version number
	    if (n == "so") {
	        if (/(iPad|iPhone|iPod|iPod touch);.*CPU.*OS (\d+\_?\d+)/i.test(ua)) {
	            v = parseFloat(RegExp.$2.replace('_', '.'));
	            n = "s";
	        }
	    }
	
	    if (n == "i" && v == 7 && window.XDomainRequest) {
	        v = 8;
	    }
	
	    if (n == "io") {
	        n = "i";
	        if (v > 6) v = 11;else if (v > 5) v = 10;else if (v > 4) v = 9;else if (v > 3.1) v = 8;else if (v > 3) v = 7;else v = 9;
	    }
	
	    // added by SPiNNWERK:
	    //   check if the user is in an "in app browser"
	    //
	    // check for facebook in app browser
	    // http://stackoverflow.com/questions/31569518/how-to-detect-facebook-in-app-browser#32348687
	    if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) app = "fb";
	
	    browser = { n: n, v: v, app: app, t: names[n] + " " + v, donotnotify: donotnotify };
	
	    return browser;
	};
	
	/**
	 * store the browser to only execute once
	 */
	var browser;
	
	/**
	 * get the browser and it's version
	 *   Taken and modified from: http://www.browser-update.org/
	 *   Look for "by SPiNNWERK" comments for more info
	 */

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (configs) {
	    // return cached browser if available
	    if (oldBrowser !== undefined) {
	        return oldBrowser;
	    }
	
	    var vs = {
	        i: configs.ie,
	        f: configs.firefox,
	        c: configs.chrome,
	        o: configs.opera,
	        s: configs.safari,
	        a: configs.android
	    },
	        browser = (0, _getBrowser2.default)(),
	        doc = document.documentElement,
	        mobileDetect = new _mobileDetect2.default(navigator.userAgent);
	
	    oldBrowser = browser.v < vs[browser.n];
	
	    // add the oldie class to the html element when we have an old browser
	    if (oldBrowser) {
	        doc.className += ' oldie';
	    }
	
	    // store the value in window.oldBrowser
	    window.oldie = oldBrowser;
	
	    // ===================================================================
	    //                     browser detection helper
	    // ===================================================================
	
	    // add the user agent as data attribute
	    doc.setAttribute('data-useragent', navigator.userAgent);
	
	    // if the user in in an application (like facebook "in app browser")
	    doc.setAttribute('data-app', browser.app);
	
	    // add the browser abbreviation as data attribute
	    doc.setAttribute('data-browser', browser.n);
	
	    if (browser.n === 's') {
	        // add the safari data attribute when its Safari
	        doc.setAttribute('data-safari', browser.v);
	    } else if (browser.n === 'i') {
	        // add IE data attribute when we have one
	        doc.setAttribute('data-ie', browser.v);
	    } else if (browser.n === 'c') {
	        // add Chrome data attribute when we have one
	        doc.setAttribute('data-chrome', browser.v);
	    } else if (browser.n === 'f') {
	        // add FF data attribute when we have one
	        doc.setAttribute('data-ff', browser.v);
	    } else if (browser.n === 'o') {
	        // add Opera data attribute when we have one
	        doc.setAttribute('data-opera', browser.v);
	    } else if (browser.n === 'a') {
	        // add Android data attribute when we have one
	        doc.setAttribute('data-android', browser.v);
	    }
	
	    doc.setAttribute('data-mobile', !!mobileDetect.mobile());
	    doc.setAttribute('data-tablet', !!mobileDetect.tablet());
	
	    return oldBrowser;
	};
	
	var _getBrowser = __webpack_require__(93);
	
	var _getBrowser2 = _interopRequireDefault(_getBrowser);
	
	var _mobileDetect = __webpack_require__(166);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * store the oldie check value
	 */
	/* eslint-disable no-implicit-coercion */
	
	var oldBrowser;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$selector = _ref.selector,
	        selector = _ref$selector === undefined ? '.scroll-up' : _ref$selector,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 1000 : _ref$duration,
	        _ref$offsetTop = _ref.offsetTop,
	        offsetTop = _ref$offsetTop === undefined ? 300 : _ref$offsetTop,
	        _ref$scrollOffset = _ref.scrollOffset,
	        scrollOffset = _ref$scrollOffset === undefined ? 0 : _ref$scrollOffset;
	
	    var $scrollUp = (0, _jquery2.default)(selector);
	
	    // scroll top on click
	    $scrollUp.on('click', function (event) {
	        event.preventDefault();
	
	        (0, _scrollTo2.default)({
	            top: scrollOffset,
	            duration: duration
	        });
	    });
	
	    // only show the button after the offset
	    (0, _jquery2.default)(window).scroll(function () {
	        if (window.pageYOffset >= offsetTop) {
	            $scrollUp.fadeIn('fast');
	        } else {
	            $scrollUp.fadeOut('fast');
	        }
	    });
	};
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _scrollTo = __webpack_require__(84);
	
	var _scrollTo2 = _interopRequireDefault(_scrollTo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getOwnPropertyDescriptor = __webpack_require__(120);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _keys = __webpack_require__(122);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(121);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _setPrototypeOf = __webpack_require__(123);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(118);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(127);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty = __webpack_require__(119);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/******/(function (modules) {
	  // webpackBootstrap
	  /******/ // The module cache
	  /******/var installedModules = {};
	  /******/
	  /******/ // The require function
	  /******/function __webpack_require__(moduleId) {
	    /******/
	    /******/ // Check if module is in cache
	    /******/if (installedModules[moduleId]) {
	      /******/return installedModules[moduleId].exports;
	      /******/
	    }
	    /******/ // Create a new module (and put it into the cache)
	    /******/var module = installedModules[moduleId] = {
	      /******/i: moduleId,
	      /******/l: false,
	      /******/exports: {}
	      /******/ };
	    /******/
	    /******/ // Execute the module function
	    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	    /******/
	    /******/ // Flag the module as loaded
	    /******/module.l = true;
	    /******/
	    /******/ // Return the exports of the module
	    /******/return module.exports;
	    /******/
	  }
	  /******/
	  /******/
	  /******/ // expose the modules object (__webpack_modules__)
	  /******/__webpack_require__.m = modules;
	  /******/
	  /******/ // expose the module cache
	  /******/__webpack_require__.c = installedModules;
	  /******/
	  /******/ // identity function for calling harmony imports with the correct context
	  /******/__webpack_require__.i = function (value) {
	    return value;
	  };
	  /******/
	  /******/ // define getter function for harmony exports
	  /******/__webpack_require__.d = function (exports, name, getter) {
	    /******/if (!__webpack_require__.o(exports, name)) {
	      /******/(0, _defineProperty2.default)(exports, name, {
	        /******/configurable: false,
	        /******/enumerable: true,
	        /******/get: getter
	        /******/ });
	      /******/
	    }
	    /******/
	  };
	  /******/
	  /******/ // getDefaultExport function for compatibility with non-harmony modules
	  /******/__webpack_require__.n = function (module) {
	    /******/var getter = module && module.__esModule ?
	    /******/function getDefault() {
	      return module['default'];
	    } :
	    /******/function getModuleExports() {
	      return module;
	    };
	    /******/__webpack_require__.d(getter, 'a', getter);
	    /******/return getter;
	    /******/
	  };
	  /******/
	  /******/ // Object.prototype.hasOwnProperty.call
	  /******/__webpack_require__.o = function (object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  };
	  /******/
	  /******/ // __webpack_public_path__
	  /******/__webpack_require__.p = "";
	  /******/
	  /******/ // Load entry module and return exports
	  /******/return __webpack_require__(__webpack_require__.s = 36);
	  /******/
	})(
	/************************************************************************/
	/******/[
	/* 0 */
	/***/function (module, exports) {
	
	  module.exports = jQuery;
	
	  /***/
	},
	/* 1 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return rtl;
	  });
	  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
	    return GetYoDigits;
	  });
	  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
	    return transitionend;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	
	  // Core Foundation Utilities, utilized in a number of places.
	
	  /**
	   * Returns a boolean for RTL support
	   */
	  function rtl() {
	    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('dir') === 'rtl';
	  }
	
	  /**
	   * returns a random base-36 uid with namespacing
	   * @function
	   * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
	   * @param {String} namespace - name of plugin to be incorporated in uid, optional.
	   * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
	   * @returns {String} - unique id
	   */
	  function GetYoDigits(length, namespace) {
	    length = length || 6;
	    return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1) + (namespace ? '-' + namespace : '');
	  }
	
	  function transitionend($elem) {
	    var transitions = {
	      'transition': 'transitionend',
	      'WebkitTransition': 'webkitTransitionEnd',
	      'MozTransition': 'transitionend',
	      'OTransition': 'otransitionend'
	    };
	    var elem = document.createElement('div'),
	        end;
	
	    for (var t in transitions) {
	      if (typeof elem.style[t] !== 'undefined') {
	        end = transitions[t];
	      }
	    }
	    if (end) {
	      return end;
	    } else {
	      end = setTimeout(function () {
	        $elem.triggerHandler('transitionend', [$elem]);
	      }, 1);
	      return 'transitionend';
	    }
	  }
	
	  /***/
	},
	/* 2 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Plugin;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  // Abstract class for providing lifecycle hooks. Expect plugins to define AT LEAST
	  // {function} _setup (replaces previous constructor),
	  // {function} _destroy (replaces previous destroy)
	
	  var Plugin = function () {
	    function Plugin(element, options) {
	      _classCallCheck(this, Plugin);
	
	      this._setup(element, options);
	      var pluginName = getPluginName(this);
	      this.uuid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, pluginName);
	
	      if (!this.$element.attr('data-' + pluginName)) {
	        this.$element.attr('data-' + pluginName, this.uuid);
	      }
	      if (!this.$element.data('zfPlugin')) {
	        this.$element.data('zfPlugin', this);
	      }
	      /**
	       * Fires when the plugin has initialized.
	       * @event Plugin#init
	       */
	      this.$element.trigger('init.zf.' + pluginName);
	    }
	
	    _createClass(Plugin, [{
	      key: 'destroy',
	      value: function destroy() {
	        this._destroy();
	        var pluginName = getPluginName(this);
	        this.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
	        /**
	         * Fires when the plugin has been destroyed.
	         * @event Plugin#destroyed
	         */
	        .trigger('destroyed.zf.' + pluginName);
	        for (var prop in this) {
	          this[prop] = null; //clean up script to prep for garbage collection.
	        }
	      }
	    }]);
	
	    return Plugin;
	  }();
	
	  // Convert PascalCase to kebab-case
	  // Thank you: http://stackoverflow.com/a/8955580
	
	
	  function hyphenate(str) {
	    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	  }
	
	  function getPluginName(obj) {
	    if (typeof obj.constructor.name !== 'undefined') {
	      return hyphenate(obj.constructor.name);
	    } else {
	      return hyphenate(obj.className);
	    }
	  }
	
	  /***/
	},
	/* 3 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Keyboard;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /*******************************************
	   *                                         *
	   * This util was created by Marius Olbertz *
	   * Please thank Marius on GitHub /owlbertz *
	   * or the web http://www.mariusolbertz.de/ *
	   *                                         *
	   ******************************************/
	
	  var keyCodes = {
	    9: 'TAB',
	    13: 'ENTER',
	    27: 'ESCAPE',
	    32: 'SPACE',
	    35: 'END',
	    36: 'HOME',
	    37: 'ARROW_LEFT',
	    38: 'ARROW_UP',
	    39: 'ARROW_RIGHT',
	    40: 'ARROW_DOWN'
	  };
	
	  var commands = {};
	
	  // Functions pulled out to be referenceable from internals
	  function findFocusable($element) {
	    if (!$element) {
	      return false;
	    }
	    return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function () {
	      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is(':visible') || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('tabindex') < 0) {
	        return false;
	      } //only have visible elements and those that have a tabindex greater or equal 0
	      return true;
	    });
	  }
	
	  function parseKey(event) {
	    var key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
	
	    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
	    key = key.replace(/\W+/, '');
	
	    if (event.shiftKey) key = 'SHIFT_' + key;
	    if (event.ctrlKey) key = 'CTRL_' + key;
	    if (event.altKey) key = 'ALT_' + key;
	
	    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
	    key = key.replace(/_$/, '');
	
	    return key;
	  }
	
	  var Keyboard = {
	    keys: getKeyCodes(keyCodes),
	
	    /**
	     * Parses the (keyboard) event and returns a String that represents its key
	     * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	     * @param {Event} event - the event generated by the event handler
	     * @return String key - String that represents the key pressed
	     */
	    parseKey: parseKey,
	
	    /**
	     * Handles the given (keyboard) event
	     * @param {Event} event - the event generated by the event handler
	     * @param {String} component - Foundation component's name, e.g. Slider or Reveal
	     * @param {Objects} functions - collection of functions that are to be executed
	     */
	    handleKey: function handleKey(event, component, functions) {
	      var commandList = commands[component],
	          keyCode = this.parseKey(event),
	          cmds,
	          command,
	          fn;
	
	      if (!commandList) return console.warn('Component not defined!');
	
	      if (typeof commandList.ltr === 'undefined') {
	        // this component does not differentiate between ltr and rtl
	        cmds = commandList; // use plain list
	      } else {
	        // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["a" /* rtl */])()) cmds = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, commandList.ltr, commandList.rtl);else cmds = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, commandList.rtl, commandList.ltr);
	      }
	      command = cmds[keyCode];
	
	      fn = functions[command];
	      if (fn && typeof fn === 'function') {
	        // execute function  if exists
	        var returnValue = fn.apply();
	        if (functions.handled || typeof functions.handled === 'function') {
	          // execute function when event was handled
	          functions.handled(returnValue);
	        }
	      } else {
	        if (functions.unhandled || typeof functions.unhandled === 'function') {
	          // execute function when event was not handled
	          functions.unhandled();
	        }
	      }
	    },
	
	    /**
	     * Finds all focusable elements within the given `$element`
	     * @param {jQuery} $element - jQuery object to search within
	     * @return {jQuery} $focusable - all focusable elements within `$element`
	     */
	
	    findFocusable: findFocusable,
	
	    /**
	     * Returns the component name name
	     * @param {Object} component - Foundation component, e.g. Slider or Reveal
	     * @return String componentName
	     */
	
	    register: function register(componentName, cmds) {
	      commands[componentName] = cmds;
	    },
	
	    // TODO9438: These references to Keyboard need to not require global. Will 'this' work in this context?
	    //
	    /**
	     * Traps the focus in the given element.
	     * @param  {jQuery} $element  jQuery object to trap the foucs into.
	     */
	    trapFocus: function trapFocus($element) {
	      var $focusable = findFocusable($element),
	          $firstFocusable = $focusable.eq(0),
	          $lastFocusable = $focusable.eq(-1);
	
	      $element.on('keydown.zf.trapfocus', function (event) {
	        if (event.target === $lastFocusable[0] && parseKey(event) === 'TAB') {
	          event.preventDefault();
	          $firstFocusable.focus();
	        } else if (event.target === $firstFocusable[0] && parseKey(event) === 'SHIFT_TAB') {
	          event.preventDefault();
	          $lastFocusable.focus();
	        }
	      });
	    },
	
	    /**
	     * Releases the trapped focus from the given element.
	     * @param  {jQuery} $element  jQuery object to release the focus for.
	     */
	    releaseFocus: function releaseFocus($element) {
	      $element.off('keydown.zf.trapfocus');
	    }
	  };
	
	  /*
	   * Constants for easier comparing.
	   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	   */
	  function getKeyCodes(kcs) {
	    var k = {};
	    for (var kc in kcs) {
	      k[kcs[kc]] = kcs[kc];
	    }return k;
	  }
	
	  /***/
	},
	/* 4 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return MediaQuery;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	
	  // Default set of media queries
	  var defaultQueries = {
	    'default': 'only screen',
	    landscape: 'only screen and (orientation: landscape)',
	    portrait: 'only screen and (orientation: portrait)',
	    retina: 'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'
	  };
	
	  // matchMedia() polyfill - Test a CSS media type/query in JS.
	  // Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license
	  var matchMedia = window.matchMedia || function () {
	    'use strict';
	
	    // For browsers that support matchMedium api such as IE 9 and webkit
	
	    var styleMedia = window.styleMedia || window.media;
	
	    // For those that don't support matchMedium
	    if (!styleMedia) {
	      var style = document.createElement('style'),
	          script = document.getElementsByTagName('script')[0],
	          info = null;
	
	      style.type = 'text/css';
	      style.id = 'matchmediajs-test';
	
	      script && script.parentNode && script.parentNode.insertBefore(style, script);
	
	      // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
	      info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;
	
	      styleMedia = {
	        matchMedium: function matchMedium(media) {
	          var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
	
	          // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
	          if (style.styleSheet) {
	            style.styleSheet.cssText = text;
	          } else {
	            style.textContent = text;
	          }
	
	          // Test if media query is true or false
	          return info.width === '1px';
	        }
	      };
	    }
	
	    return function (media) {
	      return {
	        matches: styleMedia.matchMedium(media || 'all'),
	        media: media || 'all'
	      };
	    };
	  }();
	
	  var MediaQuery = {
	    queries: [],
	
	    current: '',
	
	    /**
	     * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
	     * @function
	     * @private
	     */
	    _init: function _init() {
	      var self = this;
	      var $meta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('meta.foundation-mq');
	      if (!$meta.length) {
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<meta class="foundation-mq">').appendTo(document.head);
	      }
	
	      var extractedStyles = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.foundation-mq').css('font-family');
	      var namedQueries;
	
	      namedQueries = parseStyleToObject(extractedStyles);
	
	      for (var key in namedQueries) {
	        if (namedQueries.hasOwnProperty(key)) {
	          self.queries.push({
	            name: key,
	            value: 'only screen and (min-width: ' + namedQueries[key] + ')'
	          });
	        }
	      }
	
	      this.current = this._getCurrentSize();
	
	      this._watcher();
	    },
	
	    /**
	     * Checks if the screen is at least as wide as a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to check.
	     * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
	     */
	    atLeast: function atLeast(size) {
	      var query = this.get(size);
	
	      if (query) {
	        return matchMedia(query).matches;
	      }
	
	      return false;
	    },
	
	    /**
	     * Checks if the screen matches to a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
	     * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
	     */
	    is: function is(size) {
	      size = size.trim().split(' ');
	      if (size.length > 1 && size[1] === 'only') {
	        if (size[0] === this._getCurrentSize()) return true;
	      } else {
	        return this.atLeast(size[0]);
	      }
	      return false;
	    },
	
	    /**
	     * Gets the media query of a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to get.
	     * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
	     */
	    get: function get(size) {
	      for (var i in this.queries) {
	        if (this.queries.hasOwnProperty(i)) {
	          var query = this.queries[i];
	          if (size === query.name) return query.value;
	        }
	      }
	
	      return null;
	    },
	
	    /**
	     * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
	     * @function
	     * @private
	     * @returns {String} Name of the current breakpoint.
	     */
	    _getCurrentSize: function _getCurrentSize() {
	      var matched;
	
	      for (var i = 0; i < this.queries.length; i++) {
	        var query = this.queries[i];
	
	        if (matchMedia(query.value).matches) {
	          matched = query;
	        }
	      }
	
	      if ((typeof matched === 'undefined' ? 'undefined' : (0, _typeof3.default)(matched)) === 'object') {
	        return matched.name;
	      } else {
	        return matched;
	      }
	    },
	
	    /**
	     * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
	     * @function
	     * @private
	     */
	    _watcher: function _watcher() {
	      var _this = this;
	
	      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('resize.zf.mediaquery').on('resize.zf.mediaquery', function () {
	        var newSize = _this._getCurrentSize(),
	            currentSize = _this.current;
	
	        if (newSize !== currentSize) {
	          // Change the current media query
	          _this.current = newSize;
	
	          // Broadcast the media query change on the window
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('changed.zf.mediaquery', [newSize, currentSize]);
	        }
	      });
	    }
	  };
	
	  // Thank you: https://github.com/sindresorhus/query-string
	  function parseStyleToObject(str) {
	    var styleObject = {};
	
	    if (typeof str !== 'string') {
	      return styleObject;
	    }
	
	    str = str.trim().slice(1, -1); // browsers re-quote string style values
	
	    if (!str) {
	      return styleObject;
	    }
	
	    styleObject = str.split('&').reduce(function (ret, param) {
	      var parts = param.replace(/\+/g, ' ').split('=');
	      var key = parts[0];
	      var val = parts[1];
	      key = decodeURIComponent(key);
	
	      // missing `=` should be `null`:
	      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
	      val = val === undefined ? null : decodeURIComponent(val);
	
	      if (!ret.hasOwnProperty(key)) {
	        ret[key] = val;
	      } else if (Array.isArray(ret[key])) {
	        ret[key].push(val);
	      } else {
	        ret[key] = [ret[key], val];
	      }
	      return ret;
	    }, {});
	
	    return styleObject;
	  }
	
	  /***/
	},
	/* 5 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Triggers;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_motion__ = __webpack_require__(6);
	
	  var MutationObserver = function () {
	    var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
	    for (var i = 0; i < prefixes.length; i++) {
	      if (prefixes[i] + 'MutationObserver' in window) {
	        return window[prefixes[i] + 'MutationObserver'];
	      }
	    }
	    return false;
	  }();
	
	  var triggers = function triggers(el, type) {
	    el.data(type).split(' ').forEach(function (id) {
	      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id)[type === 'close' ? 'trigger' : 'triggerHandler'](type + '.zf.trigger', [el]);
	    });
	  };
	
	  var Triggers = {
	    Listeners: {
	      Basic: {},
	      Global: {}
	    },
	    Initializers: {}
	  };
	
	  Triggers.Listeners.Basic = {
	    openListener: function openListener() {
	      triggers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), 'open');
	    },
	    closeListener: function closeListener() {
	      var id = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('close');
	      if (id) {
	        triggers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), 'close');
	      } else {
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('close.zf.trigger');
	      }
	    },
	    toggleListener: function toggleListener() {
	      var id = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('toggle');
	      if (id) {
	        triggers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), 'toggle');
	      } else {
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('toggle.zf.trigger');
	      }
	    },
	    closeableListener: function closeableListener(e) {
	      e.stopPropagation();
	      var animation = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('closable');
	
	      if (animation !== '') {
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_motion__["a" /* Motion */].animateOut(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), animation, function () {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('closed.zf');
	        });
	      } else {
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).fadeOut().trigger('closed.zf');
	      }
	    },
	    toggleFocusListener: function toggleFocusListener() {
	      var id = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('toggle-focus');
	      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id).triggerHandler('toggle.zf.trigger', [__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)]);
	    }
	  };
	
	  // Elements with [data-open] will reveal a plugin that supports it when clicked.
	  Triggers.Initializers.addOpenListener = function ($elem) {
	    $elem.off('click.zf.trigger', Triggers.Listeners.Basic.openListener);
	    $elem.on('click.zf.trigger', '[data-open]', Triggers.Listeners.Basic.openListener);
	  };
	
	  // Elements with [data-close] will close a plugin that supports it when clicked.
	  // If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
	  Triggers.Initializers.addCloseListener = function ($elem) {
	    $elem.off('click.zf.trigger', Triggers.Listeners.Basic.closeListener);
	    $elem.on('click.zf.trigger', '[data-close]', Triggers.Listeners.Basic.closeListener);
	  };
	
	  // Elements with [data-toggle] will toggle a plugin that supports it when clicked.
	  Triggers.Initializers.addToggleListener = function ($elem) {
	    $elem.off('click.zf.trigger', Triggers.Listeners.Basic.toggleListener);
	    $elem.on('click.zf.trigger', '[data-toggle]', Triggers.Listeners.Basic.toggleListener);
	  };
	
	  // Elements with [data-closable] will respond to close.zf.trigger events.
	  Triggers.Initializers.addCloseableListener = function ($elem) {
	    $elem.off('close.zf.trigger', Triggers.Listeners.Basic.closeableListener);
	    $elem.on('close.zf.trigger', '[data-closeable], [data-closable]', Triggers.Listeners.Basic.closeableListener);
	  };
	
	  // Elements with [data-toggle-focus] will respond to coming in and out of focus
	  Triggers.Initializers.addToggleFocusListener = function ($elem) {
	    $elem.off('focus.zf.trigger blur.zf.trigger', Triggers.Listeners.Basic.toggleFocusListener);
	    $elem.on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', Triggers.Listeners.Basic.toggleFocusListener);
	  };
	
	  // More Global/complex listeners and triggers
	  Triggers.Listeners.Global = {
	    resizeListener: function resizeListener($nodes) {
	      if (!MutationObserver) {
	        //fallback for IE 9
	        $nodes.each(function () {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).triggerHandler('resizeme.zf.trigger');
	        });
	      }
	      //trigger all listening elements and signal a resize event
	      $nodes.attr('data-events', "resize");
	    },
	    scrollListener: function scrollListener($nodes) {
	      if (!MutationObserver) {
	        //fallback for IE 9
	        $nodes.each(function () {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).triggerHandler('scrollme.zf.trigger');
	        });
	      }
	      //trigger all listening elements and signal a scroll event
	      $nodes.attr('data-events', "scroll");
	    },
	    closeMeListener: function closeMeListener(e, pluginId) {
	      var plugin = e.namespace.split('.')[0];
	      var plugins = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-' + plugin + ']').not('[data-yeti-box="' + pluginId + '"]');
	
	      plugins.each(function () {
	        var _this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	        _this.triggerHandler('close.zf.trigger', [_this]);
	      });
	    }
	
	    // Global, parses whole document.
	  };Triggers.Initializers.addClosemeListener = function (pluginName) {
	    var yetiBoxes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-yeti-box]'),
	        plugNames = ['dropdown', 'tooltip', 'reveal'];
	
	    if (pluginName) {
	      if (typeof pluginName === 'string') {
	        plugNames.push(pluginName);
	      } else if ((typeof pluginName === 'undefined' ? 'undefined' : (0, _typeof3.default)(pluginName)) === 'object' && typeof pluginName[0] === 'string') {
	        plugNames.concat(pluginName);
	      } else {
	        console.error('Plugin names must be strings');
	      }
	    }
	    if (yetiBoxes.length) {
	      var listeners = plugNames.map(function (name) {
	        return 'closeme.zf.' + name;
	      }).join(' ');
	
	      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off(listeners).on(listeners, Triggers.Listeners.Global.closeMeListener);
	    }
	  };
	
	  function debounceGlobalListener(debounce, trigger, listener) {
	    var timer = void 0,
	        args = Array.prototype.slice.call(arguments, 3);
	    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off(trigger).on(trigger, function (e) {
	      if (timer) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        listener.apply(null, args);
	      }, debounce || 10); //default time to emit scroll event
	    });
	  }
	
	  Triggers.Initializers.addResizeListener = function (debounce) {
	    var $nodes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-resize]');
	    if ($nodes.length) {
	      debounceGlobalListener(debounce, 'resize.zf.trigger', Triggers.Listeners.Global.resizeListener, $nodes);
	    }
	  };
	
	  Triggers.Initializers.addScrollListener = function (debounce) {
	    var $nodes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-scroll]');
	    if ($nodes.length) {
	      debounceGlobalListener(debounce, 'scroll.zf.trigger', Triggers.Listeners.Global.scrollListener, $nodes);
	    }
	  };
	
	  Triggers.Initializers.addMutationEventsListener = function ($elem) {
	    if (!MutationObserver) {
	      return false;
	    }
	    var $nodes = $elem.find('[data-resize], [data-scroll], [data-mutate]');
	
	    //element callback
	    var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
	      var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(mutationRecordsList[0].target);
	
	      //trigger the event handler for the element depending on type
	      switch (mutationRecordsList[0].type) {
	        case "attributes":
	          if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") {
	            $target.triggerHandler('scrollme.zf.trigger', [$target, window.pageYOffset]);
	          }
	          if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") {
	            $target.triggerHandler('resizeme.zf.trigger', [$target]);
	          }
	          if (mutationRecordsList[0].attributeName === "style") {
	            $target.closest("[data-mutate]").attr("data-events", "mutate");
	            $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
	          }
	          break;
	
	        case "childList":
	          $target.closest("[data-mutate]").attr("data-events", "mutate");
	          $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
	          break;
	
	        default:
	          return false;
	        //nothing
	      }
	    };
	
	    if ($nodes.length) {
	      //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
	      for (var i = 0; i <= $nodes.length - 1; i++) {
	        var elementObserver = new MutationObserver(listeningElementsMutation);
	        elementObserver.observe($nodes[i], { attributes: true, childList: true, characterData: false, subtree: true, attributeFilter: ["data-events", "style"] });
	      }
	    }
	  };
	
	  Triggers.Initializers.addSimpleListeners = function () {
	    var $document = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document);
	
	    Triggers.Initializers.addOpenListener($document);
	    Triggers.Initializers.addCloseListener($document);
	    Triggers.Initializers.addToggleListener($document);
	    Triggers.Initializers.addCloseableListener($document);
	    Triggers.Initializers.addToggleFocusListener($document);
	  };
	
	  Triggers.Initializers.addGlobalListeners = function () {
	    var $document = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document);
	    Triggers.Initializers.addMutationEventsListener($document);
	    Triggers.Initializers.addResizeListener();
	    Triggers.Initializers.addScrollListener();
	    Triggers.Initializers.addClosemeListener();
	  };
	
	  Triggers.init = function ($, Foundation) {
	    if (typeof $.triggersInitialized === 'undefined') {
	      var $document = $(document);
	
	      if (document.readyState === "complete") {
	        Triggers.Initializers.addSimpleListeners();
	        Triggers.Initializers.addGlobalListeners();
	      } else {
	        $(window).on('load', function () {
	          Triggers.Initializers.addSimpleListeners();
	          Triggers.Initializers.addGlobalListeners();
	        });
	      }
	
	      $.triggersInitialized = true;
	    }
	
	    if (Foundation) {
	      Foundation.Triggers = Triggers;
	      // Legacy included to be backwards compatible for now.
	      Foundation.IHearYou = Triggers.Initializers.addGlobalListeners;
	    }
	  };
	
	  /***/
	},
	/* 6 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "b", function () {
	    return Move;
	  });
	  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
	    return Motion;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	
	  /**
	   * Motion module.
	   * @module foundation.motion
	   */
	
	  var initClasses = ['mui-enter', 'mui-leave'];
	  var activeClasses = ['mui-enter-active', 'mui-leave-active'];
	
	  var Motion = {
	    animateIn: function animateIn(element, animation, cb) {
	      animate(true, element, animation, cb);
	    },
	
	    animateOut: function animateOut(element, animation, cb) {
	      animate(false, element, animation, cb);
	    }
	  };
	
	  function Move(duration, elem, fn) {
	    var anim,
	        prog,
	        start = null;
	    // console.log('called');
	
	    if (duration === 0) {
	      fn.apply(elem);
	      elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
	      return;
	    }
	
	    function move(ts) {
	      if (!start) start = ts;
	      // console.log(start, ts);
	      prog = ts - start;
	      fn.apply(elem);
	
	      if (prog < duration) {
	        anim = window.requestAnimationFrame(move, elem);
	      } else {
	        window.cancelAnimationFrame(anim);
	        elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
	      }
	    }
	    anim = window.requestAnimationFrame(move);
	  }
	
	  /**
	   * Animates an element in or out using a CSS transition class.
	   * @function
	   * @private
	   * @param {Boolean} isIn - Defines if the animation is in or out.
	   * @param {Object} element - jQuery or HTML object to animate.
	   * @param {String} animation - CSS class to use.
	   * @param {Function} cb - Callback to run when animation is finished.
	   */
	  function animate(isIn, element, animation, cb) {
	    element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).eq(0);
	
	    if (!element.length) return;
	
	    var initClass = isIn ? initClasses[0] : initClasses[1];
	    var activeClass = isIn ? activeClasses[0] : activeClasses[1];
	
	    // Set up the animation
	    reset();
	
	    element.addClass(animation).css('transition', 'none');
	
	    requestAnimationFrame(function () {
	      element.addClass(initClass);
	      if (isIn) element.show();
	    });
	
	    // Start the animation
	    requestAnimationFrame(function () {
	      element[0].offsetWidth;
	      element.css('transition', '').addClass(activeClass);
	    });
	
	    // Clean up the animation when it finishes
	    element.one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["c" /* transitionend */])(element), finish);
	
	    // Hides the element (for out animations), resets the element, and runs a callback
	    function finish() {
	      if (!isIn) element.hide();
	      reset();
	      if (cb) cb.apply(element);
	    }
	
	    // Resets transitions and removes motion-specific classes
	    function reset() {
	      element[0].style.transitionDuration = 0;
	      element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
	    }
	  }
	
	  /***/
	},
	/* 7 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Box;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__foundation_util_core__ = __webpack_require__(1);
	
	  var Box = {
	    ImNotTouchingYou: ImNotTouchingYou,
	    OverlapArea: OverlapArea,
	    GetDimensions: GetDimensions,
	    GetOffsets: GetOffsets,
	    GetExplicitOffsets: GetExplicitOffsets
	
	    /**
	     * Compares the dimensions of an element to a container and determines collision events with container.
	     * @function
	     * @param {jQuery} element - jQuery object to test for collisions.
	     * @param {jQuery} parent - jQuery object to use as bounding container.
	     * @param {Boolean} lrOnly - set to true to check left and right values only.
	     * @param {Boolean} tbOnly - set to true to check top and bottom values only.
	     * @default if no parent object passed, detects collisions with `window`.
	     * @returns {Boolean} - true if collision free, false if a collision in any direction.
	     */
	  };function ImNotTouchingYou(element, parent, lrOnly, tbOnly, ignoreBottom) {
	    return OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) === 0;
	  };
	
	  function OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) {
	    var eleDims = GetDimensions(element),
	        topOver,
	        bottomOver,
	        leftOver,
	        rightOver;
	    if (parent) {
	      var parDims = GetDimensions(parent);
	
	      bottomOver = parDims.height + parDims.offset.top - (eleDims.offset.top + eleDims.height);
	      topOver = eleDims.offset.top - parDims.offset.top;
	      leftOver = eleDims.offset.left - parDims.offset.left;
	      rightOver = parDims.width + parDims.offset.left - (eleDims.offset.left + eleDims.width);
	    } else {
	      bottomOver = eleDims.windowDims.height + eleDims.windowDims.offset.top - (eleDims.offset.top + eleDims.height);
	      topOver = eleDims.offset.top - eleDims.windowDims.offset.top;
	      leftOver = eleDims.offset.left - eleDims.windowDims.offset.left;
	      rightOver = eleDims.windowDims.width - (eleDims.offset.left + eleDims.width);
	    }
	
	    bottomOver = ignoreBottom ? 0 : Math.min(bottomOver, 0);
	    topOver = Math.min(topOver, 0);
	    leftOver = Math.min(leftOver, 0);
	    rightOver = Math.min(rightOver, 0);
	
	    if (lrOnly) {
	      return leftOver + rightOver;
	    }
	    if (tbOnly) {
	      return topOver + bottomOver;
	    }
	
	    // use sum of squares b/c we care about overlap area.
	    return Math.sqrt(topOver * topOver + bottomOver * bottomOver + leftOver * leftOver + rightOver * rightOver);
	  }
	
	  /**
	   * Uses native methods to return an object of dimension values.
	   * @function
	   * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
	   * @returns {Object} - nested object of integer pixel values
	   * TODO - if element is window, return only those values.
	   */
	  function GetDimensions(elem) {
	    elem = elem.length ? elem[0] : elem;
	
	    if (elem === window || elem === document) {
	      throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
	    }
	
	    var rect = elem.getBoundingClientRect(),
	        parRect = elem.parentNode.getBoundingClientRect(),
	        winRect = document.body.getBoundingClientRect(),
	        winY = window.pageYOffset,
	        winX = window.pageXOffset;
	
	    return {
	      width: rect.width,
	      height: rect.height,
	      offset: {
	        top: rect.top + winY,
	        left: rect.left + winX
	      },
	      parentDims: {
	        width: parRect.width,
	        height: parRect.height,
	        offset: {
	          top: parRect.top + winY,
	          left: parRect.left + winX
	        }
	      },
	      windowDims: {
	        width: winRect.width,
	        height: winRect.height,
	        offset: {
	          top: winY,
	          left: winX
	        }
	      }
	    };
	  }
	
	  /**
	   * Returns an object of top and left integer pixel values for dynamically rendered elements,
	   * such as: Tooltip, Reveal, and Dropdown. Maintained for backwards compatibility, and where
	   * you don't know alignment, but generally from
	   * 6.4 forward you should use GetExplicitOffsets, as GetOffsets conflates position and alignment.
	   * @function
	   * @param {jQuery} element - jQuery object for the element being positioned.
	   * @param {jQuery} anchor - jQuery object for the element's anchor point.
	   * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
	   * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
	   * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
	   * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
	   * TODO alter/rewrite to work with `em` values as well/instead of pixels
	   */
	  function GetOffsets(element, anchor, position, vOffset, hOffset, isOverflow) {
	    console.log("NOTE: GetOffsets is deprecated in favor of GetExplicitOffsets and will be removed in 6.5");
	    switch (position) {
	      case 'top':
	        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__foundation_util_core__["a" /* rtl */])() ? GetExplicitOffsets(element, anchor, 'top', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'top', 'right', vOffset, hOffset, isOverflow);
	      case 'bottom':
	        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__foundation_util_core__["a" /* rtl */])() ? GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
	      case 'center top':
	        return GetExplicitOffsets(element, anchor, 'top', 'center', vOffset, hOffset, isOverflow);
	      case 'center bottom':
	        return GetExplicitOffsets(element, anchor, 'bottom', 'center', vOffset, hOffset, isOverflow);
	      case 'center left':
	        return GetExplicitOffsets(element, anchor, 'left', 'center', vOffset, hOffset, isOverflow);
	      case 'center right':
	        return GetExplicitOffsets(element, anchor, 'right', 'center', vOffset, hOffset, isOverflow);
	      case 'left bottom':
	        return GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow);
	      case 'right bottom':
	        return GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
	      // Backwards compatibility... this along with the reveal and reveal full
	      // classes are the only ones that didn't reference anchor
	      case 'center':
	        return {
	          left: $eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2 + hOffset,
	          top: $eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - ($eleDims.height / 2 + vOffset)
	        };
	      case 'reveal':
	        return {
	          left: ($eleDims.windowDims.width - $eleDims.width) / 2 + hOffset,
	          top: $eleDims.windowDims.offset.top + vOffset
	        };
	      case 'reveal full':
	        return {
	          left: $eleDims.windowDims.offset.left,
	          top: $eleDims.windowDims.offset.top
	        };
	        break;
	      default:
	        return {
	          left: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__foundation_util_core__["a" /* rtl */])() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset : $anchorDims.offset.left + hOffset,
	          top: $anchorDims.offset.top + $anchorDims.height + vOffset
	        };
	
	    }
	  }
	
	  function GetExplicitOffsets(element, anchor, position, alignment, vOffset, hOffset, isOverflow) {
	    var $eleDims = GetDimensions(element),
	        $anchorDims = anchor ? GetDimensions(anchor) : null;
	
	    var topVal, leftVal;
	
	    // set position related attribute
	
	    switch (position) {
	      case 'top':
	        topVal = $anchorDims.offset.top - ($eleDims.height + vOffset);
	        break;
	      case 'bottom':
	        topVal = $anchorDims.offset.top + $anchorDims.height + vOffset;
	        break;
	      case 'left':
	        leftVal = $anchorDims.offset.left - ($eleDims.width + hOffset);
	        break;
	      case 'right':
	        leftVal = $anchorDims.offset.left + $anchorDims.width + hOffset;
	        break;
	    }
	
	    // set alignment related attribute
	    switch (position) {
	      case 'top':
	      case 'bottom':
	        switch (alignment) {
	          case 'left':
	            leftVal = $anchorDims.offset.left + hOffset;
	            break;
	          case 'right':
	            leftVal = $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset;
	            break;
	          case 'center':
	            leftVal = isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2 + hOffset;
	            break;
	        }
	        break;
	      case 'right':
	      case 'left':
	        switch (alignment) {
	          case 'bottom':
	            topVal = $anchorDims.offset.top - vOffset + $anchorDims.height - $eleDims.height;
	            break;
	          case 'top':
	            topVal = $anchorDims.offset.top + vOffset;
	            break;
	          case 'center':
	            topVal = $anchorDims.offset.top + vOffset + $anchorDims.height / 2 - $eleDims.height / 2;
	            break;
	        }
	        break;
	    }
	    return { top: topVal, left: leftVal };
	  }
	
	  /***/
	},
	/* 8 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return onImagesLoaded;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	
	  /**
	   * Runs a callback function when images are fully loaded.
	   * @param {Object} images - Image(s) to check if loaded.
	   * @param {Func} callback - Function to execute when image is fully loaded.
	   */
	  function onImagesLoaded(images, callback) {
	    var self = this,
	        unloaded = images.length;
	
	    if (unloaded === 0) {
	      callback();
	    }
	
	    images.each(function () {
	      // Check if image is loaded
	      if (this.complete && this.naturalWidth !== undefined) {
	        singleImageLoaded();
	      } else {
	        // If the above check failed, simulate loading on detached element.
	        var image = new Image();
	        // Still count image as loaded if it finalizes with an error.
	        var events = "load.zf.images error.zf.images";
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(image).one(events, function me(event) {
	          // Unbind the event listeners. We're using 'one' but only one of the two events will have fired.
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).off(events, me);
	          singleImageLoaded();
	        });
	        image.src = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('src');
	      }
	    });
	
	    function singleImageLoaded() {
	      unloaded--;
	      if (unloaded === 0) {
	        callback();
	      }
	    }
	  }
	
	  /***/
	},
	/* 9 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Nest;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	
	  var Nest = {
	    Feather: function Feather(menu) {
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zf';
	
	      menu.attr('role', 'menubar');
	
	      var items = menu.find('li').attr({ 'role': 'menuitem' }),
	          subMenuClass = 'is-' + type + '-submenu',
	          subItemClass = subMenuClass + '-item',
	          hasSubClass = 'is-' + type + '-submenu-parent',
	          applyAria = type !== 'accordion'; // Accordions handle their own ARIA attriutes.
	
	      items.each(function () {
	        var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	            $sub = $item.children('ul');
	
	        if ($sub.length) {
	          $item.addClass(hasSubClass);
	          $sub.addClass('submenu ' + subMenuClass).attr({ 'data-submenu': '' });
	          if (applyAria) {
	            $item.attr({
	              'aria-haspopup': true,
	              'aria-label': $item.children('a:first').text()
	            });
	            // Note:  Drilldowns behave differently in how they hide, and so need
	            // additional attributes.  We should look if this possibly over-generalized
	            // utility (Nest) is appropriate when we rework menus in 6.4
	            if (type === 'drilldown') {
	              $item.attr({ 'aria-expanded': false });
	            }
	          }
	          $sub.addClass('submenu ' + subMenuClass).attr({
	            'data-submenu': '',
	            'role': 'menu'
	          });
	          if (type === 'drilldown') {
	            $sub.attr({ 'aria-hidden': true });
	          }
	        }
	
	        if ($item.parent('[data-submenu]').length) {
	          $item.addClass('is-submenu-item ' + subItemClass);
	        }
	      });
	
	      return;
	    },
	    Burn: function Burn(menu, type) {
	      var //items = menu.find('li'),
	      subMenuClass = 'is-' + type + '-submenu',
	          subItemClass = subMenuClass + '-item',
	          hasSubClass = 'is-' + type + '-submenu-parent';
	
	      menu.find('>li, .menu, .menu > li').removeClass(subMenuClass + ' ' + subItemClass + ' ' + hasSubClass + ' is-submenu-item submenu is-active').removeAttr('data-submenu').css('display', '');
	    }
	  };
	
	  /***/
	},
	/* 10 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Touch;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  //**************************************************
	  //**Work inspired by multiple jquery swipe plugins**
	  //**Done by Yohai Ararat ***************************
	  //**************************************************
	
	
	  var Touch = {};
	
	  var startPosX,
	      startPosY,
	      startTime,
	      elapsedTime,
	      isMoving = false;
	
	  function onTouchEnd() {
	    //  alert(this);
	    this.removeEventListener('touchmove', onTouchMove);
	    this.removeEventListener('touchend', onTouchEnd);
	    isMoving = false;
	  }
	
	  function onTouchMove(e) {
	    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.spotSwipe.preventDefault) {
	      e.preventDefault();
	    }
	    if (isMoving) {
	      var x = e.touches[0].pageX;
	      var y = e.touches[0].pageY;
	      var dx = startPosX - x;
	      var dy = startPosY - y;
	      var dir;
	      elapsedTime = new Date().getTime() - startTime;
	      if (Math.abs(dx) >= __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.spotSwipe.moveThreshold && elapsedTime <= __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.spotSwipe.timeThreshold) {
	        dir = dx > 0 ? 'left' : 'right';
	      }
	      // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
	      //   dir = dy > 0 ? 'down' : 'up';
	      // }
	      if (dir) {
	        e.preventDefault();
	        onTouchEnd.call(this);
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('swipe', dir).trigger('swipe' + dir);
	      }
	    }
	  }
	
	  function onTouchStart(e) {
	    if (e.touches.length == 1) {
	      startPosX = e.touches[0].pageX;
	      startPosY = e.touches[0].pageY;
	      isMoving = true;
	      startTime = new Date().getTime();
	      this.addEventListener('touchmove', onTouchMove, false);
	      this.addEventListener('touchend', onTouchEnd, false);
	    }
	  }
	
	  function init() {
	    this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
	  }
	
	  function teardown() {
	    this.removeEventListener('touchstart', onTouchStart);
	  }
	
	  var SpotSwipe = function () {
	    function SpotSwipe($) {
	      _classCallCheck(this, SpotSwipe);
	
	      this.version = '1.0.0';
	      this.enabled = 'ontouchstart' in document.documentElement;
	      this.preventDefault = false;
	      this.moveThreshold = 75;
	      this.timeThreshold = 200;
	      this.$ = $;
	      this._init();
	    }
	
	    _createClass(SpotSwipe, [{
	      key: '_init',
	      value: function _init() {
	        var $ = this.$;
	        $.event.special.swipe = { setup: init };
	
	        $.each(['left', 'up', 'down', 'right'], function () {
	          $.event.special['swipe' + this] = { setup: function setup() {
	              $(this).on('swipe', $.noop);
	            } };
	        });
	      }
	    }]);
	
	    return SpotSwipe;
	  }();
	
	  /****************************************************
	   * As far as I can tell, both setupSpotSwipe and    *
	   * setupTouchHandler should be idempotent,          *
	   * because they directly replace functions &        *
	   * values, and do not add event handlers directly.  *
	   ****************************************************/
	
	  Touch.setupSpotSwipe = function ($) {
	    $.spotSwipe = new SpotSwipe($);
	  };
	
	  /****************************************************
	   * Method for adding pseudo drag events to elements *
	   ***************************************************/
	  Touch.setupTouchHandler = function ($) {
	    $.fn.addTouch = function () {
	      this.each(function (i, el) {
	        $(el).bind('touchstart touchmove touchend touchcancel', function () {
	          //we pass the original event object because the jQuery event
	          //object is normalized to w3c specs and does not provide the TouchList
	          handleTouch(event);
	        });
	      });
	
	      var handleTouch = function handleTouch(event) {
	        var touches = event.changedTouches,
	            first = touches[0],
	            eventTypes = {
	          touchstart: 'mousedown',
	          touchmove: 'mousemove',
	          touchend: 'mouseup'
	        },
	            type = eventTypes[event.type],
	            simulatedEvent;
	
	        if ('MouseEvent' in window && typeof window.MouseEvent === 'function') {
	          simulatedEvent = new window.MouseEvent(type, {
	            'bubbles': true,
	            'cancelable': true,
	            'screenX': first.screenX,
	            'screenY': first.screenY,
	            'clientX': first.clientX,
	            'clientY': first.clientY
	          });
	        } else {
	          simulatedEvent = document.createEvent('MouseEvent');
	          simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0 /*left*/, null);
	        }
	        first.target.dispatchEvent(simulatedEvent);
	      };
	    };
	  };
	
	  Touch.init = function ($) {
	    if (typeof $.spotSwipe === 'undefined') {
	      Touch.setupSpotSwipe($);
	      Touch.setupTouchHandler($);
	    }
	  };
	
	  /***/
	},
	/* 11 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Accordion;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Accordion module.
	   * @module foundation.accordion
	   * @requires foundation.util.keyboard
	   */
	
	  var Accordion = function (_Plugin) {
	    _inherits(Accordion, _Plugin);
	
	    function Accordion() {
	      _classCallCheck(this, Accordion);
	
	      return _possibleConstructorReturn(this, (Accordion.__proto__ || (0, _getPrototypeOf2.default)(Accordion)).apply(this, arguments));
	    }
	
	    _createClass(Accordion, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of an accordion.
	       * @class
	       * @name Accordion
	       * @fires Accordion#init
	       * @param {jQuery} element - jQuery object to make into an accordion.
	       * @param {Object} options - a plain object with settings to override the default options.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Accordion.defaults, this.$element.data(), options);
	
	        this.className = 'Accordion'; // ie9 back compat
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Accordion', {
	          'ENTER': 'toggle',
	          'SPACE': 'toggle',
	          'ARROW_DOWN': 'next',
	          'ARROW_UP': 'previous'
	        });
	      }
	
	      /**
	       * Initializes the accordion by animating the preset active pane(s).
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var _this3 = this;
	
	        this.$element.attr('role', 'tablist');
	        this.$tabs = this.$element.children('[data-accordion-item]');
	
	        this.$tabs.each(function (idx, el) {
	          var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el),
	              $content = $el.children('[data-tab-content]'),
	              id = $content[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */])(6, 'accordion'),
	              linkId = el.id || id + '-label';
	
	          $el.find('a:first').attr({
	            'aria-controls': id,
	            'role': 'tab',
	            'id': linkId,
	            'aria-expanded': false,
	            'aria-selected': false
	          });
	
	          $content.attr({ 'role': 'tabpanel', 'aria-labelledby': linkId, 'aria-hidden': true, 'id': id });
	        });
	        var $initActive = this.$element.find('.is-active').children('[data-tab-content]');
	        this.firstTimeInit = true;
	        if ($initActive.length) {
	          this.down($initActive, this.firstTimeInit);
	          this.firstTimeInit = false;
	        }
	
	        this._checkDeepLink = function () {
	          var anchor = window.location.hash;
	          //need a hash and a relevant anchor in this tabset
	          if (anchor.length) {
	            var $link = _this3.$element.find('[href$="' + anchor + '"]'),
	                $anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(anchor);
	
	            if ($link.length && $anchor) {
	              if (!$link.parent('[data-accordion-item]').hasClass('is-active')) {
	                _this3.down($anchor, _this3.firstTimeInit);
	                _this3.firstTimeInit = false;
	              };
	
	              //roll up a little to show the titles
	              if (_this3.options.deepLinkSmudge) {
	                var _this = _this3;
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).load(function () {
	                  var offset = _this.$element.offset();
	                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({ scrollTop: offset.top }, _this.options.deepLinkSmudgeDelay);
	                });
	              }
	
	              /**
	                * Fires when the zplugin has deeplinked at pageload
	                * @event Accordion#deeplink
	                */
	              _this3.$element.trigger('deeplink.zf.accordion', [$link, $anchor]);
	            }
	          }
	        };
	
	        //use browser to open a tab, if it exists in this tabset
	        if (this.options.deepLink) {
	          this._checkDeepLink();
	        }
	
	        this._events();
	      }
	
	      /**
	       * Adds event handlers for items within the accordion.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        this.$tabs.each(function () {
	          var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	          var $tabContent = $elem.children('[data-tab-content]');
	          if ($tabContent.length) {
	            $elem.children('a').off('click.zf.accordion keydown.zf.accordion').on('click.zf.accordion', function (e) {
	              e.preventDefault();
	              _this.toggle($tabContent);
	            }).on('keydown.zf.accordion', function (e) {
	              __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Accordion', {
	                toggle: function toggle() {
	                  _this.toggle($tabContent);
	                },
	                next: function next() {
	                  var $a = $elem.next().find('a').focus();
	                  if (!_this.options.multiExpand) {
	                    $a.trigger('click.zf.accordion');
	                  }
	                },
	                previous: function previous() {
	                  var $a = $elem.prev().find('a').focus();
	                  if (!_this.options.multiExpand) {
	                    $a.trigger('click.zf.accordion');
	                  }
	                },
	                handled: function handled() {
	                  e.preventDefault();
	                  e.stopPropagation();
	                }
	              });
	            });
	          }
	        });
	        if (this.options.deepLink) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('popstate', this._checkDeepLink);
	        }
	      }
	
	      /**
	       * Toggles the selected content pane's open/close state.
	       * @param {jQuery} $target - jQuery object of the pane to toggle (`.accordion-content`).
	       * @function
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle($target) {
	        if ($target.closest('[data-accordion]').is('[disabled]')) {
	          console.info('Cannot toggle an accordion that is disabled.');
	          return;
	        }
	        if ($target.parent().hasClass('is-active')) {
	          this.up($target);
	        } else {
	          this.down($target);
	        }
	        //either replace or update browser history
	        if (this.options.deepLink) {
	          var anchor = $target.prev('a').attr('href');
	
	          if (this.options.updateHistory) {
	            history.pushState({}, '', anchor);
	          } else {
	            history.replaceState({}, '', anchor);
	          }
	        }
	      }
	
	      /**
	       * Opens the accordion tab defined by `$target`.
	       * @param {jQuery} $target - Accordion pane to open (`.accordion-content`).
	       * @param {Boolean} firstTime - flag to determine if reflow should happen.
	       * @fires Accordion#down
	       * @function
	       */
	
	    }, {
	      key: 'down',
	      value: function down($target, firstTime) {
	        var _this4 = this;
	
	        /**
	         * checking firstTime allows for initial render of the accordion
	         * to render preset is-active panes.
	         */
	        if ($target.closest('[data-accordion]').is('[disabled]') && !firstTime) {
	          console.info('Cannot call down on an accordion that is disabled.');
	          return;
	        }
	        $target.attr('aria-hidden', false).parent('[data-tab-content]').addBack().parent().addClass('is-active');
	
	        if (!this.options.multiExpand && !firstTime) {
	          var $currentActive = this.$element.children('.is-active').children('[data-tab-content]');
	          if ($currentActive.length) {
	            this.up($currentActive.not($target));
	          }
	        }
	
	        $target.slideDown(this.options.slideSpeed, function () {
	          /**
	           * Fires when the tab is done opening.
	           * @event Accordion#down
	           */
	          _this4.$element.trigger('down.zf.accordion', [$target]);
	        });
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + $target.attr('aria-labelledby')).attr({
	          'aria-expanded': true,
	          'aria-selected': true
	        });
	      }
	
	      /**
	       * Closes the tab defined by `$target`.
	       * @param {jQuery} $target - Accordion tab to close (`.accordion-content`).
	       * @fires Accordion#up
	       * @function
	       */
	
	    }, {
	      key: 'up',
	      value: function up($target) {
	        if ($target.closest('[data-accordion]').is('[disabled]')) {
	          console.info('Cannot call up on an accordion that is disabled.');
	          return;
	        }
	
	        var $aunts = $target.parent().siblings(),
	            _this = this;
	
	        if (!this.options.allowAllClosed && !$aunts.hasClass('is-active') || !$target.parent().hasClass('is-active')) {
	          return;
	        }
	
	        $target.slideUp(_this.options.slideSpeed, function () {
	          /**
	           * Fires when the tab is done collapsing up.
	           * @event Accordion#up
	           */
	          _this.$element.trigger('up.zf.accordion', [$target]);
	        });
	
	        $target.attr('aria-hidden', true).parent().removeClass('is-active');
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + $target.attr('aria-labelledby')).attr({
	          'aria-expanded': false,
	          'aria-selected': false
	        });
	      }
	
	      /**
	       * Destroys an instance of an accordion.
	       * @fires Accordion#destroyed
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.find('[data-tab-content]').stop(true).slideUp(0).css('display', '');
	        this.$element.find('a').off('.zf.accordion');
	        if (this.options.deepLink) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('popstate', this._checkDeepLink);
	        }
	      }
	    }]);
	
	    return Accordion;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  Accordion.defaults = {
	    /**
	     * Amount of time to animate the opening of an accordion pane.
	     * @option
	     * @type {number}
	     * @default 250
	     */
	    slideSpeed: 250,
	    /**
	     * Allow the accordion to have multiple open panes.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    multiExpand: false,
	    /**
	     * Allow the accordion to close all panes.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    allowAllClosed: false,
	    /**
	     * Allows the window to scroll to content of pane specified by hash anchor
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLink: false,
	
	    /**
	     * Adjust the deep link scroll to make sure the top of the accordion panel is visible
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLinkSmudge: false,
	
	    /**
	     * Animation time (ms) for the deep link adjustment
	     * @option
	     * @type {number}
	     * @default 300
	     */
	    deepLinkSmudgeDelay: 300,
	
	    /**
	     * Update the browser history with the open accordion
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    updateHistory: false
	  };
	
	  /***/
	},
	/* 12 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return AccordionMenu;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__ = __webpack_require__(9);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * AccordionMenu module.
	   * @module foundation.accordionMenu
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.nest
	   */
	
	  var AccordionMenu = function (_Plugin) {
	    _inherits(AccordionMenu, _Plugin);
	
	    function AccordionMenu() {
	      _classCallCheck(this, AccordionMenu);
	
	      return _possibleConstructorReturn(this, (AccordionMenu.__proto__ || (0, _getPrototypeOf2.default)(AccordionMenu)).apply(this, arguments));
	    }
	
	    _createClass(AccordionMenu, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of an accordion menu.
	       * @class
	       * @name AccordionMenu
	       * @fires AccordionMenu#init
	       * @param {jQuery} element - jQuery object to make into an accordion menu.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, AccordionMenu.defaults, this.$element.data(), options);
	        this.className = 'AccordionMenu'; // ie9 back compat
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('AccordionMenu', {
	          'ENTER': 'toggle',
	          'SPACE': 'toggle',
	          'ARROW_RIGHT': 'open',
	          'ARROW_UP': 'up',
	          'ARROW_DOWN': 'down',
	          'ARROW_LEFT': 'close',
	          'ESCAPE': 'closeAll'
	        });
	      }
	
	      /**
	       * Initializes the accordion menu by hiding all nested menus.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Feather(this.$element, 'accordion');
	
	        var _this = this;
	
	        this.$element.find('[data-submenu]').not('.is-active').slideUp(0); //.find('a').css('padding-left', '1rem');
	        this.$element.attr({
	          'role': 'tree',
	          'aria-multiselectable': this.options.multiOpen
	        });
	
	        this.$menuLinks = this.$element.find('.is-accordion-submenu-parent');
	        this.$menuLinks.each(function () {
	          var linkId = this.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'acc-menu-link'),
	              $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $sub = $elem.children('[data-submenu]'),
	              subId = $sub[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'acc-menu'),
	              isActive = $sub.hasClass('is-active');
	
	          if (_this.options.submenuToggle) {
	            $elem.addClass('has-submenu-toggle');
	            $elem.children('a').after('<button id="' + linkId + '" class="submenu-toggle" aria-controls="' + subId + '" aria-expanded="' + isActive + '" title="' + _this.options.submenuToggleText + '"><span class="submenu-toggle-text">' + _this.options.submenuToggleText + '</span></button>');
	          } else {
	            $elem.attr({
	              'aria-controls': subId,
	              'aria-expanded': isActive,
	              'id': linkId
	            });
	          }
	          $sub.attr({
	            'aria-labelledby': linkId,
	            'aria-hidden': !isActive,
	            'role': 'group',
	            'id': subId
	          });
	        });
	        this.$element.find('li').attr({
	          'role': 'treeitem'
	        });
	        var initPanes = this.$element.find('.is-active');
	        if (initPanes.length) {
	          var _this = this;
	          initPanes.each(function () {
	            _this.down(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	          });
	        }
	        this._events();
	      }
	
	      /**
	       * Adds event handlers for items within the menu.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        this.$element.find('li').each(function () {
	          var $submenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('[data-submenu]');
	
	          if ($submenu.length) {
	            if (_this.options.submenuToggle) {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('.submenu-toggle').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function (e) {
	                _this.toggle($submenu);
	              });
	            } else {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('a').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function (e) {
	                e.preventDefault();
	                _this.toggle($submenu);
	              });
	            }
	          }
	        }).on('keydown.zf.accordionmenu', function (e) {
	          var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $elements = $element.parent('ul').children('li'),
	              $prevElement,
	              $nextElement,
	              $target = $element.children('[data-submenu]');
	
	          $elements.each(function (i) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is($element)) {
	              $prevElement = $elements.eq(Math.max(0, i - 1)).find('a').first();
	              $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1)).find('a').first();
	
	              if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('[data-submenu]:visible').length) {
	                // has open sub menu
	                $nextElement = $element.find('li:first-child').find('a').first();
	              }
	              if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is(':first-child')) {
	                // is first element of sub menu
	                $prevElement = $element.parents('li').first().find('a').first();
	              } else if ($prevElement.parents('li').first().children('[data-submenu]:visible').length) {
	                // if previous element has open sub menu
	                $prevElement = $prevElement.parents('li').find('li:last-child').find('a').first();
	              }
	              if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is(':last-child')) {
	                // is last element of sub menu
	                $nextElement = $element.parents('li').first().next('li').find('a').first();
	              }
	
	              return;
	            }
	          });
	
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'AccordionMenu', {
	            open: function open() {
	              if ($target.is(':hidden')) {
	                _this.down($target);
	                $target.find('li').first().find('a').first().focus();
	              }
	            },
	            close: function close() {
	              if ($target.length && !$target.is(':hidden')) {
	                // close active sub of this item
	                _this.up($target);
	              } else if ($element.parent('[data-submenu]').length) {
	                // close currently open sub
	                _this.up($element.parent('[data-submenu]'));
	                $element.parents('li').first().find('a').first().focus();
	              }
	            },
	            up: function up() {
	              $prevElement.focus();
	              return true;
	            },
	            down: function down() {
	              $nextElement.focus();
	              return true;
	            },
	            toggle: function toggle() {
	              if (_this.options.submenuToggle) {
	                return false;
	              }
	              if ($element.children('[data-submenu]').length) {
	                _this.toggle($element.children('[data-submenu]'));
	                return true;
	              }
	            },
	            closeAll: function closeAll() {
	              _this.hideAll();
	            },
	            handled: function handled(preventDefault) {
	              if (preventDefault) {
	                e.preventDefault();
	              }
	              e.stopImmediatePropagation();
	            }
	          });
	        }); //.attr('tabindex', 0);
	      }
	
	      /**
	       * Closes all panes of the menu.
	       * @function
	       */
	
	    }, {
	      key: 'hideAll',
	      value: function hideAll() {
	        this.up(this.$element.find('[data-submenu]'));
	      }
	
	      /**
	       * Opens all panes of the menu.
	       * @function
	       */
	
	    }, {
	      key: 'showAll',
	      value: function showAll() {
	        this.down(this.$element.find('[data-submenu]'));
	      }
	
	      /**
	       * Toggles the open/close state of a submenu.
	       * @function
	       * @param {jQuery} $target - the submenu to toggle
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle($target) {
	        if (!$target.is(':animated')) {
	          if (!$target.is(':hidden')) {
	            this.up($target);
	          } else {
	            this.down($target);
	          }
	        }
	      }
	
	      /**
	       * Opens the sub-menu defined by `$target`.
	       * @param {jQuery} $target - Sub-menu to open.
	       * @fires AccordionMenu#down
	       */
	
	    }, {
	      key: 'down',
	      value: function down($target) {
	        var _this = this;
	
	        if (!this.options.multiOpen) {
	          this.up(this.$element.find('.is-active').not($target.parentsUntil(this.$element).add($target)));
	        }
	
	        $target.addClass('is-active').attr({ 'aria-hidden': false });
	
	        if (this.options.submenuToggle) {
	          $target.prev('.submenu-toggle').attr({ 'aria-expanded': true });
	        } else {
	          $target.parent('.is-accordion-submenu-parent').attr({ 'aria-expanded': true });
	        }
	
	        $target.slideDown(_this.options.slideSpeed, function () {
	          /**
	           * Fires when the menu is done opening.
	           * @event AccordionMenu#down
	           */
	          _this.$element.trigger('down.zf.accordionMenu', [$target]);
	        });
	      }
	
	      /**
	       * Closes the sub-menu defined by `$target`. All sub-menus inside the target will be closed as well.
	       * @param {jQuery} $target - Sub-menu to close.
	       * @fires AccordionMenu#up
	       */
	
	    }, {
	      key: 'up',
	      value: function up($target) {
	        var _this = this;
	        $target.slideUp(_this.options.slideSpeed, function () {
	          /**
	           * Fires when the menu is done collapsing up.
	           * @event AccordionMenu#up
	           */
	          _this.$element.trigger('up.zf.accordionMenu', [$target]);
	        });
	
	        var $menus = $target.find('[data-submenu]').slideUp(0).addBack().attr('aria-hidden', true);
	
	        if (this.options.submenuToggle) {
	          $menus.prev('.submenu-toggle').attr('aria-expanded', false);
	        } else {
	          $menus.parent('.is-accordion-submenu-parent').attr('aria-expanded', false);
	        }
	      }
	
	      /**
	       * Destroys an instance of accordion menu.
	       * @fires AccordionMenu#destroyed
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.find('[data-submenu]').slideDown(0).css('display', '');
	        this.$element.find('a').off('click.zf.accordionMenu');
	
	        if (this.options.submenuToggle) {
	          this.$element.find('.has-submenu-toggle').removeClass('has-submenu-toggle');
	          this.$element.find('.submenu-toggle').remove();
	        }
	
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Burn(this.$element, 'accordion');
	      }
	    }]);
	
	    return AccordionMenu;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_plugin__["a" /* Plugin */]);
	
	  AccordionMenu.defaults = {
	    /**
	     * Amount of time to animate the opening of a submenu in ms.
	     * @option
	     * @type {number}
	     * @default 250
	     */
	    slideSpeed: 250,
	    /**
	     * Adds a separate submenu toggle button. This allows the parent item to have a link.
	     * @option
	     * @example true
	     */
	    submenuToggle: false,
	    /**
	     * The text used for the submenu toggle if enabled. This is used for screen readers only.
	     * @option
	     * @example true
	     */
	    submenuToggleText: 'Toggle menu',
	    /**
	     * Allow the menu to have multiple open panes.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    multiOpen: true
	  };
	
	  /***/
	},
	/* 13 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Drilldown;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__ = __webpack_require__(9);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_box__ = __webpack_require__(7);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Drilldown module.
	   * @module foundation.drilldown
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.nest
	   * @requires foundation.util.box
	   */
	
	  var Drilldown = function (_Plugin) {
	    _inherits(Drilldown, _Plugin);
	
	    function Drilldown() {
	      _classCallCheck(this, Drilldown);
	
	      return _possibleConstructorReturn(this, (Drilldown.__proto__ || (0, _getPrototypeOf2.default)(Drilldown)).apply(this, arguments));
	    }
	
	    _createClass(Drilldown, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a drilldown menu.
	       * @class
	       * @name Drilldown
	       * @param {jQuery} element - jQuery object to make into an accordion menu.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Drilldown.defaults, this.$element.data(), options);
	        this.className = 'Drilldown'; // ie9 back compat
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Drilldown', {
	          'ENTER': 'open',
	          'SPACE': 'open',
	          'ARROW_RIGHT': 'next',
	          'ARROW_UP': 'up',
	          'ARROW_DOWN': 'down',
	          'ARROW_LEFT': 'previous',
	          'ESCAPE': 'close',
	          'TAB': 'down',
	          'SHIFT_TAB': 'up'
	        });
	      }
	
	      /**
	       * Initializes the drilldown by creating jQuery collections of elements
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Feather(this.$element, 'drilldown');
	
	        if (this.options.autoApplyClass) {
	          this.$element.addClass('drilldown');
	        }
	
	        this.$element.attr({
	          'role': 'tree',
	          'aria-multiselectable': false
	        });
	        this.$submenuAnchors = this.$element.find('li.is-drilldown-submenu-parent').children('a');
	        this.$submenus = this.$submenuAnchors.parent('li').children('[data-submenu]').attr('role', 'group');
	        this.$menuItems = this.$element.find('li').not('.js-drilldown-back').attr('role', 'treeitem').find('a');
	        this.$element.attr('data-mutate', this.$element.attr('data-drilldown') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'drilldown'));
	
	        this._prepareMenu();
	        this._registerEvents();
	
	        this._keyboardEvents();
	      }
	
	      /**
	       * prepares drilldown menu by setting attributes to links and elements
	       * sets a min height to prevent content jumping
	       * wraps the element if not already wrapped
	       * @private
	       * @function
	       */
	
	    }, {
	      key: '_prepareMenu',
	      value: function _prepareMenu() {
	        var _this = this;
	        // if(!this.options.holdOpen){
	        //   this._menuLinkEvents();
	        // }
	        this.$submenuAnchors.each(function () {
	          var $link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	          var $sub = $link.parent();
	          if (_this.options.parentLink) {
	            $link.clone().prependTo($sub.children('[data-submenu]')).wrap('<li class="is-submenu-parent-item is-submenu-item is-drilldown-submenu-item" role="menuitem"></li>');
	          }
	          $link.data('savedHref', $link.attr('href')).removeAttr('href').attr('tabindex', 0);
	          $link.children('[data-submenu]').attr({
	            'aria-hidden': true,
	            'tabindex': 0,
	            'role': 'group'
	          });
	          _this._events($link);
	        });
	        this.$submenus.each(function () {
	          var $menu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $back = $menu.find('.js-drilldown-back');
	          if (!$back.length) {
	            switch (_this.options.backButtonPosition) {
	              case "bottom":
	                $menu.append(_this.options.backButton);
	                break;
	              case "top":
	                $menu.prepend(_this.options.backButton);
	                break;
	              default:
	                console.error("Unsupported backButtonPosition value '" + _this.options.backButtonPosition + "'");
	            }
	          }
	          _this._back($menu);
	        });
	
	        this.$submenus.addClass('invisible');
	        if (!this.options.autoHeight) {
	          this.$submenus.addClass('drilldown-submenu-cover-previous');
	        }
	
	        // create a wrapper on element if it doesn't exist.
	        if (!this.$element.parent().hasClass('is-drilldown')) {
	          this.$wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.options.wrapper).addClass('is-drilldown');
	          if (this.options.animateHeight) this.$wrapper.addClass('animate-height');
	          this.$element.wrap(this.$wrapper);
	        }
	        // set wrapper
	        this.$wrapper = this.$element.parent();
	        this.$wrapper.css(this._getMaxDims());
	      }
	    }, {
	      key: '_resize',
	      value: function _resize() {
	        this.$wrapper.css({ 'max-width': 'none', 'min-height': 'none' });
	        // _getMaxDims has side effects (boo) but calling it should update all other necessary heights & widths
	        this.$wrapper.css(this._getMaxDims());
	      }
	
	      /**
	       * Adds event handlers to elements in the menu.
	       * @function
	       * @private
	       * @param {jQuery} $elem - the current menu item to add handlers to.
	       */
	
	    }, {
	      key: '_events',
	      value: function _events($elem) {
	        var _this = this;
	
	        $elem.off('click.zf.drilldown').on('click.zf.drilldown', function (e) {
	          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parentsUntil('ul', 'li').hasClass('is-drilldown-submenu-parent')) {
	            e.stopImmediatePropagation();
	            e.preventDefault();
	          }
	
	          // if(e.target !== e.currentTarget.firstElementChild){
	          //   return false;
	          // }
	          _this._show($elem.parent('li'));
	
	          if (_this.options.closeOnClick) {
	            var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body');
	            $body.off('.zf.drilldown').on('click.zf.drilldown', function (e) {
	              if (e.target === _this.$element[0] || __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.contains(_this.$element[0], e.target)) {
	                return;
	              }
	              e.preventDefault();
	              _this._hideAll();
	              $body.off('.zf.drilldown');
	            });
	          }
	        });
	      }
	
	      /**
	       * Adds event handlers to the menu element.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_registerEvents',
	      value: function _registerEvents() {
	        if (this.options.scrollTop) {
	          this._bindHandler = this._scrollTop.bind(this);
	          this.$element.on('open.zf.drilldown hide.zf.drilldown closed.zf.drilldown', this._bindHandler);
	        }
	        this.$element.on('mutateme.zf.trigger', this._resize.bind(this));
	      }
	
	      /**
	       * Scroll to Top of Element or data-scroll-top-element
	       * @function
	       * @fires Drilldown#scrollme
	       */
	
	    }, {
	      key: '_scrollTop',
	      value: function _scrollTop() {
	        var _this = this;
	        var $scrollTopElement = _this.options.scrollTopElement != '' ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this.options.scrollTopElement) : _this.$element,
	            scrollPos = parseInt($scrollTopElement.offset().top + _this.options.scrollTopOffset, 10);
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop(true).animate({ scrollTop: scrollPos }, _this.options.animationDuration, _this.options.animationEasing, function () {
	          /**
	            * Fires after the menu has scrolled
	            * @event Drilldown#scrollme
	            */
	          if (this === __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html')[0]) _this.$element.trigger('scrollme.zf.drilldown');
	        });
	      }
	
	      /**
	       * Adds keydown event listener to `li`'s in the menu.
	       * @private
	       */
	
	    }, {
	      key: '_keyboardEvents',
	      value: function _keyboardEvents() {
	        var _this = this;
	
	        this.$menuItems.add(this.$element.find('.js-drilldown-back > a, .is-submenu-parent-item > a')).on('keydown.zf.drilldown', function (e) {
	          var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $elements = $element.parent('li').parent('ul').children('li').children('a'),
	              $prevElement,
	              $nextElement;
	
	          $elements.each(function (i) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is($element)) {
	              $prevElement = $elements.eq(Math.max(0, i - 1));
	              $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
	              return;
	            }
	          });
	
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Drilldown', {
	            next: function next() {
	              if ($element.is(_this.$submenuAnchors)) {
	                _this._show($element.parent('li'));
	                $element.parent('li').one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($element), function () {
	                  $element.parent('li').find('ul li a').filter(_this.$menuItems).first().focus();
	                });
	                return true;
	              }
	            },
	            previous: function previous() {
	              _this._hide($element.parent('li').parent('ul'));
	              $element.parent('li').parent('ul').one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($element), function () {
	                setTimeout(function () {
	                  $element.parent('li').parent('ul').parent('li').children('a').first().focus();
	                }, 1);
	              });
	              return true;
	            },
	            up: function up() {
	              $prevElement.focus();
	              // Don't tap focus on first element in root ul
	              return !$element.is(_this.$element.find('> li:first-child > a'));
	            },
	            down: function down() {
	              $nextElement.focus();
	              // Don't tap focus on last element in root ul
	              return !$element.is(_this.$element.find('> li:last-child > a'));
	            },
	            close: function close() {
	              // Don't close on element in root ul
	              if (!$element.is(_this.$element.find('> li > a'))) {
	                _this._hide($element.parent().parent());
	                $element.parent().parent().siblings('a').focus();
	              }
	            },
	            open: function open() {
	              if (!$element.is(_this.$menuItems)) {
	                // not menu item means back button
	                _this._hide($element.parent('li').parent('ul'));
	                $element.parent('li').parent('ul').one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($element), function () {
	                  setTimeout(function () {
	                    $element.parent('li').parent('ul').parent('li').children('a').first().focus();
	                  }, 1);
	                });
	                return true;
	              } else if ($element.is(_this.$submenuAnchors)) {
	                _this._show($element.parent('li'));
	                $element.parent('li').one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($element), function () {
	                  $element.parent('li').find('ul li a').filter(_this.$menuItems).first().focus();
	                });
	                return true;
	              }
	            },
	            handled: function handled(preventDefault) {
	              if (preventDefault) {
	                e.preventDefault();
	              }
	              e.stopImmediatePropagation();
	            }
	          });
	        }); // end keyboardAccess
	      }
	
	      /**
	       * Closes all open elements, and returns to root menu.
	       * @function
	       * @fires Drilldown#closed
	       */
	
	    }, {
	      key: '_hideAll',
	      value: function _hideAll() {
	        var $elem = this.$element.find('.is-drilldown-submenu.is-active').addClass('is-closing');
	        if (this.options.autoHeight) this.$wrapper.css({ height: $elem.parent().closest('ul').data('calcHeight') });
	        $elem.one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($elem), function (e) {
	          $elem.removeClass('is-active is-closing');
	        });
	        /**
	         * Fires when the menu is fully closed.
	         * @event Drilldown#closed
	         */
	        this.$element.trigger('closed.zf.drilldown');
	      }
	
	      /**
	       * Adds event listener for each `back` button, and closes open menus.
	       * @function
	       * @fires Drilldown#back
	       * @param {jQuery} $elem - the current sub-menu to add `back` event.
	       */
	
	    }, {
	      key: '_back',
	      value: function _back($elem) {
	        var _this = this;
	        $elem.off('click.zf.drilldown');
	        $elem.children('.js-drilldown-back').on('click.zf.drilldown', function (e) {
	          e.stopImmediatePropagation();
	          // console.log('mouseup on back');
	          _this._hide($elem);
	
	          // If there is a parent submenu, call show
	          var parentSubMenu = $elem.parent('li').parent('ul').parent('li');
	          if (parentSubMenu.length) {
	            _this._show(parentSubMenu);
	          }
	        });
	      }
	
	      /**
	       * Adds event listener to menu items w/o submenus to close open menus on click.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_menuLinkEvents',
	      value: function _menuLinkEvents() {
	        var _this = this;
	        this.$menuItems.not('.is-drilldown-submenu-parent').off('click.zf.drilldown').on('click.zf.drilldown', function (e) {
	          // e.stopImmediatePropagation();
	          setTimeout(function () {
	            _this._hideAll();
	          }, 0);
	        });
	      }
	
	      /**
	       * Opens a submenu.
	       * @function
	       * @fires Drilldown#open
	       * @param {jQuery} $elem - the current element with a submenu to open, i.e. the `li` tag.
	       */
	
	    }, {
	      key: '_show',
	      value: function _show($elem) {
	        if (this.options.autoHeight) this.$wrapper.css({ height: $elem.children('[data-submenu]').data('calcHeight') });
	        $elem.attr('aria-expanded', true);
	        $elem.children('[data-submenu]').addClass('is-active').removeClass('invisible').attr('aria-hidden', false);
	        /**
	         * Fires when the submenu has opened.
	         * @event Drilldown#open
	         */
	        this.$element.trigger('open.zf.drilldown', [$elem]);
	      }
	    }, {
	      key: '_hide',
	
	      /**
	       * Hides a submenu
	       * @function
	       * @fires Drilldown#hide
	       * @param {jQuery} $elem - the current sub-menu to hide, i.e. the `ul` tag.
	       */
	      value: function _hide($elem) {
	        if (this.options.autoHeight) this.$wrapper.css({ height: $elem.parent().closest('ul').data('calcHeight') });
	        var _this = this;
	        $elem.parent('li').attr('aria-expanded', false);
	        $elem.attr('aria-hidden', true).addClass('is-closing');
	        $elem.addClass('is-closing').one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])($elem), function () {
	          $elem.removeClass('is-active is-closing');
	          $elem.blur().addClass('invisible');
	        });
	        /**
	         * Fires when the submenu has closed.
	         * @event Drilldown#hide
	         */
	        $elem.trigger('hide.zf.drilldown', [$elem]);
	      }
	
	      /**
	       * Iterates through the nested menus to calculate the min-height, and max-width for the menu.
	       * Prevents content jumping.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_getMaxDims',
	      value: function _getMaxDims() {
	        var maxHeight = 0,
	            result = {},
	            _this = this;
	        this.$submenus.add(this.$element).each(function () {
	          var numOfElems = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('li').length;
	          var height = __WEBPACK_IMPORTED_MODULE_4__foundation_util_box__["a" /* Box */].GetDimensions(this).height;
	          maxHeight = height > maxHeight ? height : maxHeight;
	          if (_this.options.autoHeight) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('calcHeight', height);
	            if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('is-drilldown-submenu')) result['height'] = height;
	          }
	        });
	
	        if (!this.options.autoHeight) result['min-height'] = maxHeight + 'px';
	
	        result['max-width'] = this.$element[0].getBoundingClientRect().width + 'px';
	
	        return result;
	      }
	
	      /**
	       * Destroys the Drilldown Menu
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        if (this.options.scrollTop) this.$element.off('.zf.drilldown', this._bindHandler);
	        this._hideAll();
	        this.$element.off('mutateme.zf.trigger');
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Burn(this.$element, 'drilldown');
	        this.$element.unwrap().find('.js-drilldown-back, .is-submenu-parent-item').remove().end().find('.is-active, .is-closing, .is-drilldown-submenu').removeClass('is-active is-closing is-drilldown-submenu').end().find('[data-submenu]').removeAttr('aria-hidden tabindex role');
	        this.$submenuAnchors.each(function () {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).off('.zf.drilldown');
	        });
	
	        this.$submenus.removeClass('drilldown-submenu-cover-previous invisible');
	
	        this.$element.find('a').each(function () {
	          var $link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	          $link.removeAttr('tabindex');
	          if ($link.data('savedHref')) {
	            $link.attr('href', $link.data('savedHref')).removeData('savedHref');
	          } else {
	            return;
	          }
	        });
	      }
	    }]);
	
	    return Drilldown;
	  }(__WEBPACK_IMPORTED_MODULE_5__foundation_plugin__["a" /* Plugin */]);
	
	  Drilldown.defaults = {
	    /**
	     * Drilldowns depend on styles in order to function properly; in the default build of Foundation these are
	     * on the `drilldown` class. This option auto-applies this class to the drilldown upon initialization.
	     * @option
	     * @type {boolian}
	     * @default true
	     */
	    autoApplyClass: true,
	    /**
	     * Markup used for JS generated back button. Prepended  or appended (see backButtonPosition) to submenu lists and deleted on `destroy` method, 'js-drilldown-back' class required. Remove the backslash (`\`) if copy and pasting.
	     * @option
	     * @type {string}
	     * @default '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>'
	     */
	    backButton: '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>',
	    /**
	     * Position the back button either at the top or bottom of drilldown submenus. Can be `'left'` or `'bottom'`.
	     * @option
	     * @type {string}
	     * @default top
	     */
	    backButtonPosition: 'top',
	    /**
	     * Markup used to wrap drilldown menu. Use a class name for independent styling; the JS applied class: `is-drilldown` is required. Remove the backslash (`\`) if copy and pasting.
	     * @option
	     * @type {string}
	     * @default '<div></div>'
	     */
	    wrapper: '<div></div>',
	    /**
	     * Adds the parent link to the submenu.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    parentLink: false,
	    /**
	     * Allow the menu to return to root list on body click.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    closeOnClick: false,
	    /**
	     * Allow the menu to auto adjust height.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    autoHeight: false,
	    /**
	     * Animate the auto adjust height.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    animateHeight: false,
	    /**
	     * Scroll to the top of the menu after opening a submenu or navigating back using the menu back button
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    scrollTop: false,
	    /**
	     * String jquery selector (for example 'body') of element to take offset().top from, if empty string the drilldown menu offset().top is taken
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    scrollTopElement: '',
	    /**
	     * ScrollTop offset
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    scrollTopOffset: 0,
	    /**
	     * Scroll animation duration
	     * @option
	     * @type {number}
	     * @default 500
	     */
	    animationDuration: 500,
	    /**
	     * Scroll animation easing. Can be `'swing'` or `'linear'`.
	     * @option
	     * @type {string}
	     * @see {@link https://api.jquery.com/animate|JQuery animate}
	     * @default 'swing'
	     */
	    animationEasing: 'swing'
	    // holdOpen: false
	  };
	
	  /***/
	},
	/* 14 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return DropdownMenu;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__ = __webpack_require__(9);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_box__ = __webpack_require__(7);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * DropdownMenu module.
	   * @module foundation.dropdown-menu
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.box
	   * @requires foundation.util.nest
	   */
	
	  var DropdownMenu = function (_Plugin) {
	    _inherits(DropdownMenu, _Plugin);
	
	    function DropdownMenu() {
	      _classCallCheck(this, DropdownMenu);
	
	      return _possibleConstructorReturn(this, (DropdownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropdownMenu)).apply(this, arguments));
	    }
	
	    _createClass(DropdownMenu, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of DropdownMenu.
	       * @class
	       * @name DropdownMenu
	       * @fires DropdownMenu#init
	       * @param {jQuery} element - jQuery object to make into a dropdown menu.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DropdownMenu.defaults, this.$element.data(), options);
	        this.className = 'DropdownMenu'; // ie9 back compat
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('DropdownMenu', {
	          'ENTER': 'open',
	          'SPACE': 'open',
	          'ARROW_RIGHT': 'next',
	          'ARROW_UP': 'up',
	          'ARROW_DOWN': 'down',
	          'ARROW_LEFT': 'previous',
	          'ESCAPE': 'close'
	        });
	      }
	
	      /**
	       * Initializes the plugin, and calls _prepareMenu
	       * @private
	       * @function
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Feather(this.$element, 'dropdown');
	
	        var subs = this.$element.find('li.is-dropdown-submenu-parent');
	        this.$element.children('.is-dropdown-submenu-parent').children('.is-dropdown-submenu').addClass('first-sub');
	
	        this.$menuItems = this.$element.find('[role="menuitem"]');
	        this.$tabs = this.$element.children('[role="menuitem"]');
	        this.$tabs.find('ul.is-dropdown-submenu').addClass(this.options.verticalClass);
	
	        if (this.options.alignment === 'auto') {
	          if (this.$element.hasClass(this.options.rightClass) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__foundation_util_core__["a" /* rtl */])() || this.$element.parents('.top-bar-right').is('*')) {
	            this.options.alignment = 'right';
	            subs.addClass('opens-left');
	          } else {
	            this.options.alignment = 'left';
	            subs.addClass('opens-right');
	          }
	        } else {
	          if (this.options.alignment === 'right') {
	            subs.addClass('opens-left');
	          } else {
	            subs.addClass('opens-right');
	          }
	        }
	        this.changed = false;
	        this._events();
	      }
	    }, {
	      key: '_isVertical',
	      value: function _isVertical() {
	        return this.$tabs.css('display') === 'block' || this.$element.css('flex-direction') === 'column';
	      }
	    }, {
	      key: '_isRtl',
	      value: function _isRtl() {
	        return this.$element.hasClass('align-right') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__foundation_util_core__["a" /* rtl */])() && !this.$element.hasClass('align-left');
	      }
	
	      /**
	       * Adds event listeners to elements within the menu
	       * @private
	       * @function
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this,
	            hasTouch = 'ontouchstart' in window || typeof window.ontouchstart !== 'undefined',
	            parClass = 'is-dropdown-submenu-parent';
	
	        // used for onClick and in the keyboard handlers
	        var handleClickFn = function handleClickFn(e) {
	          var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parentsUntil('ul', '.' + parClass),
	              hasSub = $elem.hasClass(parClass),
	              hasClicked = $elem.attr('data-is-click') === 'true',
	              $sub = $elem.children('.is-dropdown-submenu');
	
	          if (hasSub) {
	            if (hasClicked) {
	              if (!_this.options.closeOnClick || !_this.options.clickOpen && !hasTouch || _this.options.forceFollow && hasTouch) {
	                return;
	              } else {
	                e.stopImmediatePropagation();
	                e.preventDefault();
	                _this._hide($elem);
	              }
	            } else {
	              e.preventDefault();
	              e.stopImmediatePropagation();
	              _this._show($sub);
	              $elem.add($elem.parentsUntil(_this.$element, '.' + parClass)).attr('data-is-click', true);
	            }
	          }
	        };
	
	        if (this.options.clickOpen || hasTouch) {
	          this.$menuItems.on('click.zf.dropdownmenu touchstart.zf.dropdownmenu', handleClickFn);
	        }
	
	        // Handle Leaf element Clicks
	        if (_this.options.closeOnClickInside) {
	          this.$menuItems.on('click.zf.dropdownmenu', function (e) {
	            var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	                hasSub = $elem.hasClass(parClass);
	            if (!hasSub) {
	              _this._hide();
	            }
	          });
	        }
	
	        if (!this.options.disableHover) {
	          this.$menuItems.on('mouseenter.zf.dropdownmenu', function (e) {
	            var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	                hasSub = $elem.hasClass(parClass);
	
	            if (hasSub) {
	              clearTimeout($elem.data('_delay'));
	              $elem.data('_delay', setTimeout(function () {
	                _this._show($elem.children('.is-dropdown-submenu'));
	              }, _this.options.hoverDelay));
	            }
	          }).on('mouseleave.zf.dropdownmenu', function (e) {
	            var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	                hasSub = $elem.hasClass(parClass);
	            if (hasSub && _this.options.autoclose) {
	              if ($elem.attr('data-is-click') === 'true' && _this.options.clickOpen) {
	                return false;
	              }
	
	              clearTimeout($elem.data('_delay'));
	              $elem.data('_delay', setTimeout(function () {
	                _this._hide($elem);
	              }, _this.options.closingTime));
	            }
	          });
	        }
	        this.$menuItems.on('keydown.zf.dropdownmenu', function (e) {
	          var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parentsUntil('ul', '[role="menuitem"]'),
	              isTab = _this.$tabs.index($element) > -1,
	              $elements = isTab ? _this.$tabs : $element.siblings('li').add($element),
	              $prevElement,
	              $nextElement;
	
	          $elements.each(function (i) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is($element)) {
	              $prevElement = $elements.eq(i - 1);
	              $nextElement = $elements.eq(i + 1);
	              return;
	            }
	          });
	
	          var nextSibling = function nextSibling() {
	            $nextElement.children('a:first').focus();
	            e.preventDefault();
	          },
	              prevSibling = function prevSibling() {
	            $prevElement.children('a:first').focus();
	            e.preventDefault();
	          },
	              openSub = function openSub() {
	            var $sub = $element.children('ul.is-dropdown-submenu');
	            if ($sub.length) {
	              _this._show($sub);
	              $element.find('li > a:first').focus();
	              e.preventDefault();
	            } else {
	              return;
	            }
	          },
	              closeSub = function closeSub() {
	            //if ($element.is(':first-child')) {
	            var close = $element.parent('ul').parent('li');
	            close.children('a:first').focus();
	            _this._hide(close);
	            e.preventDefault();
	            //}
	          };
	          var functions = {
	            open: openSub,
	            close: function close() {
	              _this._hide(_this.$element);
	              _this.$menuItems.eq(0).children('a').focus(); // focus to first element
	              e.preventDefault();
	            },
	            handled: function handled() {
	              e.stopImmediatePropagation();
	            }
	          };
	
	          if (isTab) {
	            if (_this._isVertical()) {
	              // vertical menu
	              if (_this._isRtl()) {
	                // right aligned
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                  down: nextSibling,
	                  up: prevSibling,
	                  next: closeSub,
	                  previous: openSub
	                });
	              } else {
	                // left aligned
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                  down: nextSibling,
	                  up: prevSibling,
	                  next: openSub,
	                  previous: closeSub
	                });
	              }
	            } else {
	              // horizontal menu
	              if (_this._isRtl()) {
	                // right aligned
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                  next: prevSibling,
	                  previous: nextSibling,
	                  down: openSub,
	                  up: closeSub
	                });
	              } else {
	                // left aligned
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                  next: nextSibling,
	                  previous: prevSibling,
	                  down: openSub,
	                  up: closeSub
	                });
	              }
	            }
	          } else {
	            // not tabs -> one sub
	            if (_this._isRtl()) {
	              // right aligned
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                next: closeSub,
	                previous: openSub,
	                down: nextSibling,
	                up: prevSibling
	              });
	            } else {
	              // left aligned
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(functions, {
	                next: openSub,
	                previous: closeSub,
	                down: nextSibling,
	                up: prevSibling
	              });
	            }
	          }
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'DropdownMenu', functions);
	        });
	      }
	
	      /**
	       * Adds an event handler to the body to close any dropdowns on a click.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_addBodyHandler',
	      value: function _addBodyHandler() {
	        var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body),
	            _this = this;
	        $body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu').on('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu', function (e) {
	          var $link = _this.$element.find(e.target);
	          if ($link.length) {
	            return;
	          }
	
	          _this._hide();
	          $body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu');
	        });
	      }
	
	      /**
	       * Opens a dropdown pane, and checks for collisions first.
	       * @param {jQuery} $sub - ul element that is a submenu to show
	       * @function
	       * @private
	       * @fires DropdownMenu#show
	       */
	
	    }, {
	      key: '_show',
	      value: function _show($sub) {
	        var idx = this.$tabs.index(this.$tabs.filter(function (i, el) {
	          return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find($sub).length > 0;
	        }));
	        var $sibs = $sub.parent('li.is-dropdown-submenu-parent').siblings('li.is-dropdown-submenu-parent');
	        this._hide($sibs, idx);
	        $sub.css('visibility', 'hidden').addClass('js-dropdown-active').parent('li.is-dropdown-submenu-parent').addClass('is-active');
	        var clear = __WEBPACK_IMPORTED_MODULE_3__foundation_util_box__["a" /* Box */].ImNotTouchingYou($sub, null, true);
	        if (!clear) {
	          var oldClass = this.options.alignment === 'left' ? '-right' : '-left',
	              $parentLi = $sub.parent('.is-dropdown-submenu-parent');
	          $parentLi.removeClass('opens' + oldClass).addClass('opens-' + this.options.alignment);
	          clear = __WEBPACK_IMPORTED_MODULE_3__foundation_util_box__["a" /* Box */].ImNotTouchingYou($sub, null, true);
	          if (!clear) {
	            $parentLi.removeClass('opens-' + this.options.alignment).addClass('opens-inner');
	          }
	          this.changed = true;
	        }
	        $sub.css('visibility', '');
	        if (this.options.closeOnClick) {
	          this._addBodyHandler();
	        }
	        /**
	         * Fires when the new dropdown pane is visible.
	         * @event DropdownMenu#show
	         */
	        this.$element.trigger('show.zf.dropdownmenu', [$sub]);
	      }
	
	      /**
	       * Hides a single, currently open dropdown pane, if passed a parameter, otherwise, hides everything.
	       * @function
	       * @param {jQuery} $elem - element with a submenu to hide
	       * @param {Number} idx - index of the $tabs collection to hide
	       * @private
	       */
	
	    }, {
	      key: '_hide',
	      value: function _hide($elem, idx) {
	        var $toClose;
	        if ($elem && $elem.length) {
	          $toClose = $elem;
	        } else if (idx !== undefined) {
	          $toClose = this.$tabs.not(function (i, el) {
	            return i === idx;
	          });
	        } else {
	          $toClose = this.$element;
	        }
	        var somethingToClose = $toClose.hasClass('is-active') || $toClose.find('.is-active').length > 0;
	
	        if (somethingToClose) {
	          $toClose.find('li.is-active').add($toClose).attr({
	            'data-is-click': false
	          }).removeClass('is-active');
	
	          $toClose.find('ul.js-dropdown-active').removeClass('js-dropdown-active');
	
	          if (this.changed || $toClose.find('opens-inner').length) {
	            var oldClass = this.options.alignment === 'left' ? 'right' : 'left';
	            $toClose.find('li.is-dropdown-submenu-parent').add($toClose).removeClass('opens-inner opens-' + this.options.alignment).addClass('opens-' + oldClass);
	            this.changed = false;
	          }
	          /**
	           * Fires when the open menus are closed.
	           * @event DropdownMenu#hide
	           */
	          this.$element.trigger('hide.zf.dropdownmenu', [$toClose]);
	        }
	      }
	
	      /**
	       * Destroys the plugin.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$menuItems.off('.zf.dropdownmenu').removeAttr('data-is-click').removeClass('is-right-arrow is-left-arrow is-down-arrow opens-right opens-left opens-inner');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).off('.zf.dropdownmenu');
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_nest__["a" /* Nest */].Burn(this.$element, 'dropdown');
	      }
	    }]);
	
	    return DropdownMenu;
	  }(__WEBPACK_IMPORTED_MODULE_5__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin
	   */
	
	  DropdownMenu.defaults = {
	    /**
	     * Disallows hover events from opening submenus
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    disableHover: false,
	    /**
	     * Allow a submenu to automatically close on a mouseleave event, if not clicked open.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    autoclose: true,
	    /**
	     * Amount of time to delay opening a submenu on hover event.
	     * @option
	     * @type {number}
	     * @default 50
	     */
	    hoverDelay: 50,
	    /**
	     * Allow a submenu to open/remain open on parent click event. Allows cursor to move away from menu.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    clickOpen: false,
	    /**
	     * Amount of time to delay closing a submenu on a mouseleave event.
	     * @option
	     * @type {number}
	     * @default 500
	     */
	
	    closingTime: 500,
	    /**
	     * Position of the menu relative to what direction the submenus should open. Handled by JS. Can be `'auto'`, `'left'` or `'right'`.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    alignment: 'auto',
	    /**
	     * Allow clicks on the body to close any open submenus.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnClick: true,
	    /**
	     * Allow clicks on leaf anchor links to close any open submenus.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnClickInside: true,
	    /**
	     * Class applied to vertical oriented menus, Foundation default is `vertical`. Update this if using your own class.
	     * @option
	     * @type {string}
	     * @default 'vertical'
	     */
	    verticalClass: 'vertical',
	    /**
	     * Class applied to right-side oriented menus, Foundation default is `align-right`. Update this if using your own class.
	     * @option
	     * @type {string}
	     * @default 'align-right'
	     */
	    rightClass: 'align-right',
	    /**
	     * Boolean to force overide the clicking of links to perform default action, on second touch event for mobile.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    forceFollow: true
	  };
	
	  /***/
	},
	/* 15 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Positionable;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__foundation_util_box__ = __webpack_require__(7);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var POSITIONS = ['left', 'right', 'top', 'bottom'];
	  var VERTICAL_ALIGNMENTS = ['top', 'bottom', 'center'];
	  var HORIZONTAL_ALIGNMENTS = ['left', 'right', 'center'];
	
	  var ALIGNMENTS = {
	    'left': VERTICAL_ALIGNMENTS,
	    'right': VERTICAL_ALIGNMENTS,
	    'top': HORIZONTAL_ALIGNMENTS,
	    'bottom': HORIZONTAL_ALIGNMENTS
	  };
	
	  function nextItem(item, array) {
	    var currentIdx = array.indexOf(item);
	    if (currentIdx === array.length - 1) {
	      return array[0];
	    } else {
	      return array[currentIdx + 1];
	    }
	  }
	
	  var Positionable = function (_Plugin) {
	    _inherits(Positionable, _Plugin);
	
	    function Positionable() {
	      _classCallCheck(this, Positionable);
	
	      return _possibleConstructorReturn(this, (Positionable.__proto__ || (0, _getPrototypeOf2.default)(Positionable)).apply(this, arguments));
	    }
	
	    _createClass(Positionable, [{
	      key: '_init',
	
	      /**
	       * Abstract class encapsulating the tether-like explicit positioning logic
	       * including repositioning based on overlap.
	       * Expects classes to define defaults for vOffset, hOffset, position,
	       * alignment, allowOverlap, and allowBottomOverlap. They can do this by
	       * extending the defaults, or (for now recommended due to the way docs are
	       * generated) by explicitly declaring them.
	       *
	       **/
	
	      value: function _init() {
	        this.triedPositions = {};
	        this.position = this.options.position === 'auto' ? this._getDefaultPosition() : this.options.position;
	        this.alignment = this.options.alignment === 'auto' ? this._getDefaultAlignment() : this.options.alignment;
	      }
	    }, {
	      key: '_getDefaultPosition',
	      value: function _getDefaultPosition() {
	        return 'bottom';
	      }
	    }, {
	      key: '_getDefaultAlignment',
	      value: function _getDefaultAlignment() {
	        switch (this.position) {
	          case 'bottom':
	          case 'top':
	            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["a" /* rtl */])() ? 'right' : 'left';
	          case 'left':
	          case 'right':
	            return 'bottom';
	        }
	      }
	
	      /**
	       * Adjusts the positionable possible positions by iterating through alignments
	       * and positions.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_reposition',
	      value: function _reposition() {
	        if (this._alignmentsExhausted(this.position)) {
	          this.position = nextItem(this.position, POSITIONS);
	          this.alignment = ALIGNMENTS[this.position][0];
	        } else {
	          this._realign();
	        }
	      }
	
	      /**
	       * Adjusts the dropdown pane possible positions by iterating through alignments
	       * on the current position.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_realign',
	      value: function _realign() {
	        this._addTriedPosition(this.position, this.alignment);
	        this.alignment = nextItem(this.alignment, ALIGNMENTS[this.position]);
	      }
	    }, {
	      key: '_addTriedPosition',
	      value: function _addTriedPosition(position, alignment) {
	        this.triedPositions[position] = this.triedPositions[position] || [];
	        this.triedPositions[position].push(alignment);
	      }
	    }, {
	      key: '_positionsExhausted',
	      value: function _positionsExhausted() {
	        var isExhausted = true;
	        for (var i = 0; i < POSITIONS.length; i++) {
	          isExhausted = isExhausted && this._alignmentsExhausted(POSITIONS[i]);
	        }
	        return isExhausted;
	      }
	    }, {
	      key: '_alignmentsExhausted',
	      value: function _alignmentsExhausted(position) {
	        return this.triedPositions[position] && this.triedPositions[position].length == ALIGNMENTS[position].length;
	      }
	
	      // When we're trying to center, we don't want to apply offset that's going to
	      // take us just off center, so wrap around to return 0 for the appropriate
	      // offset in those alignments.  TODO: Figure out if we want to make this
	      // configurable behavior... it feels more intuitive, especially for tooltips, but
	      // it's possible someone might actually want to start from center and then nudge
	      // slightly off.
	
	    }, {
	      key: '_getVOffset',
	      value: function _getVOffset() {
	        return this.options.vOffset;
	      }
	    }, {
	      key: '_getHOffset',
	      value: function _getHOffset() {
	        return this.options.hOffset;
	      }
	    }, {
	      key: '_setPosition',
	      value: function _setPosition($anchor, $element, $parent) {
	        if ($anchor.attr('aria-expanded') === 'false') {
	          return false;
	        }
	        var $eleDims = __WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].GetDimensions($element),
	            $anchorDims = __WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].GetDimensions($anchor);
	
	        $element.offset(__WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
	
	        if (!this.options.allowOverlap) {
	          var overlaps = {};
	          var minOverlap = 100000000;
	          // default coordinates to how we start, in case we can't figure out better
	          var minCoordinates = { position: this.position, alignment: this.alignment };
	          while (!this._positionsExhausted()) {
	            var overlap = __WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].OverlapArea($element, $parent, false, false, this.options.allowBottomOverlap);
	            if (overlap === 0) {
	              return;
	            }
	
	            if (overlap < minOverlap) {
	              minOverlap = overlap;
	              minCoordinates = { position: this.position, alignment: this.alignment };
	            }
	
	            this._reposition();
	
	            $element.offset(__WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
	          }
	          // If we get through the entire loop, there was no non-overlapping
	          // position available. Pick the version with least overlap.
	          this.position = minCoordinates.position;
	          this.alignment = minCoordinates.alignment;
	          $element.offset(__WEBPACK_IMPORTED_MODULE_0__foundation_util_box__["a" /* Box */].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
	        }
	      }
	    }]);
	
	    return Positionable;
	  }(__WEBPACK_IMPORTED_MODULE_1__foundation_plugin__["a" /* Plugin */]);
	
	  Positionable.defaults = {
	    /**
	     * Position of positionable relative to anchor. Can be left, right, bottom, top, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    position: 'auto',
	    /**
	     * Alignment of positionable relative to anchor. Can be left, right, bottom, top, center, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    alignment: 'auto',
	    /**
	     * Allow overlap of container/window. If false, dropdown positionable first
	     * try to position as defined by data-position and data-alignment, but
	     * reposition if it would cause an overflow.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    allowOverlap: false,
	    /**
	     * Allow overlap of only the bottom of the container. This is the most common
	     * behavior for dropdowns, allowing the dropdown to extend the bottom of the
	     * screen but not otherwise influence or break out of the container.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    allowBottomOverlap: true,
	    /**
	     * Number of pixels the positionable should be separated vertically from anchor
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    vOffset: 0,
	    /**
	     * Number of pixels the positionable should be separated horizontally from anchor
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    hOffset: 0
	  };
	
	  /***/
	},
	/* 16 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return SmoothScroll;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * SmoothScroll module.
	   * @module foundation.smooth-scroll
	   */
	
	  var SmoothScroll = function (_Plugin) {
	    _inherits(SmoothScroll, _Plugin);
	
	    function SmoothScroll() {
	      _classCallCheck(this, SmoothScroll);
	
	      return _possibleConstructorReturn(this, (SmoothScroll.__proto__ || (0, _getPrototypeOf2.default)(SmoothScroll)).apply(this, arguments));
	    }
	
	    _createClass(SmoothScroll, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of SmoothScroll.
	       * @class
	       * @name SmoothScroll
	       * @fires SmoothScroll#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, SmoothScroll.defaults, this.$element.data(), options);
	        this.className = 'SmoothScroll'; // ie9 back compat
	
	        this._init();
	      }
	
	      /**
	       * Initialize the SmoothScroll plugin
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var id = this.$element[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, 'smooth-scroll');
	        var _this = this;
	        this.$element.attr({
	          'id': id
	        });
	
	        this._events();
	      }
	
	      /**
	       * Initializes events for SmoothScroll.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        // click handler function.
	        var handleLinkClick = function handleLinkClick(e) {
	          // exit function if the event source isn't coming from an anchor with href attribute starts with '#'
	          if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is('a[href^="#"]')) {
	            return false;
	          }
	
	          var arrival = this.getAttribute('href');
	
	          _this._inTransition = true;
	
	          SmoothScroll.scrollToLoc(arrival, _this.options, function () {
	            _this._inTransition = false;
	          });
	
	          e.preventDefault();
	        };
	
	        this.$element.on('click.zf.smoothScroll', handleLinkClick);
	        this.$element.on('click.zf.smoothScroll', 'a[href^="#"]', handleLinkClick);
	      }
	
	      /**
	       * Function to scroll to a given location on the page.
	       * @param {String} loc - A properly formatted jQuery id selector. Example: '#foo'
	       * @param {Object} options - The options to use.
	       * @param {Function} callback - The callback function.
	       * @static
	       * @function
	       */
	
	    }], [{
	      key: 'scrollToLoc',
	      value: function scrollToLoc(loc) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SmoothScroll.defaults;
	        var callback = arguments[2];
	
	        // Do nothing if target does not exist to prevent errors
	        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(loc).length) {
	          return false;
	        }
	
	        var scrollPos = Math.round(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(loc).offset().top - options.threshold / 2 - options.offset);
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop(true).animate({ scrollTop: scrollPos }, options.animationDuration, options.animationEasing, function () {
	          if (callback && typeof callback == "function") {
	            callback();
	          }
	        });
	      }
	    }]);
	
	    return SmoothScroll;
	  }(__WEBPACK_IMPORTED_MODULE_2__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin.
	   */
	
	  SmoothScroll.defaults = {
	    /**
	     * Amount of time, in ms, the animated scrolling should take between locations.
	     * @option
	     * @type {number}
	     * @default 500
	     */
	    animationDuration: 500,
	    /**
	     * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
	     * @option
	     * @type {string}
	     * @default 'linear'
	     * @see {@link https://api.jquery.com/animate|Jquery animate}
	     */
	    animationEasing: 'linear',
	    /**
	     * Number of pixels to use as a marker for location changes.
	     * @option
	     * @type {number}
	     * @default 50
	     */
	    threshold: 50,
	    /**
	     * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    offset: 0
	  };
	
	  /***/
	},
	/* 17 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Tabs;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_imageLoader__ = __webpack_require__(8);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Tabs module.
	   * @module foundation.tabs
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.imageLoader if tabs contain images
	   */
	
	  var Tabs = function (_Plugin) {
	    _inherits(Tabs, _Plugin);
	
	    function Tabs() {
	      _classCallCheck(this, Tabs);
	
	      return _possibleConstructorReturn(this, (Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).apply(this, arguments));
	    }
	
	    _createClass(Tabs, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of tabs.
	       * @class
	       * @name Tabs
	       * @fires Tabs#init
	       * @param {jQuery} element - jQuery object to make into tabs.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Tabs.defaults, this.$element.data(), options);
	        this.className = 'Tabs'; // ie9 back compat
	
	        this._init();
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Tabs', {
	          'ENTER': 'open',
	          'SPACE': 'open',
	          'ARROW_RIGHT': 'next',
	          'ARROW_UP': 'previous',
	          'ARROW_DOWN': 'next',
	          'ARROW_LEFT': 'previous'
	          // 'TAB': 'next',
	          // 'SHIFT_TAB': 'previous'
	        });
	      }
	
	      /**
	       * Initializes the tabs by showing and focusing (if autoFocus=true) the preset active tab.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var _this3 = this;
	
	        var _this = this;
	
	        this.$element.attr({ 'role': 'tablist' });
	        this.$tabTitles = this.$element.find('.' + this.options.linkClass);
	        this.$tabContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-tabs-content="' + this.$element[0].id + '"]');
	
	        this.$tabTitles.each(function () {
	          var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $link = $elem.find('a'),
	              isActive = $elem.hasClass('' + _this.options.linkActiveClass),
	              hash = $link.attr('data-tabs-target') || $link[0].hash.slice(1),
	              linkId = $link[0].id ? $link[0].id : hash + '-label',
	              $tabContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + hash);
	
	          $elem.attr({ 'role': 'presentation' });
	
	          $link.attr({
	            'role': 'tab',
	            'aria-controls': hash,
	            'aria-selected': isActive,
	            'id': linkId,
	            'tabindex': isActive ? '0' : '-1'
	          });
	
	          $tabContent.attr({
	            'role': 'tabpanel',
	            'aria-labelledby': linkId
	          });
	
	          if (!isActive) {
	            $tabContent.attr('aria-hidden', 'true');
	          }
	
	          if (isActive && _this.options.autoFocus) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).load(function () {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({ scrollTop: $elem.offset().top }, _this.options.deepLinkSmudgeDelay, function () {
	                $link.focus();
	              });
	            });
	          }
	        });
	        if (this.options.matchHeight) {
	          var $images = this.$tabContent.find('img');
	
	          if ($images.length) {
	            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_imageLoader__["a" /* onImagesLoaded */])($images, this._setHeight.bind(this));
	          } else {
	            this._setHeight();
	          }
	        }
	
	        //current context-bound function to open tabs on page load or history popstate
	        this._checkDeepLink = function () {
	          var anchor = window.location.hash;
	          //need a hash and a relevant anchor in this tabset
	          if (anchor.length) {
	            var $link = _this3.$element.find('[href$="' + anchor + '"]');
	            if ($link.length) {
	              _this3.selectTab(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(anchor), true);
	
	              //roll up a little to show the titles
	              if (_this3.options.deepLinkSmudge) {
	                var offset = _this3.$element.offset();
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({ scrollTop: offset.top }, _this3.options.deepLinkSmudgeDelay);
	              }
	
	              /**
	                * Fires when the zplugin has deeplinked at pageload
	                * @event Tabs#deeplink
	                */
	              _this3.$element.trigger('deeplink.zf.tabs', [$link, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(anchor)]);
	            }
	          }
	        };
	
	        //use browser to open a tab, if it exists in this tabset
	        if (this.options.deepLink) {
	          this._checkDeepLink();
	        }
	
	        this._events();
	      }
	
	      /**
	       * Adds event handlers for items within the tabs.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        this._addKeyHandler();
	        this._addClickHandler();
	        this._setHeightMqHandler = null;
	
	        if (this.options.matchHeight) {
	          this._setHeightMqHandler = this._setHeight.bind(this);
	
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', this._setHeightMqHandler);
	        }
	
	        if (this.options.deepLink) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('popstate', this._checkDeepLink);
	        }
	      }
	
	      /**
	       * Adds click handlers for items within the tabs.
	       * @private
	       */
	
	    }, {
	      key: '_addClickHandler',
	      value: function _addClickHandler() {
	        var _this = this;
	
	        this.$element.off('click.zf.tabs').on('click.zf.tabs', '.' + this.options.linkClass, function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	          _this._handleTabChange(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	        });
	      }
	
	      /**
	       * Adds keyboard event handlers for items within the tabs.
	       * @private
	       */
	
	    }, {
	      key: '_addKeyHandler',
	      value: function _addKeyHandler() {
	        var _this = this;
	
	        this.$tabTitles.off('keydown.zf.tabs').on('keydown.zf.tabs', function (e) {
	          if (e.which === 9) return;
	
	          var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              $elements = $element.parent('ul').children('li'),
	              $prevElement,
	              $nextElement;
	
	          $elements.each(function (i) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is($element)) {
	              if (_this.options.wrapOnKeys) {
	                $prevElement = i === 0 ? $elements.last() : $elements.eq(i - 1);
	                $nextElement = i === $elements.length - 1 ? $elements.first() : $elements.eq(i + 1);
	              } else {
	                $prevElement = $elements.eq(Math.max(0, i - 1));
	                $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
	              }
	              return;
	            }
	          });
	
	          // handle keyboard event with keyboard util
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Tabs', {
	            open: function open() {
	              $element.find('[role="tab"]').focus();
	              _this._handleTabChange($element);
	            },
	            previous: function previous() {
	              $prevElement.find('[role="tab"]').focus();
	              _this._handleTabChange($prevElement);
	            },
	            next: function next() {
	              $nextElement.find('[role="tab"]').focus();
	              _this._handleTabChange($nextElement);
	            },
	            handled: function handled() {
	              e.stopPropagation();
	              e.preventDefault();
	            }
	          });
	        });
	      }
	
	      /**
	       * Opens the tab `$targetContent` defined by `$target`. Collapses active tab.
	       * @param {jQuery} $target - Tab to open.
	       * @param {boolean} historyHandled - browser has already handled a history update
	       * @fires Tabs#change
	       * @function
	       */
	
	    }, {
	      key: '_handleTabChange',
	      value: function _handleTabChange($target, historyHandled) {
	
	        /**
	         * Check for active class on target. Collapse if exists.
	         */
	        if ($target.hasClass('' + this.options.linkActiveClass)) {
	          if (this.options.activeCollapse) {
	            this._collapseTab($target);
	
	            /**
	             * Fires when the zplugin has successfully collapsed tabs.
	             * @event Tabs#collapse
	             */
	            this.$element.trigger('collapse.zf.tabs', [$target]);
	          }
	          return;
	        }
	
	        var $oldTab = this.$element.find('.' + this.options.linkClass + '.' + this.options.linkActiveClass),
	            $tabLink = $target.find('[role="tab"]'),
	            hash = $tabLink.attr('data-tabs-target') || $tabLink[0].hash.slice(1),
	            $targetContent = this.$tabContent.find('#' + hash);
	
	        //close old tab
	        this._collapseTab($oldTab);
	
	        //open new tab
	        this._openTab($target);
	
	        //either replace or update browser history
	        if (this.options.deepLink && !historyHandled) {
	          var anchor = $target.find('a').attr('href');
	
	          if (this.options.updateHistory) {
	            history.pushState({}, '', anchor);
	          } else {
	            history.replaceState({}, '', anchor);
	          }
	        }
	
	        /**
	         * Fires when the plugin has successfully changed tabs.
	         * @event Tabs#change
	         */
	        this.$element.trigger('change.zf.tabs', [$target, $targetContent]);
	
	        //fire to children a mutation event
	        $targetContent.find("[data-mutate]").trigger("mutateme.zf.trigger");
	      }
	
	      /**
	       * Opens the tab `$targetContent` defined by `$target`.
	       * @param {jQuery} $target - Tab to Open.
	       * @function
	       */
	
	    }, {
	      key: '_openTab',
	      value: function _openTab($target) {
	        var $tabLink = $target.find('[role="tab"]'),
	            hash = $tabLink.attr('data-tabs-target') || $tabLink[0].hash.slice(1),
	            $targetContent = this.$tabContent.find('#' + hash);
	
	        $target.addClass('' + this.options.linkActiveClass);
	
	        $tabLink.attr({
	          'aria-selected': 'true',
	          'tabindex': '0'
	        });
	
	        $targetContent.addClass('' + this.options.panelActiveClass).removeAttr('aria-hidden');
	      }
	
	      /**
	       * Collapses `$targetContent` defined by `$target`.
	       * @param {jQuery} $target - Tab to Open.
	       * @function
	       */
	
	    }, {
	      key: '_collapseTab',
	      value: function _collapseTab($target) {
	        var $target_anchor = $target.removeClass('' + this.options.linkActiveClass).find('[role="tab"]').attr({
	          'aria-selected': 'false',
	          'tabindex': -1
	        });
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + $target_anchor.attr('aria-controls')).removeClass('' + this.options.panelActiveClass).attr({ 'aria-hidden': 'true' });
	      }
	
	      /**
	       * Public method for selecting a content pane to display.
	       * @param {jQuery | String} elem - jQuery object or string of the id of the pane to display.
	       * @param {boolean} historyHandled - browser has already handled a history update
	       * @function
	       */
	
	    }, {
	      key: 'selectTab',
	      value: function selectTab(elem, historyHandled) {
	        var idStr;
	
	        if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
	          idStr = elem[0].id;
	        } else {
	          idStr = elem;
	        }
	
	        if (idStr.indexOf('#') < 0) {
	          idStr = '#' + idStr;
	        }
	
	        var $target = this.$tabTitles.find('[href$="' + idStr + '"]').parent('.' + this.options.linkClass);
	
	        this._handleTabChange($target, historyHandled);
	      }
	    }, {
	      key: '_setHeight',
	
	      /**
	       * Sets the height of each panel to the height of the tallest panel.
	       * If enabled in options, gets called on media query change.
	       * If loading content via external source, can be called directly or with _reflow.
	       * If enabled with `data-match-height="true"`, tabs sets to equal height
	       * @function
	       * @private
	       */
	      value: function _setHeight() {
	        var max = 0,
	            _this = this; // Lock down the `this` value for the root tabs object
	
	        this.$tabContent.find('.' + this.options.panelClass).css('height', '').each(function () {
	
	          var panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              isActive = panel.hasClass('' + _this.options.panelActiveClass); // get the options from the parent instead of trying to get them from the child
	
	          if (!isActive) {
	            panel.css({ 'visibility': 'hidden', 'display': 'block' });
	          }
	
	          var temp = this.getBoundingClientRect().height;
	
	          if (!isActive) {
	            panel.css({
	              'visibility': '',
	              'display': ''
	            });
	          }
	
	          max = temp > max ? temp : max;
	        }).css('height', max + 'px');
	      }
	
	      /**
	       * Destroys an instance of an tabs.
	       * @fires Tabs#destroyed
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.find('.' + this.options.linkClass).off('.zf.tabs').hide().end().find('.' + this.options.panelClass).hide();
	
	        if (this.options.matchHeight) {
	          if (this._setHeightMqHandler != null) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('changed.zf.mediaquery', this._setHeightMqHandler);
	          }
	        }
	
	        if (this.options.deepLink) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('popstate', this._checkDeepLink);
	        }
	      }
	    }]);
	
	    return Tabs;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  Tabs.defaults = {
	    /**
	     * Allows the window to scroll to content of pane specified by hash anchor
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLink: false,
	
	    /**
	     * Adjust the deep link scroll to make sure the top of the tab panel is visible
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLinkSmudge: false,
	
	    /**
	     * Animation time (ms) for the deep link adjustment
	     * @option
	     * @type {number}
	     * @default 300
	     */
	    deepLinkSmudgeDelay: 300,
	
	    /**
	     * Update the browser history with the open tab
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    updateHistory: false,
	
	    /**
	     * Allows the window to scroll to content of active pane on load if set to true.
	     * Not recommended if more than one tab panel per page.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    autoFocus: false,
	
	    /**
	     * Allows keyboard input to 'wrap' around the tab links.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    wrapOnKeys: true,
	
	    /**
	     * Allows the tab content panes to match heights if set to true.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    matchHeight: false,
	
	    /**
	     * Allows active tabs to collapse when clicked.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    activeCollapse: false,
	
	    /**
	     * Class applied to `li`'s in tab link list.
	     * @option
	     * @type {string}
	     * @default 'tabs-title'
	     */
	    linkClass: 'tabs-title',
	
	    /**
	     * Class applied to the active `li` in tab link list.
	     * @option
	     * @type {string}
	     * @default 'is-active'
	     */
	    linkActiveClass: 'is-active',
	
	    /**
	     * Class applied to the content containers.
	     * @option
	     * @type {string}
	     * @default 'tabs-panel'
	     */
	    panelClass: 'tabs-panel',
	
	    /**
	     * Class applied to the active content container.
	     * @option
	     * @type {string}
	     * @default 'is-active'
	     */
	    panelActiveClass: 'is-active'
	  };
	
	  /***/
	},
	/* 18 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Timer;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	
	  function Timer(elem, options, cb) {
	    var _this = this,
	        duration = options.duration,
	
	    //options is an object for easily adding features later.
	    nameSpace = (0, _keys2.default)(elem.data())[0] || 'timer',
	        remain = -1,
	        start,
	        timer;
	
	    this.isPaused = false;
	
	    this.restart = function () {
	      remain = -1;
	      clearTimeout(timer);
	      this.start();
	    };
	
	    this.start = function () {
	      this.isPaused = false;
	      // if(!elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
	      clearTimeout(timer);
	      remain = remain <= 0 ? duration : remain;
	      elem.data('paused', false);
	      start = Date.now();
	      timer = setTimeout(function () {
	        if (options.infinite) {
	          _this.restart(); //rerun the timer.
	        }
	        if (cb && typeof cb === 'function') {
	          cb();
	        }
	      }, remain);
	      elem.trigger('timerstart.zf.' + nameSpace);
	    };
	
	    this.pause = function () {
	      this.isPaused = true;
	      //if(elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
	      clearTimeout(timer);
	      elem.data('paused', true);
	      var end = Date.now();
	      remain = remain - (end - start);
	      elem.trigger('timerpaused.zf.' + nameSpace);
	    };
	  }
	
	  /***/
	},
	/* 19 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	
	  Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_core__ = __webpack_require__(21);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_box__ = __webpack_require__(7);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_imageLoader__ = __webpack_require__(8);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_8__foundation_util_nest__ = __webpack_require__(9);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__foundation_util_timer__ = __webpack_require__(18);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_10__foundation_util_touch__ = __webpack_require__(10);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_11__foundation_util_triggers__ = __webpack_require__(5);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_12__foundation_abide__ = __webpack_require__(20);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_13__foundation_accordion__ = __webpack_require__(11);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_14__foundation_accordionMenu__ = __webpack_require__(12);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_15__foundation_drilldown__ = __webpack_require__(13);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_16__foundation_dropdown__ = __webpack_require__(22);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_17__foundation_dropdownMenu__ = __webpack_require__(14);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_18__foundation_equalizer__ = __webpack_require__(23);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_19__foundation_interchange__ = __webpack_require__(24);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_20__foundation_magellan__ = __webpack_require__(25);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_21__foundation_offcanvas__ = __webpack_require__(26);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_22__foundation_orbit__ = __webpack_require__(27);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_23__foundation_responsiveMenu__ = __webpack_require__(29);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_24__foundation_responsiveToggle__ = __webpack_require__(30);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_25__foundation_reveal__ = __webpack_require__(31);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_26__foundation_slider__ = __webpack_require__(32);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_27__foundation_smoothScroll__ = __webpack_require__(16);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_28__foundation_sticky__ = __webpack_require__(33);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_29__foundation_tabs__ = __webpack_require__(17);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_30__foundation_toggler__ = __webpack_require__(34);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_31__foundation_tooltip__ = __webpack_require__(35);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_32__foundation_responsiveAccordionTabs__ = __webpack_require__(28);
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].addToJquery(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	  // Add Foundation Utils to Foundation global namespace for backwards
	  // compatibility.
	
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].rtl = __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["a" /* rtl */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].GetYoDigits = __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].transitionend = __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["c" /* transitionend */];
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Box = __WEBPACK_IMPORTED_MODULE_3__foundation_util_box__["a" /* Box */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].onImagesLoaded = __WEBPACK_IMPORTED_MODULE_4__foundation_util_imageLoader__["a" /* onImagesLoaded */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Keyboard = __WEBPACK_IMPORTED_MODULE_5__foundation_util_keyboard__["a" /* Keyboard */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].MediaQuery = __WEBPACK_IMPORTED_MODULE_6__foundation_util_mediaQuery__["a" /* MediaQuery */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Motion = __WEBPACK_IMPORTED_MODULE_7__foundation_util_motion__["a" /* Motion */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Move = __WEBPACK_IMPORTED_MODULE_7__foundation_util_motion__["b" /* Move */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Nest = __WEBPACK_IMPORTED_MODULE_8__foundation_util_nest__["a" /* Nest */];
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].Timer = __WEBPACK_IMPORTED_MODULE_9__foundation_util_timer__["a" /* Timer */];
	
	  // Touch and Triggers previously were almost purely sede effect driven,
	  // so no // need to add it to Foundation, just init them.
	
	
	  __WEBPACK_IMPORTED_MODULE_10__foundation_util_touch__["a" /* Touch */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	  __WEBPACK_IMPORTED_MODULE_11__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a, __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */]);
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_12__foundation_abide__["a" /* Abide */], 'Abide');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_13__foundation_accordion__["a" /* Accordion */], 'Accordion');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_14__foundation_accordionMenu__["a" /* AccordionMenu */], 'AccordionMenu');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_15__foundation_drilldown__["a" /* Drilldown */], 'Drilldown');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_16__foundation_dropdown__["a" /* Dropdown */], 'Dropdown');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_17__foundation_dropdownMenu__["a" /* DropdownMenu */], 'DropdownMenu');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_18__foundation_equalizer__["a" /* Equalizer */], 'Equalizer');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_19__foundation_interchange__["a" /* Interchange */], 'Interchange');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_20__foundation_magellan__["a" /* Magellan */], 'Magellan');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_21__foundation_offcanvas__["a" /* OffCanvas */], 'OffCanvas');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_22__foundation_orbit__["a" /* Orbit */], 'Orbit');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_23__foundation_responsiveMenu__["a" /* ResponsiveMenu */], 'ResponsiveMenu');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_24__foundation_responsiveToggle__["a" /* ResponsiveToggle */], 'ResponsiveToggle');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_25__foundation_reveal__["a" /* Reveal */], 'Reveal');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_26__foundation_slider__["a" /* Slider */], 'Slider');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_27__foundation_smoothScroll__["a" /* SmoothScroll */], 'SmoothScroll');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_28__foundation_sticky__["a" /* Sticky */], 'Sticky');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_29__foundation_tabs__["a" /* Tabs */], 'Tabs');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_30__foundation_toggler__["a" /* Toggler */], 'Toggler');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_31__foundation_tooltip__["a" /* Tooltip */], 'Tooltip');
	
	  __WEBPACK_IMPORTED_MODULE_1__foundation_core__["a" /* Foundation */].plugin(__WEBPACK_IMPORTED_MODULE_32__foundation_responsiveAccordionTabs__["a" /* ResponsiveAccordionTabs */], 'ResponsiveAccordionTabs');
	
	  /***/
	},
	/* 20 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Abide;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Abide module.
	   * @module foundation.abide
	   */
	
	  var Abide = function (_Plugin) {
	    _inherits(Abide, _Plugin);
	
	    function Abide() {
	      _classCallCheck(this, Abide);
	
	      return _possibleConstructorReturn(this, (Abide.__proto__ || (0, _getPrototypeOf2.default)(Abide)).apply(this, arguments));
	    }
	
	    _createClass(Abide, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Abide.
	       * @class
	       * @name Abide
	       * @fires Abide#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, {}, Abide.defaults, this.$element.data(), options);
	
	        this.className = 'Abide'; // ie9 back compat
	        this._init();
	      }
	
	      /**
	       * Initializes the Abide plugin and calls functions to get Abide functioning on load.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        this.$inputs = this.$element.find('input, textarea, select');
	
	        this._events();
	      }
	
	      /**
	       * Initializes events for Abide.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this3 = this;
	
	        this.$element.off('.abide').on('reset.zf.abide', function () {
	          _this3.resetForm();
	        }).on('submit.zf.abide', function () {
	          return _this3.validateForm();
	        });
	
	        if (this.options.validateOn === 'fieldChange') {
	          this.$inputs.off('change.zf.abide').on('change.zf.abide', function (e) {
	            _this3.validateInput(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target));
	          });
	        }
	
	        if (this.options.liveValidate) {
	          this.$inputs.off('input.zf.abide').on('input.zf.abide', function (e) {
	            _this3.validateInput(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target));
	          });
	        }
	
	        if (this.options.validateOnBlur) {
	          this.$inputs.off('blur.zf.abide').on('blur.zf.abide', function (e) {
	            _this3.validateInput(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target));
	          });
	        }
	      }
	
	      /**
	       * Calls necessary functions to update Abide upon DOM change
	       * @private
	       */
	
	    }, {
	      key: '_reflow',
	      value: function _reflow() {
	        this._init();
	      }
	
	      /**
	       * Checks whether or not a form element has the required attribute and if it's checked or not
	       * @param {Object} element - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */
	
	    }, {
	      key: 'requiredCheck',
	      value: function requiredCheck($el) {
	        if (!$el.attr('required')) return true;
	
	        var isGood = true;
	
	        switch ($el[0].type) {
	          case 'checkbox':
	            isGood = $el[0].checked;
	            break;
	
	          case 'select':
	          case 'select-one':
	          case 'select-multiple':
	            var opt = $el.find('option:selected');
	            if (!opt.length || !opt.val()) isGood = false;
	            break;
	
	          default:
	            if (!$el.val() || !$el.val().length) isGood = false;
	        }
	
	        return isGood;
	      }
	
	      /**
	       * Get:
	       * - Based on $el, the first element(s) corresponding to `formErrorSelector` in this order:
	       *   1. The element's direct sibling('s).
	       *   2. The element's parent's children.
	       * - Element(s) with the attribute `[data-form-error-for]` set with the element's id.
	       *
	       * This allows for multiple form errors per input, though if none are found, no form errors will be shown.
	       *
	       * @param {Object} $el - jQuery object to use as reference to find the form error selector.
	       * @returns {Object} jQuery object with the selector.
	       */
	
	    }, {
	      key: 'findFormError',
	      value: function findFormError($el) {
	        var id = $el[0].id;
	        var $error = $el.siblings(this.options.formErrorSelector);
	
	        if (!$error.length) {
	          $error = $el.parent().find(this.options.formErrorSelector);
	        }
	
	        $error = $error.add(this.$element.find('[data-form-error-for="' + id + '"]'));
	
	        return $error;
	      }
	
	      /**
	       * Get the first element in this order:
	       * 2. The <label> with the attribute `[for="someInputId"]`
	       * 3. The `.closest()` <label>
	       *
	       * @param {Object} $el - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */
	
	    }, {
	      key: 'findLabel',
	      value: function findLabel($el) {
	        var id = $el[0].id;
	        var $label = this.$element.find('label[for="' + id + '"]');
	
	        if (!$label.length) {
	          return $el.closest('label');
	        }
	
	        return $label;
	      }
	
	      /**
	       * Get the set of labels associated with a set of radio els in this order
	       * 2. The <label> with the attribute `[for="someInputId"]`
	       * 3. The `.closest()` <label>
	       *
	       * @param {Object} $el - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */
	
	    }, {
	      key: 'findRadioLabels',
	      value: function findRadioLabels($els) {
	        var _this4 = this;
	
	        var labels = $els.map(function (i, el) {
	          var id = el.id;
	          var $label = _this4.$element.find('label[for="' + id + '"]');
	
	          if (!$label.length) {
	            $label = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).closest('label');
	          }
	          return $label[0];
	        });
	
	        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(labels);
	      }
	
	      /**
	       * Adds the CSS error class as specified by the Abide settings to the label, input, and the form
	       * @param {Object} $el - jQuery object to add the class to
	       */
	
	    }, {
	      key: 'addErrorClasses',
	      value: function addErrorClasses($el) {
	        var $label = this.findLabel($el);
	        var $formError = this.findFormError($el);
	
	        if ($label.length) {
	          $label.addClass(this.options.labelErrorClass);
	        }
	
	        if ($formError.length) {
	          $formError.addClass(this.options.formErrorClass);
	        }
	
	        $el.addClass(this.options.inputErrorClass).attr('data-invalid', '');
	      }
	
	      /**
	       * Remove CSS error classes etc from an entire radio button group
	       * @param {String} groupName - A string that specifies the name of a radio button group
	       *
	       */
	
	    }, {
	      key: 'removeRadioErrorClasses',
	      value: function removeRadioErrorClasses(groupName) {
	        var $els = this.$element.find(':radio[name="' + groupName + '"]');
	        var $labels = this.findRadioLabels($els);
	        var $formErrors = this.findFormError($els);
	
	        if ($labels.length) {
	          $labels.removeClass(this.options.labelErrorClass);
	        }
	
	        if ($formErrors.length) {
	          $formErrors.removeClass(this.options.formErrorClass);
	        }
	
	        $els.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');
	      }
	
	      /**
	       * Removes CSS error class as specified by the Abide settings from the label, input, and the form
	       * @param {Object} $el - jQuery object to remove the class from
	       */
	
	    }, {
	      key: 'removeErrorClasses',
	      value: function removeErrorClasses($el) {
	        // radios need to clear all of the els
	        if ($el[0].type == 'radio') {
	          return this.removeRadioErrorClasses($el.attr('name'));
	        }
	
	        var $label = this.findLabel($el);
	        var $formError = this.findFormError($el);
	
	        if ($label.length) {
	          $label.removeClass(this.options.labelErrorClass);
	        }
	
	        if ($formError.length) {
	          $formError.removeClass(this.options.formErrorClass);
	        }
	
	        $el.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');
	      }
	
	      /**
	       * Goes through a form to find inputs and proceeds to validate them in ways specific to their type.
	       * Ignores inputs with data-abide-ignore, type="hidden" or disabled attributes set
	       * @fires Abide#invalid
	       * @fires Abide#valid
	       * @param {Object} element - jQuery object to validate, should be an HTML input
	       * @returns {Boolean} goodToGo - If the input is valid or not.
	       */
	
	    }, {
	      key: 'validateInput',
	      value: function validateInput($el) {
	        var clearRequire = this.requiredCheck($el),
	            validated = false,
	            customValidator = true,
	            validator = $el.attr('data-validator'),
	            equalTo = true;
	
	        // don't validate ignored inputs or hidden inputs or disabled inputs
	        if ($el.is('[data-abide-ignore]') || $el.is('[type="hidden"]') || $el.is('[disabled]')) {
	          return true;
	        }
	
	        switch ($el[0].type) {
	          case 'radio':
	            validated = this.validateRadio($el.attr('name'));
	            break;
	
	          case 'checkbox':
	            validated = clearRequire;
	            break;
	
	          case 'select':
	          case 'select-one':
	          case 'select-multiple':
	            validated = clearRequire;
	            break;
	
	          default:
	            validated = this.validateText($el);
	        }
	
	        if (validator) {
	          customValidator = this.matchValidation($el, validator, $el.attr('required'));
	        }
	
	        if ($el.attr('data-equalto')) {
	          equalTo = this.options.validators.equalTo($el);
	        }
	
	        var goodToGo = [clearRequire, validated, customValidator, equalTo].indexOf(false) === -1;
	        var message = (goodToGo ? 'valid' : 'invalid') + '.zf.abide';
	
	        if (goodToGo) {
	          // Re-validate inputs that depend on this one with equalto
	          var dependentElements = this.$element.find('[data-equalto="' + $el.attr('id') + '"]');
	          if (dependentElements.length) {
	            var _this = this;
	            dependentElements.each(function () {
	              if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()) {
	                _this.validateInput(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	              }
	            });
	          }
	        }
	
	        this[goodToGo ? 'removeErrorClasses' : 'addErrorClasses']($el);
	
	        /**
	         * Fires when the input is done checking for validation. Event trigger is either `valid.zf.abide` or `invalid.zf.abide`
	         * Trigger includes the DOM element of the input.
	         * @event Abide#valid
	         * @event Abide#invalid
	         */
	        $el.trigger(message, [$el]);
	
	        return goodToGo;
	      }
	
	      /**
	       * Goes through a form and if there are any invalid inputs, it will display the form error element
	       * @returns {Boolean} noError - true if no errors were detected...
	       * @fires Abide#formvalid
	       * @fires Abide#forminvalid
	       */
	
	    }, {
	      key: 'validateForm',
	      value: function validateForm() {
	        var acc = [];
	        var _this = this;
	
	        this.$inputs.each(function () {
	          acc.push(_this.validateInput(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)));
	        });
	
	        var noError = acc.indexOf(false) === -1;
	
	        this.$element.find('[data-abide-error]').css('display', noError ? 'none' : 'block');
	
	        /**
	         * Fires when the form is finished validating. Event trigger is either `formvalid.zf.abide` or `forminvalid.zf.abide`.
	         * Trigger includes the element of the form.
	         * @event Abide#formvalid
	         * @event Abide#forminvalid
	         */
	        this.$element.trigger((noError ? 'formvalid' : 'forminvalid') + '.zf.abide', [this.$element]);
	
	        return noError;
	      }
	
	      /**
	       * Determines whether or a not a text input is valid based on the pattern specified in the attribute. If no matching pattern is found, returns true.
	       * @param {Object} $el - jQuery object to validate, should be a text input HTML element
	       * @param {String} pattern - string value of one of the RegEx patterns in Abide.options.patterns
	       * @returns {Boolean} Boolean value depends on whether or not the input value matches the pattern specified
	       */
	
	    }, {
	      key: 'validateText',
	      value: function validateText($el, pattern) {
	        // A pattern can be passed to this function, or it will be infered from the input's "pattern" attribute, or it's "type" attribute
	        pattern = pattern || $el.attr('pattern') || $el.attr('type');
	        var inputText = $el.val();
	        var valid = false;
	
	        if (inputText.length) {
	          // If the pattern attribute on the element is in Abide's list of patterns, then test that regexp
	          if (this.options.patterns.hasOwnProperty(pattern)) {
	            valid = this.options.patterns[pattern].test(inputText);
	          }
	          // If the pattern name isn't also the type attribute of the field, then test it as a regexp
	          else if (pattern !== $el.attr('type')) {
	              valid = new RegExp(pattern).test(inputText);
	            } else {
	              valid = true;
	            }
	        }
	        // An empty field is valid if it's not required
	        else if (!$el.prop('required')) {
	            valid = true;
	          }
	
	        return valid;
	      }
	
	      /**
	       * Determines whether or a not a radio input is valid based on whether or not it is required and selected. Although the function targets a single `<input>`, it validates by checking the `required` and `checked` properties of all radio buttons in its group.
	       * @param {String} groupName - A string that specifies the name of a radio button group
	       * @returns {Boolean} Boolean value depends on whether or not at least one radio input has been selected (if it's required)
	       */
	
	    }, {
	      key: 'validateRadio',
	      value: function validateRadio(groupName) {
	        // If at least one radio in the group has the `required` attribute, the group is considered required
	        // Per W3C spec, all radio buttons in a group should have `required`, but we're being nice
	        var $group = this.$element.find(':radio[name="' + groupName + '"]');
	        var valid = false,
	            required = false;
	
	        // For the group to be required, at least one radio needs to be required
	        $group.each(function (i, e) {
	          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).attr('required')) {
	            required = true;
	          }
	        });
	        if (!required) valid = true;
	
	        if (!valid) {
	          // For the group to be valid, at least one radio needs to be checked
	          $group.each(function (i, e) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).prop('checked')) {
	              valid = true;
	            }
	          });
	        };
	
	        return valid;
	      }
	
	      /**
	       * Determines if a selected input passes a custom validation function. Multiple validations can be used, if passed to the element with `data-validator="foo bar baz"` in a space separated listed.
	       * @param {Object} $el - jQuery input element.
	       * @param {String} validators - a string of function names matching functions in the Abide.options.validators object.
	       * @param {Boolean} required - self explanatory?
	       * @returns {Boolean} - true if validations passed.
	       */
	
	    }, {
	      key: 'matchValidation',
	      value: function matchValidation($el, validators, required) {
	        var _this5 = this;
	
	        required = required ? true : false;
	
	        var clear = validators.split(' ').map(function (v) {
	          return _this5.options.validators[v]($el, required, $el.parent());
	        });
	        return clear.indexOf(false) === -1;
	      }
	
	      /**
	       * Resets form inputs and styles
	       * @fires Abide#formreset
	       */
	
	    }, {
	      key: 'resetForm',
	      value: function resetForm() {
	        var $form = this.$element,
	            opts = this.options;
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + opts.labelErrorClass, $form).not('small').removeClass(opts.labelErrorClass);
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + opts.inputErrorClass, $form).not('small').removeClass(opts.inputErrorClass);
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.formErrorSelector + '.' + opts.formErrorClass).removeClass(opts.formErrorClass);
	        $form.find('[data-abide-error]').css('display', 'none');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(':input', $form).not(':button, :submit, :reset, :hidden, :radio, :checkbox, [data-abide-ignore]').val('').removeAttr('data-invalid');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(':input:radio', $form).not('[data-abide-ignore]').prop('checked', false).removeAttr('data-invalid');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(':input:checkbox', $form).not('[data-abide-ignore]').prop('checked', false).removeAttr('data-invalid');
	        /**
	         * Fires when the form has been reset.
	         * @event Abide#formreset
	         */
	        $form.trigger('formreset.zf.abide', [$form]);
	      }
	
	      /**
	       * Destroys an instance of Abide.
	       * Removes error styles and classes from elements, without resetting their values.
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        var _this = this;
	        this.$element.off('.abide').find('[data-abide-error]').css('display', 'none');
	
	        this.$inputs.off('.abide').each(function () {
	          _this.removeErrorClasses(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	        });
	      }
	    }]);
	
	    return Abide;
	  }(__WEBPACK_IMPORTED_MODULE_1__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin
	   */
	
	  Abide.defaults = {
	    /**
	     * The default event to validate inputs. Checkboxes and radios validate immediately.
	     * Remove or change this value for manual validation.
	     * @option
	     * @type {?string}
	     * @default 'fieldChange'
	     */
	    validateOn: 'fieldChange',
	
	    /**
	     * Class to be applied to input labels on failed validation.
	     * @option
	     * @type {string}
	     * @default 'is-invalid-label'
	     */
	    labelErrorClass: 'is-invalid-label',
	
	    /**
	     * Class to be applied to inputs on failed validation.
	     * @option
	     * @type {string}
	     * @default 'is-invalid-input'
	     */
	    inputErrorClass: 'is-invalid-input',
	
	    /**
	     * Class selector to use to target Form Errors for show/hide.
	     * @option
	     * @type {string}
	     * @default '.form-error'
	     */
	    formErrorSelector: '.form-error',
	
	    /**
	     * Class added to Form Errors on failed validation.
	     * @option
	     * @type {string}
	     * @default 'is-visible'
	     */
	    formErrorClass: 'is-visible',
	
	    /**
	     * Set to true to validate text inputs on any value change.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    liveValidate: false,
	
	    /**
	     * Set to true to validate inputs on blur.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    validateOnBlur: false,
	
	    patterns: {
	      alpha: /^[a-zA-Z]+$/,
	      alpha_numeric: /^[a-zA-Z0-9]+$/,
	      integer: /^[-+]?\d+$/,
	      number: /^[-+]?\d*(?:[\.\,]\d+)?$/,
	
	      // amex, visa, diners
	      card: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(?:222[1-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
	      cvv: /^([0-9]){3,4}$/,
	
	      // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
	      email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
	
	      url: /^(https?|ftp|file|ssh):\/\/(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/,
	      // abc.de
	      domain: /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,
	
	      datetime: /^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/,
	      // YYYY-MM-DD
	      date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/,
	      // HH:MM:SS
	      time: /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,
	      dateISO: /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/,
	      // MM/DD/YYYY
	      month_day_year: /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/,
	      // DD/MM/YYYY
	      day_month_year: /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/,
	
	      // #FFF or #FFFFFF
	      color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
	
	      // Domain || URL
	      website: {
	        test: function test(text) {
	          return Abide.defaults.patterns['domain'].test(text) || Abide.defaults.patterns['url'].test(text);
	        }
	      }
	    },
	
	    /**
	     * Optional validation functions to be used. `equalTo` being the only default included function.
	     * Functions should return only a boolean if the input is valid or not. Functions are given the following arguments:
	     * el : The jQuery element to validate.
	     * required : Boolean value of the required attribute be present or not.
	     * parent : The direct parent of the input.
	     * @option
	     */
	    validators: {
	      equalTo: function equalTo(el, required, parent) {
	        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + el.attr('data-equalto')).val() === el.val();
	      }
	    }
	  };
	
	  /***/
	},
	/* 21 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Foundation;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__ = __webpack_require__(4);
	
	  var FOUNDATION_VERSION = '6.4.3';
	
	  // Global Foundation object
	  // This is attached to the window, or used as a module for AMD/Browserify
	  var Foundation = {
	    version: FOUNDATION_VERSION,
	
	    /**
	     * Stores initialized plugins.
	     */
	    _plugins: {},
	
	    /**
	     * Stores generated unique ids for plugin instances
	     */
	    _uuids: [],
	
	    /**
	     * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
	     * @param {Object} plugin - The constructor of the plugin.
	     */
	    plugin: function plugin(_plugin, name) {
	      // Object key to use when adding to global Foundation object
	      // Examples: Foundation.Reveal, Foundation.OffCanvas
	      var className = name || functionName(_plugin);
	      // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
	      // Examples: data-reveal, data-off-canvas
	      var attrName = hyphenate(className);
	
	      // Add to the Foundation object and the plugins list (for reflowing)
	      this._plugins[attrName] = this[className] = _plugin;
	    },
	    /**
	     * @function
	     * Populates the _uuids array with pointers to each individual plugin instance.
	     * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
	     * Also fires the initialization event for each plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @param {String} name - the name of the plugin, passed as a camelCased string.
	     * @fires Plugin#init
	     */
	    registerPlugin: function registerPlugin(plugin, name) {
	      var pluginName = name ? hyphenate(name) : functionName(plugin.constructor).toLowerCase();
	      plugin.uuid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, pluginName);
	
	      if (!plugin.$element.attr('data-' + pluginName)) {
	        plugin.$element.attr('data-' + pluginName, plugin.uuid);
	      }
	      if (!plugin.$element.data('zfPlugin')) {
	        plugin.$element.data('zfPlugin', plugin);
	      }
	      /**
	       * Fires when the plugin has initialized.
	       * @event Plugin#init
	       */
	      plugin.$element.trigger('init.zf.' + pluginName);
	
	      this._uuids.push(plugin.uuid);
	
	      return;
	    },
	    /**
	     * @function
	     * Removes the plugins uuid from the _uuids array.
	     * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
	     * Also fires the destroyed event for the plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @fires Plugin#destroyed
	     */
	    unregisterPlugin: function unregisterPlugin(plugin) {
	      var pluginName = hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));
	
	      this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
	      plugin.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
	      /**
	       * Fires when the plugin has been destroyed.
	       * @event Plugin#destroyed
	       */
	      .trigger('destroyed.zf.' + pluginName);
	      for (var prop in plugin) {
	        plugin[prop] = null; //clean up script to prep for garbage collection.
	      }
	      return;
	    },
	
	    /**
	     * @function
	     * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
	     * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
	     * @default If no argument is passed, reflow all currently active plugins.
	     */
	    reInit: function reInit(plugins) {
	      var isJQ = plugins instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
	      try {
	        if (isJQ) {
	          plugins.each(function () {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('zfPlugin')._init();
	          });
	        } else {
	          var type = typeof plugins === 'undefined' ? 'undefined' : (0, _typeof3.default)(plugins),
	              _this = this,
	              fns = {
	            'object': function object(plgs) {
	              plgs.forEach(function (p) {
	                p = hyphenate(p);
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-' + p + ']').foundation('_init');
	              });
	            },
	            'string': function string() {
	              plugins = hyphenate(plugins);
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-' + plugins + ']').foundation('_init');
	            },
	            'undefined': function undefined() {
	              this['object']((0, _keys2.default)(_this._plugins));
	            }
	          };
	          fns[type](plugins);
	        }
	      } catch (err) {
	        console.error(err);
	      } finally {
	        return plugins;
	      }
	    },
	
	    /**
	     * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
	     * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
	     * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
	     */
	    reflow: function reflow(elem, plugins) {
	
	      // If plugins is undefined, just grab everything
	      if (typeof plugins === 'undefined') {
	        plugins = (0, _keys2.default)(this._plugins);
	      }
	      // If plugins is a string, convert it to an array with one item
	      else if (typeof plugins === 'string') {
	          plugins = [plugins];
	        }
	
	      var _this = this;
	
	      // Iterate through each plugin
	      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(plugins, function (i, name) {
	        // Get the current plugin
	        var plugin = _this._plugins[name];
	
	        // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
	        var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).find('[data-' + name + ']').addBack('[data-' + name + ']');
	
	        // For each plugin found, initialize it
	        $elem.each(function () {
	          var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              opts = {};
	          // Don't double-dip on plugins
	          if ($el.data('zfPlugin')) {
	            console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");
	            return;
	          }
	
	          if ($el.attr('data-options')) {
	            var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
	              var opt = e.split(':').map(function (el) {
	                return el.trim();
	              });
	              if (opt[0]) opts[opt[0]] = parseValue(opt[1]);
	            });
	          }
	          try {
	            $el.data('zfPlugin', new plugin(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts));
	          } catch (er) {
	            console.error(er);
	          } finally {
	            return;
	          }
	        });
	      });
	    },
	    getFnName: functionName,
	
	    addToJquery: function addToJquery($) {
	      // TODO: consider not making this a jQuery function
	      // TODO: need way to reflow vs. re-initialize
	      /**
	       * The Foundation jQuery method.
	       * @param {String|Array} method - An action to perform on the current jQuery object.
	       */
	      var foundation = function foundation(method) {
	        var type = typeof method === 'undefined' ? 'undefined' : (0, _typeof3.default)(method),
	            $noJS = $('.no-js');
	
	        if ($noJS.length) {
	          $noJS.removeClass('no-js');
	        }
	
	        if (type === 'undefined') {
	          //needs to initialize the Foundation object, or an individual plugin.
	          __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	          Foundation.reflow(this);
	        } else if (type === 'string') {
	          //an individual method to invoke on a plugin or group of plugins
	          var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
	          var plugClass = this.data('zfPlugin'); //determine the class of plugin
	
	          if (plugClass !== undefined && plugClass[method] !== undefined) {
	            //make sure both the class and method exist
	            if (this.length === 1) {
	              //if there's only one, call it directly.
	              plugClass[method].apply(plugClass, args);
	            } else {
	              this.each(function (i, el) {
	                //otherwise loop through the jQuery collection and invoke the method on each
	                plugClass[method].apply($(el).data('zfPlugin'), args);
	              });
	            }
	          } else {
	            //error for no class or no method
	            throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? functionName(plugClass) : 'this element') + '.');
	          }
	        } else {
	          //error for invalid argument type
	          throw new TypeError('We\'re sorry, ' + type + ' is not a valid parameter. You must use a string representing the method you wish to invoke.');
	        }
	        return this;
	      };
	      $.fn.foundation = foundation;
	      return $;
	    }
	  };
	
	  Foundation.util = {
	    /**
	     * Function for applying a debounce effect to a function call.
	     * @function
	     * @param {Function} func - Function to be called at end of timeout.
	     * @param {Number} delay - Time in ms to delay the call of `func`.
	     * @returns function
	     */
	    throttle: function throttle(func, delay) {
	      var timer = null;
	
	      return function () {
	        var context = this,
	            args = arguments;
	
	        if (timer === null) {
	          timer = setTimeout(function () {
	            func.apply(context, args);
	            timer = null;
	          }, delay);
	        }
	      };
	    }
	  };
	
	  window.Foundation = Foundation;
	
	  // Polyfill for requestAnimationFrame
	  (function () {
	    if (!Date.now || !window.Date.now) window.Date.now = Date.now = function () {
	      return new Date().getTime();
	    };
	
	    var vendors = ['webkit', 'moz'];
	    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	      var vp = vendors[i];
	      window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
	      window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
	    }
	    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	      var lastTime = 0;
	      window.requestAnimationFrame = function (callback) {
	        var now = Date.now();
	        var nextTime = Math.max(lastTime + 16, now);
	        return setTimeout(function () {
	          callback(lastTime = nextTime);
	        }, nextTime - now);
	      };
	      window.cancelAnimationFrame = clearTimeout;
	    }
	    /**
	     * Polyfill for performance.now, required by rAF
	     */
	    if (!window.performance || !window.performance.now) {
	      window.performance = {
	        start: Date.now(),
	        now: function now() {
	          return Date.now() - this.start;
	        }
	      };
	    }
	  })();
	  if (!Function.prototype.bind) {
	    Function.prototype.bind = function (oThis) {
	      if (typeof this !== 'function') {
	        // closest thing possible to the ECMAScript 5
	        // internal IsCallable function
	        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	      }
	
	      var aArgs = Array.prototype.slice.call(arguments, 1),
	          fToBind = this,
	          fNOP = function fNOP() {},
	          fBound = function fBound() {
	        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	      };
	
	      if (this.prototype) {
	        // native functions don't have a prototype
	        fNOP.prototype = this.prototype;
	      }
	      fBound.prototype = new fNOP();
	
	      return fBound;
	    };
	  }
	  // Polyfill to get the name of a function in IE9
	  function functionName(fn) {
	    if (Function.prototype.name === undefined) {
	      var funcNameRegex = /function\s([^(]{1,})\(/;
	      var results = funcNameRegex.exec(fn.toString());
	      return results && results.length > 1 ? results[1].trim() : "";
	    } else if (fn.prototype === undefined) {
	      return fn.constructor.name;
	    } else {
	      return fn.prototype.constructor.name;
	    }
	  }
	  function parseValue(str) {
	    if ('true' === str) return true;else if ('false' === str) return false;else if (!isNaN(str * 1)) return parseFloat(str);
	    return str;
	  }
	  // Convert PascalCase to kebab-case
	  // Thank you: http://stackoverflow.com/a/8955580
	  function hyphenate(str) {
	    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	  }
	
	  /***/
	},
	/* 22 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Dropdown;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_positionable__ = __webpack_require__(15);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  var _get = function get(object, property, receiver) {
	    if (object === null) object = Function.prototype;var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);if (desc === undefined) {
	      var parent = (0, _getPrototypeOf2.default)(object);if (parent === null) {
	        return undefined;
	      } else {
	        return get(parent, property, receiver);
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;if (getter === undefined) {
	        return undefined;
	      }return getter.call(receiver);
	    }
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Dropdown module.
	   * @module foundation.dropdown
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.box
	   * @requires foundation.util.triggers
	   */
	
	  var Dropdown = function (_Positionable) {
	    _inherits(Dropdown, _Positionable);
	
	    function Dropdown() {
	      _classCallCheck(this, Dropdown);
	
	      return _possibleConstructorReturn(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).apply(this, arguments));
	    }
	
	    _createClass(Dropdown, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a dropdown.
	       * @class
	       * @name Dropdown
	       * @param {jQuery} element - jQuery object to make into a dropdown.
	       *        Object should be of the dropdown panel, rather than its anchor.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Dropdown.defaults, this.$element.data(), options);
	        this.className = 'Dropdown'; // ie9 back compat
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_4__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Dropdown', {
	          'ENTER': 'open',
	          'SPACE': 'open',
	          'ESCAPE': 'close'
	        });
	      }
	
	      /**
	       * Initializes the plugin by setting/checking options and attributes, adding helper variables, and saving the anchor.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var $id = this.$element.attr('id');
	
	        this.$anchors = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-toggle="' + $id + '"]').length ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-toggle="' + $id + '"]') : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-open="' + $id + '"]');
	        this.$anchors.attr({
	          'aria-controls': $id,
	          'data-is-focus': false,
	          'data-yeti-box': $id,
	          'aria-haspopup': true,
	          'aria-expanded': false
	        });
	
	        this._setCurrentAnchor(this.$anchors.first());
	
	        if (this.options.parentClass) {
	          this.$parent = this.$element.parents('.' + this.options.parentClass);
	        } else {
	          this.$parent = null;
	        }
	
	        this.$element.attr({
	          'aria-hidden': 'true',
	          'data-yeti-box': $id,
	          'data-resize': $id,
	          'aria-labelledby': this.$currentAnchor.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */])(6, 'dd-anchor')
	        });
	        _get(Dropdown.prototype.__proto__ || (0, _getPrototypeOf2.default)(Dropdown.prototype), '_init', this).call(this);
	        this._events();
	      }
	    }, {
	      key: '_getDefaultPosition',
	      value: function _getDefaultPosition() {
	        // handle legacy classnames
	        var position = this.$element[0].className.match(/(top|left|right|bottom)/g);
	        if (position) {
	          return position[0];
	        } else {
	          return 'bottom';
	        }
	      }
	    }, {
	      key: '_getDefaultAlignment',
	      value: function _getDefaultAlignment() {
	        // handle legacy float approach
	        var horizontalPosition = /float-(\S+)/.exec(this.$currentAnchor.className);
	        if (horizontalPosition) {
	          return horizontalPosition[1];
	        }
	
	        return _get(Dropdown.prototype.__proto__ || (0, _getPrototypeOf2.default)(Dropdown.prototype), '_getDefaultAlignment', this).call(this);
	      }
	
	      /**
	       * Sets the position and orientation of the dropdown pane, checks for collisions if allow-overlap is not true.
	       * Recursively calls itself if a collision is detected, with a new position class.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_setPosition',
	      value: function _setPosition() {
	        _get(Dropdown.prototype.__proto__ || (0, _getPrototypeOf2.default)(Dropdown.prototype), '_setPosition', this).call(this, this.$currentAnchor, this.$element, this.$parent);
	      }
	
	      /**
	       * Make it a current anchor.
	       * Current anchor as the reference for the position of Dropdown panes.
	       * @param {HTML} el - DOM element of the anchor.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_setCurrentAnchor',
	      value: function _setCurrentAnchor(el) {
	        this.$currentAnchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
	      }
	
	      /**
	       * Adds event listeners to the element utilizing the triggers utility library.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	        this.$element.on({
	          'open.zf.trigger': this.open.bind(this),
	          'close.zf.trigger': this.close.bind(this),
	          'toggle.zf.trigger': this.toggle.bind(this),
	          'resizeme.zf.trigger': this._setPosition.bind(this)
	        });
	
	        this.$anchors.off('click.zf.trigger').on('click.zf.trigger', function () {
	          _this._setCurrentAnchor(this);
	        });
	
	        if (this.options.hover) {
	          this.$anchors.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
	            _this._setCurrentAnchor(this);
	
	            var bodyData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').data();
	            if (typeof bodyData.whatinput === 'undefined' || bodyData.whatinput === 'mouse') {
	              clearTimeout(_this.timeout);
	              _this.timeout = setTimeout(function () {
	                _this.open();
	                _this.$anchors.data('hover', true);
	              }, _this.options.hoverDelay);
	            }
	          }).on('mouseleave.zf.dropdown', function () {
	            clearTimeout(_this.timeout);
	            _this.timeout = setTimeout(function () {
	              _this.close();
	              _this.$anchors.data('hover', false);
	            }, _this.options.hoverDelay);
	          });
	          if (this.options.hoverPane) {
	            this.$element.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
	              clearTimeout(_this.timeout);
	            }).on('mouseleave.zf.dropdown', function () {
	              clearTimeout(_this.timeout);
	              _this.timeout = setTimeout(function () {
	                _this.close();
	                _this.$anchors.data('hover', false);
	              }, _this.options.hoverDelay);
	            });
	          }
	        }
	        this.$anchors.add(this.$element).on('keydown.zf.dropdown', function (e) {
	
	          var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              visibleFocusableElements = __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].findFocusable(_this.$element);
	
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Dropdown', {
	            open: function open() {
	              if ($target.is(_this.$anchors)) {
	                _this.open();
	                _this.$element.attr('tabindex', -1).focus();
	                e.preventDefault();
	              }
	            },
	            close: function close() {
	              _this.close();
	              _this.$anchors.focus();
	            }
	          });
	        });
	      }
	
	      /**
	       * Adds an event handler to the body to close any dropdowns on a click.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_addBodyHandler',
	      value: function _addBodyHandler() {
	        var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).not(this.$element),
	            _this = this;
	        $body.off('click.zf.dropdown').on('click.zf.dropdown', function (e) {
	          if (_this.$anchors.is(e.target) || _this.$anchors.find(e.target).length) {
	            return;
	          }
	          if (_this.$element.find(e.target).length) {
	            return;
	          }
	          _this.close();
	          $body.off('click.zf.dropdown');
	        });
	      }
	
	      /**
	       * Opens the dropdown pane, and fires a bubbling event to close other dropdowns.
	       * @function
	       * @fires Dropdown#closeme
	       * @fires Dropdown#show
	       */
	
	    }, {
	      key: 'open',
	      value: function open() {
	        // var _this = this;
	        /**
	         * Fires to close other open dropdowns, typically when dropdown is opening
	         * @event Dropdown#closeme
	         */
	        this.$element.trigger('closeme.zf.dropdown', this.$element.attr('id'));
	        this.$anchors.addClass('hover').attr({ 'aria-expanded': true });
	        // this.$element/*.show()*/;
	
	        this.$element.addClass('is-opening');
	        this._setPosition();
	        this.$element.removeClass('is-opening').addClass('is-open').attr({ 'aria-hidden': false });
	
	        if (this.options.autoFocus) {
	          var $focusable = __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].findFocusable(this.$element);
	          if ($focusable.length) {
	            $focusable.eq(0).focus();
	          }
	        }
	
	        if (this.options.closeOnClick) {
	          this._addBodyHandler();
	        }
	
	        if (this.options.trapFocus) {
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].trapFocus(this.$element);
	        }
	
	        /**
	         * Fires once the dropdown is visible.
	         * @event Dropdown#show
	         */
	        this.$element.trigger('show.zf.dropdown', [this.$element]);
	      }
	
	      /**
	       * Closes the open dropdown pane.
	       * @function
	       * @fires Dropdown#hide
	       */
	
	    }, {
	      key: 'close',
	      value: function close() {
	        if (!this.$element.hasClass('is-open')) {
	          return false;
	        }
	        this.$element.removeClass('is-open').attr({ 'aria-hidden': true });
	
	        this.$anchors.removeClass('hover').attr('aria-expanded', false);
	
	        /**
	         * Fires once the dropdown is no longer visible.
	         * @event Dropdown#hide
	         */
	        this.$element.trigger('hide.zf.dropdown', [this.$element]);
	
	        if (this.options.trapFocus) {
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].releaseFocus(this.$element);
	        }
	      }
	
	      /**
	       * Toggles the dropdown pane's visibility.
	       * @function
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle() {
	        if (this.$element.hasClass('is-open')) {
	          if (this.$anchors.data('hover')) return;
	          this.close();
	        } else {
	          this.open();
	        }
	      }
	
	      /**
	       * Destroys the dropdown.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('.zf.trigger').hide();
	        this.$anchors.off('.zf.dropdown');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).off('click.zf.dropdown');
	      }
	    }]);
	
	    return Dropdown;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_positionable__["a" /* Positionable */]);
	
	  Dropdown.defaults = {
	    /**
	     * Class that designates bounding container of Dropdown (default: window)
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    parentClass: null,
	    /**
	     * Amount of time to delay opening a submenu on hover event.
	     * @option
	     * @type {number}
	     * @default 250
	     */
	    hoverDelay: 250,
	    /**
	     * Allow submenus to open on hover events
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    hover: false,
	    /**
	     * Don't close dropdown when hovering over dropdown pane
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    hoverPane: false,
	    /**
	     * Number of pixels between the dropdown pane and the triggering element on open.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    vOffset: 0,
	    /**
	     * Number of pixels between the dropdown pane and the triggering element on open.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    hOffset: 0,
	    /**
	     * DEPRECATED: Class applied to adjust open position.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    positionClass: '',
	
	    /**
	     * Position of dropdown. Can be left, right, bottom, top, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    position: 'auto',
	    /**
	     * Alignment of dropdown relative to anchor. Can be left, right, bottom, top, center, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    alignment: 'auto',
	    /**
	     * Allow overlap of container/window. If false, dropdown will first try to position as defined by data-position and data-alignment, but reposition if it would cause an overflow.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    allowOverlap: false,
	    /**
	     * Allow overlap of only the bottom of the container. This is the most common
	     * behavior for dropdowns, allowing the dropdown to extend the bottom of the
	     * screen but not otherwise influence or break out of the container.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    allowBottomOverlap: true,
	    /**
	     * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    trapFocus: false,
	    /**
	     * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    autoFocus: false,
	    /**
	     * Allows a click on the body to close the dropdown.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    closeOnClick: false
	  };
	
	  /***/
	},
	/* 23 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Equalizer;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_imageLoader__ = __webpack_require__(8);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Equalizer module.
	   * @module foundation.equalizer
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.imageLoader if equalizer contains images
	   */
	
	  var Equalizer = function (_Plugin) {
	    _inherits(Equalizer, _Plugin);
	
	    function Equalizer() {
	      _classCallCheck(this, Equalizer);
	
	      return _possibleConstructorReturn(this, (Equalizer.__proto__ || (0, _getPrototypeOf2.default)(Equalizer)).apply(this, arguments));
	    }
	
	    _createClass(Equalizer, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Equalizer.
	       * @class
	       * @name Equalizer
	       * @fires Equalizer#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Equalizer.defaults, this.$element.data(), options);
	        this.className = 'Equalizer'; // ie9 back compat
	
	        this._init();
	      }
	
	      /**
	       * Initializes the Equalizer plugin and calls functions to get equalizer functioning on load.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var eqId = this.$element.attr('data-equalizer') || '';
	        var $watched = this.$element.find('[data-equalizer-watch="' + eqId + '"]');
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	
	        this.$watched = $watched.length ? $watched : this.$element.find('[data-equalizer-watch]');
	        this.$element.attr('data-resize', eqId || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'eq'));
	        this.$element.attr('data-mutate', eqId || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'eq'));
	
	        this.hasNested = this.$element.find('[data-equalizer]').length > 0;
	        this.isNested = this.$element.parentsUntil(document.body, '[data-equalizer]').length > 0;
	        this.isOn = false;
	        this._bindHandler = {
	          onResizeMeBound: this._onResizeMe.bind(this),
	          onPostEqualizedBound: this._onPostEqualized.bind(this)
	        };
	
	        var imgs = this.$element.find('img');
	        var tooSmall;
	        if (this.options.equalizeOn) {
	          tooSmall = this._checkMQ();
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', this._checkMQ.bind(this));
	        } else {
	          this._events();
	        }
	        if (tooSmall !== undefined && tooSmall === false || tooSmall === undefined) {
	          if (imgs.length) {
	            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_imageLoader__["a" /* onImagesLoaded */])(imgs, this._reflow.bind(this));
	          } else {
	            this._reflow();
	          }
	        }
	      }
	
	      /**
	       * Removes event listeners if the breakpoint is too small.
	       * @private
	       */
	
	    }, {
	      key: '_pauseEvents',
	      value: function _pauseEvents() {
	        this.isOn = false;
	        this.$element.off({
	          '.zf.equalizer': this._bindHandler.onPostEqualizedBound,
	          'resizeme.zf.trigger': this._bindHandler.onResizeMeBound,
	          'mutateme.zf.trigger': this._bindHandler.onResizeMeBound
	        });
	      }
	
	      /**
	       * function to handle $elements resizeme.zf.trigger, with bound this on _bindHandler.onResizeMeBound
	       * @private
	       */
	
	    }, {
	      key: '_onResizeMe',
	      value: function _onResizeMe(e) {
	        this._reflow();
	      }
	
	      /**
	       * function to handle $elements postequalized.zf.equalizer, with bound this on _bindHandler.onPostEqualizedBound
	       * @private
	       */
	
	    }, {
	      key: '_onPostEqualized',
	      value: function _onPostEqualized(e) {
	        if (e.target !== this.$element[0]) {
	          this._reflow();
	        }
	      }
	
	      /**
	       * Initializes events for Equalizer.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	        this._pauseEvents();
	        if (this.hasNested) {
	          this.$element.on('postequalized.zf.equalizer', this._bindHandler.onPostEqualizedBound);
	        } else {
	          this.$element.on('resizeme.zf.trigger', this._bindHandler.onResizeMeBound);
	          this.$element.on('mutateme.zf.trigger', this._bindHandler.onResizeMeBound);
	        }
	        this.isOn = true;
	      }
	
	      /**
	       * Checks the current breakpoint to the minimum required size.
	       * @private
	       */
	
	    }, {
	      key: '_checkMQ',
	      value: function _checkMQ() {
	        var tooSmall = !__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].is(this.options.equalizeOn);
	        if (tooSmall) {
	          if (this.isOn) {
	            this._pauseEvents();
	            this.$watched.css('height', 'auto');
	          }
	        } else {
	          if (!this.isOn) {
	            this._events();
	          }
	        }
	        return tooSmall;
	      }
	
	      /**
	       * A noop version for the plugin
	       * @private
	       */
	
	    }, {
	      key: '_killswitch',
	      value: function _killswitch() {
	        return;
	      }
	
	      /**
	       * Calls necessary functions to update Equalizer upon DOM change
	       * @private
	       */
	
	    }, {
	      key: '_reflow',
	      value: function _reflow() {
	        if (!this.options.equalizeOnStack) {
	          if (this._isStacked()) {
	            this.$watched.css('height', 'auto');
	            return false;
	          }
	        }
	        if (this.options.equalizeByRow) {
	          this.getHeightsByRow(this.applyHeightByRow.bind(this));
	        } else {
	          this.getHeights(this.applyHeight.bind(this));
	        }
	      }
	
	      /**
	       * Manually determines if the first 2 elements are *NOT* stacked.
	       * @private
	       */
	
	    }, {
	      key: '_isStacked',
	      value: function _isStacked() {
	        if (!this.$watched[0] || !this.$watched[1]) {
	          return true;
	        }
	        return this.$watched[0].getBoundingClientRect().top !== this.$watched[1].getBoundingClientRect().top;
	      }
	
	      /**
	       * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
	       * @param {Function} cb - A non-optional callback to return the heights array to.
	       * @returns {Array} heights - An array of heights of children within Equalizer container
	       */
	
	    }, {
	      key: 'getHeights',
	      value: function getHeights(cb) {
	        var heights = [];
	        for (var i = 0, len = this.$watched.length; i < len; i++) {
	          this.$watched[i].style.height = 'auto';
	          heights.push(this.$watched[i].offsetHeight);
	        }
	        cb(heights);
	      }
	
	      /**
	       * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
	       * @param {Function} cb - A non-optional callback to return the heights array to.
	       * @returns {Array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
	       */
	
	    }, {
	      key: 'getHeightsByRow',
	      value: function getHeightsByRow(cb) {
	        var lastElTopOffset = this.$watched.length ? this.$watched.first().offset().top : 0,
	            groups = [],
	            group = 0;
	        //group by Row
	        groups[group] = [];
	        for (var i = 0, len = this.$watched.length; i < len; i++) {
	          this.$watched[i].style.height = 'auto';
	          //maybe could use this.$watched[i].offsetTop
	          var elOffsetTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$watched[i]).offset().top;
	          if (elOffsetTop != lastElTopOffset) {
	            group++;
	            groups[group] = [];
	            lastElTopOffset = elOffsetTop;
	          }
	          groups[group].push([this.$watched[i], this.$watched[i].offsetHeight]);
	        }
	
	        for (var j = 0, ln = groups.length; j < ln; j++) {
	          var heights = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(groups[j]).map(function () {
	            return this[1];
	          }).get();
	          var max = Math.max.apply(null, heights);
	          groups[j].push(max);
	        }
	        cb(groups);
	      }
	
	      /**
	       * Changes the CSS height property of each child in an Equalizer parent to match the tallest
	       * @param {array} heights - An array of heights of children within Equalizer container
	       * @fires Equalizer#preequalized
	       * @fires Equalizer#postequalized
	       */
	
	    }, {
	      key: 'applyHeight',
	      value: function applyHeight(heights) {
	        var max = Math.max.apply(null, heights);
	        /**
	         * Fires before the heights are applied
	         * @event Equalizer#preequalized
	         */
	        this.$element.trigger('preequalized.zf.equalizer');
	
	        this.$watched.css('height', max);
	
	        /**
	         * Fires when the heights have been applied
	         * @event Equalizer#postequalized
	         */
	        this.$element.trigger('postequalized.zf.equalizer');
	      }
	
	      /**
	       * Changes the CSS height property of each child in an Equalizer parent to match the tallest by row
	       * @param {array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
	       * @fires Equalizer#preequalized
	       * @fires Equalizer#preequalizedrow
	       * @fires Equalizer#postequalizedrow
	       * @fires Equalizer#postequalized
	       */
	
	    }, {
	      key: 'applyHeightByRow',
	      value: function applyHeightByRow(groups) {
	        /**
	         * Fires before the heights are applied
	         */
	        this.$element.trigger('preequalized.zf.equalizer');
	        for (var i = 0, len = groups.length; i < len; i++) {
	          var groupsILength = groups[i].length,
	              max = groups[i][groupsILength - 1];
	          if (groupsILength <= 2) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(groups[i][0][0]).css({ 'height': 'auto' });
	            continue;
	          }
	          /**
	            * Fires before the heights per row are applied
	            * @event Equalizer#preequalizedrow
	            */
	          this.$element.trigger('preequalizedrow.zf.equalizer');
	          for (var j = 0, lenJ = groupsILength - 1; j < lenJ; j++) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(groups[i][j][0]).css({ 'height': max });
	          }
	          /**
	            * Fires when the heights per row have been applied
	            * @event Equalizer#postequalizedrow
	            */
	          this.$element.trigger('postequalizedrow.zf.equalizer');
	        }
	        /**
	         * Fires when the heights have been applied
	         */
	        this.$element.trigger('postequalized.zf.equalizer');
	      }
	
	      /**
	       * Destroys an instance of Equalizer.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this._pauseEvents();
	        this.$watched.css('height', 'auto');
	      }
	    }]);
	
	    return Equalizer;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin
	   */
	
	  Equalizer.defaults = {
	    /**
	     * Enable height equalization when stacked on smaller screens.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    equalizeOnStack: false,
	    /**
	     * Enable height equalization row by row.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    equalizeByRow: false,
	    /**
	     * String representing the minimum breakpoint size the plugin should equalize heights on.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    equalizeOn: ''
	  };
	
	  /***/
	},
	/* 24 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Interchange;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Interchange module.
	   * @module foundation.interchange
	   * @requires foundation.util.mediaQuery
	   */
	
	  var Interchange = function (_Plugin) {
	    _inherits(Interchange, _Plugin);
	
	    function Interchange() {
	      _classCallCheck(this, Interchange);
	
	      return _possibleConstructorReturn(this, (Interchange.__proto__ || (0, _getPrototypeOf2.default)(Interchange)).apply(this, arguments));
	    }
	
	    _createClass(Interchange, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Interchange.
	       * @class
	       * @name Interchange
	       * @fires Interchange#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Interchange.defaults, options);
	        this.rules = [];
	        this.currentPath = '';
	        this.className = 'Interchange'; // ie9 back compat
	
	        this._init();
	        this._events();
	      }
	
	      /**
	       * Initializes the Interchange plugin and calls functions to get interchange functioning on load.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	
	        var id = this.$element[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'interchange');
	        this.$element.attr({
	          'data-resize': id,
	          'id': id
	        });
	
	        this._addBreakpoints();
	        this._generateRules();
	        this._reflow();
	      }
	
	      /**
	       * Initializes events for Interchange.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this3 = this;
	
	        this.$element.off('resizeme.zf.trigger').on('resizeme.zf.trigger', function () {
	          return _this3._reflow();
	        });
	      }
	
	      /**
	       * Calls necessary functions to update Interchange upon DOM change
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_reflow',
	      value: function _reflow() {
	        var match;
	
	        // Iterate through each rule, but only save the last match
	        for (var i in this.rules) {
	          if (this.rules.hasOwnProperty(i)) {
	            var rule = this.rules[i];
	            if (window.matchMedia(rule.query).matches) {
	              match = rule;
	            }
	          }
	        }
	
	        if (match) {
	          this.replace(match.path);
	        }
	      }
	
	      /**
	       * Gets the Foundation breakpoints and adds them to the Interchange.SPECIAL_QUERIES object.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_addBreakpoints',
	      value: function _addBreakpoints() {
	        for (var i in __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].queries) {
	          if (__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].queries.hasOwnProperty(i)) {
	            var query = __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].queries[i];
	            Interchange.SPECIAL_QUERIES[query.name] = query.value;
	          }
	        }
	      }
	
	      /**
	       * Checks the Interchange element for the provided media query + content pairings
	       * @function
	       * @private
	       * @param {Object} element - jQuery object that is an Interchange instance
	       * @returns {Array} scenarios - Array of objects that have 'mq' and 'path' keys with corresponding keys
	       */
	
	    }, {
	      key: '_generateRules',
	      value: function _generateRules(element) {
	        var rulesList = [];
	        var rules;
	
	        if (this.options.rules) {
	          rules = this.options.rules;
	        } else {
	          rules = this.$element.data('interchange');
	        }
	
	        rules = typeof rules === 'string' ? rules.match(/\[.*?\]/g) : rules;
	
	        for (var i in rules) {
	          if (rules.hasOwnProperty(i)) {
	            var rule = rules[i].slice(1, -1).split(', ');
	            var path = rule.slice(0, -1).join('');
	            var query = rule[rule.length - 1];
	
	            if (Interchange.SPECIAL_QUERIES[query]) {
	              query = Interchange.SPECIAL_QUERIES[query];
	            }
	
	            rulesList.push({
	              path: path,
	              query: query
	            });
	          }
	        }
	
	        this.rules = rulesList;
	      }
	
	      /**
	       * Update the `src` property of an image, or change the HTML of a container, to the specified path.
	       * @function
	       * @param {String} path - Path to the image or HTML partial.
	       * @fires Interchange#replaced
	       */
	
	    }, {
	      key: 'replace',
	      value: function replace(path) {
	        if (this.currentPath === path) return;
	
	        var _this = this,
	            trigger = 'replaced.zf.interchange';
	
	        // Replacing images
	        if (this.$element[0].nodeName === 'IMG') {
	          this.$element.attr('src', path).on('load', function () {
	            _this.currentPath = path;
	          }).trigger(trigger);
	        }
	        // Replacing background images
	        else if (path.match(/\.(gif|jpg|jpeg|png|svg|tiff)([?#].*)?/i)) {
	            path = path.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            this.$element.css({ 'background-image': 'url(' + path + ')' }).trigger(trigger);
	          }
	          // Replacing HTML
	          else {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(path, function (response) {
	                _this.$element.html(response).trigger(trigger);
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(response).foundation();
	                _this.currentPath = path;
	              });
	            }
	
	        /**
	         * Fires when content in an Interchange element is done being loaded.
	         * @event Interchange#replaced
	         */
	        // this.$element.trigger('replaced.zf.interchange');
	      }
	
	      /**
	       * Destroys an instance of interchange.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('resizeme.zf.trigger');
	      }
	    }]);
	
	    return Interchange;
	  }(__WEBPACK_IMPORTED_MODULE_2__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin
	   */
	
	  Interchange.defaults = {
	    /**
	     * Rules to be applied to Interchange elements. Set with the `data-interchange` array notation.
	     * @option
	     * @type {?array}
	     * @default null
	     */
	    rules: null
	  };
	
	  Interchange.SPECIAL_QUERIES = {
	    'landscape': 'screen and (orientation: landscape)',
	    'portrait': 'screen and (orientation: portrait)',
	    'retina': 'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)'
	  };
	
	  /***/
	},
	/* 25 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Magellan;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_smoothScroll__ = __webpack_require__(16);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Magellan module.
	   * @module foundation.magellan
	   * @requires foundation.smoothScroll
	   */
	
	  var Magellan = function (_Plugin) {
	    _inherits(Magellan, _Plugin);
	
	    function Magellan() {
	      _classCallCheck(this, Magellan);
	
	      return _possibleConstructorReturn(this, (Magellan.__proto__ || (0, _getPrototypeOf2.default)(Magellan)).apply(this, arguments));
	    }
	
	    _createClass(Magellan, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Magellan.
	       * @class
	       * @name Magellan
	       * @fires Magellan#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Magellan.defaults, this.$element.data(), options);
	        this.className = 'Magellan'; // ie9 back compat
	
	        this._init();
	        this.calcPoints();
	      }
	
	      /**
	       * Initializes the Magellan plugin and calls functions to get equalizer functioning on load.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var id = this.$element[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, 'magellan');
	        var _this = this;
	        this.$targets = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-magellan-target]');
	        this.$links = this.$element.find('a');
	        this.$element.attr({
	          'data-resize': id,
	          'data-scroll': id,
	          'id': id
	        });
	        this.$active = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
	        this.scrollPos = parseInt(window.pageYOffset, 10);
	
	        this._events();
	      }
	
	      /**
	       * Calculates an array of pixel values that are the demarcation lines between locations on the page.
	       * Can be invoked if new elements are added or the size of a location changes.
	       * @function
	       */
	
	    }, {
	      key: 'calcPoints',
	      value: function calcPoints() {
	        var _this = this,
	            body = document.body,
	            html = document.documentElement;
	
	        this.points = [];
	        this.winHeight = Math.round(Math.max(window.innerHeight, html.clientHeight));
	        this.docHeight = Math.round(Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight));
	
	        this.$targets.each(function () {
	          var $tar = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              pt = Math.round($tar.offset().top - _this.options.threshold);
	          $tar.targetPoint = pt;
	          _this.points.push(pt);
	        });
	      }
	
	      /**
	       * Initializes events for Magellan.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this,
	            $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body'),
	            opts = {
	          duration: _this.options.animationDuration,
	          easing: _this.options.animationEasing
	        };
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).one('load', function () {
	          if (_this.options.deepLinking) {
	            if (location.hash) {
	              _this.scrollToLoc(location.hash);
	            }
	          }
	          _this.calcPoints();
	          _this._updateActive();
	        });
	
	        this.$element.on({
	          'resizeme.zf.trigger': this.reflow.bind(this),
	          'scrollme.zf.trigger': this._updateActive.bind(this)
	        }).on('click.zf.magellan', 'a[href^="#"]', function (e) {
	          e.preventDefault();
	          var arrival = this.getAttribute('href');
	          _this.scrollToLoc(arrival);
	        });
	
	        this._deepLinkScroll = function (e) {
	          if (_this.options.deepLinking) {
	            _this.scrollToLoc(window.location.hash);
	          }
	        };
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('popstate', this._deepLinkScroll);
	      }
	
	      /**
	       * Function to scroll to a given location on the page.
	       * @param {String} loc - a properly formatted jQuery id selector. Example: '#foo'
	       * @function
	       */
	
	    }, {
	      key: 'scrollToLoc',
	      value: function scrollToLoc(loc) {
	        this._inTransition = true;
	        var _this = this;
	
	        var options = {
	          animationEasing: this.options.animationEasing,
	          animationDuration: this.options.animationDuration,
	          threshold: this.options.threshold,
	          offset: this.options.offset
	        };
	
	        __WEBPACK_IMPORTED_MODULE_3__foundation_smoothScroll__["a" /* SmoothScroll */].scrollToLoc(loc, options, function () {
	          _this._inTransition = false;
	          _this._updateActive();
	        });
	      }
	
	      /**
	       * Calls necessary functions to update Magellan upon DOM change
	       * @function
	       */
	
	    }, {
	      key: 'reflow',
	      value: function reflow() {
	        this.calcPoints();
	        this._updateActive();
	      }
	
	      /**
	       * Updates the visibility of an active location link, and updates the url hash for the page, if deepLinking enabled.
	       * @private
	       * @function
	       * @fires Magellan#update
	       */
	
	    }, {
	      key: '_updateActive',
	      value: function _updateActive() /*evt, elem, scrollPos*/{
	        if (this._inTransition) {
	          return;
	        }
	        var winPos = /*scrollPos ||*/parseInt(window.pageYOffset, 10),
	            curIdx;
	
	        if (winPos + this.winHeight === this.docHeight) {
	          curIdx = this.points.length - 1;
	        } else if (winPos < this.points[0]) {
	          curIdx = undefined;
	        } else {
	          var isDown = this.scrollPos < winPos,
	              _this = this,
	              curVisible = this.points.filter(function (p, i) {
	            return isDown ? p - _this.options.offset <= winPos : p - _this.options.offset - _this.options.threshold <= winPos;
	          });
	          curIdx = curVisible.length ? curVisible.length - 1 : 0;
	        }
	
	        this.$active.removeClass(this.options.activeClass);
	        this.$active = this.$links.filter('[href="#' + this.$targets.eq(curIdx).data('magellan-target') + '"]').addClass(this.options.activeClass);
	
	        if (this.options.deepLinking) {
	          var hash = "";
	          if (curIdx != undefined) {
	            hash = this.$active[0].getAttribute('href');
	          }
	          if (hash !== window.location.hash) {
	            if (window.history.pushState) {
	              window.history.pushState(null, null, hash);
	            } else {
	              window.location.hash = hash;
	            }
	          }
	        }
	
	        this.scrollPos = winPos;
	        /**
	         * Fires when magellan is finished updating to the new active element.
	         * @event Magellan#update
	         */
	        this.$element.trigger('update.zf.magellan', [this.$active]);
	      }
	
	      /**
	       * Destroys an instance of Magellan and resets the url of the window.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('.zf.trigger .zf.magellan').find('.' + this.options.activeClass).removeClass(this.options.activeClass);
	
	        if (this.options.deepLinking) {
	          var hash = this.$active[0].getAttribute('href');
	          window.location.hash.replace(hash, '');
	        }
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('popstate', this._deepLinkScroll);
	      }
	    }]);
	
	    return Magellan;
	  }(__WEBPACK_IMPORTED_MODULE_2__foundation_plugin__["a" /* Plugin */]);
	
	  /**
	   * Default settings for plugin
	   */
	
	  Magellan.defaults = {
	    /**
	     * Amount of time, in ms, the animated scrolling should take between locations.
	     * @option
	     * @type {number}
	     * @default 500
	     */
	    animationDuration: 500,
	    /**
	     * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
	     * @option
	     * @type {string}
	     * @default 'linear'
	     * @see {@link https://api.jquery.com/animate|Jquery animate}
	     */
	    animationEasing: 'linear',
	    /**
	     * Number of pixels to use as a marker for location changes.
	     * @option
	     * @type {number}
	     * @default 50
	     */
	    threshold: 50,
	    /**
	     * Class applied to the active locations link on the magellan container.
	     * @option
	     * @type {string}
	     * @default 'is-active'
	     */
	    activeClass: 'is-active',
	    /**
	     * Allows the script to manipulate the url of the current page, and if supported, alter the history.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLinking: false,
	    /**
	     * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    offset: 0
	  };
	
	  /***/
	},
	/* 26 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return OffCanvas;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * OffCanvas module.
	   * @module foundation.offcanvas
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.triggers
	   */
	
	  var OffCanvas = function (_Plugin) {
	    _inherits(OffCanvas, _Plugin);
	
	    function OffCanvas() {
	      _classCallCheck(this, OffCanvas);
	
	      return _possibleConstructorReturn(this, (OffCanvas.__proto__ || (0, _getPrototypeOf2.default)(OffCanvas)).apply(this, arguments));
	    }
	
	    _createClass(OffCanvas, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of an off-canvas wrapper.
	       * @class
	       * @name OffCanvas
	       * @fires OffCanvas#init
	       * @param {Object} element - jQuery object to initialize.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        var _this3 = this;
	
	        this.className = 'OffCanvas'; // ie9 back compat
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, OffCanvas.defaults, this.$element.data(), options);
	        this.contentClasses = { base: [], reveal: [] };
	        this.$lastTrigger = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
	        this.$triggers = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
	        this.position = 'left';
	        this.$content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
	        this.nested = !!this.options.nested;
	
	        // Defines the CSS transition/position classes of the off-canvas content container.
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(['push', 'overlap']).each(function (index, val) {
	          _this3.contentClasses.base.push('has-transition-' + val);
	        });
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(['left', 'right', 'top', 'bottom']).each(function (index, val) {
	          _this3.contentClasses.base.push('has-position-' + val);
	          _this3.contentClasses.reveal.push('has-reveal-' + val);
	        });
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_5__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	
	        this._init();
	        this._events();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('OffCanvas', {
	          'ESCAPE': 'close'
	        });
	      }
	
	      /**
	       * Initializes the off-canvas wrapper by adding the exit overlay (if needed).
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var id = this.$element.attr('id');
	
	        this.$element.attr('aria-hidden', 'true');
	
	        // Find off-canvas content, either by ID (if specified), by siblings or by closest selector (fallback)
	        if (this.options.contentId) {
	          this.$content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + this.options.contentId);
	        } else if (this.$element.siblings('[data-off-canvas-content]').length) {
	          this.$content = this.$element.siblings('[data-off-canvas-content]').first();
	        } else {
	          this.$content = this.$element.closest('[data-off-canvas-content]').first();
	        }
	
	        if (!this.options.contentId) {
	          // Assume that the off-canvas element is nested if it isn't a sibling of the content
	          this.nested = this.$element.siblings('[data-off-canvas-content]').length === 0;
	        } else if (this.options.contentId && this.options.nested === null) {
	          // Warning if using content ID without setting the nested option
	          // Once the element is nested it is required to work properly in this case
	          console.warn('Remember to use the nested option if using the content ID option!');
	        }
	
	        if (this.nested === true) {
	          // Force transition overlap if nested
	          this.options.transition = 'overlap';
	          // Remove appropriate classes if already assigned in markup
	          this.$element.removeClass('is-transition-push');
	        }
	
	        this.$element.addClass('is-transition-' + this.options.transition + ' is-closed');
	
	        // Find triggers that affect this element and add aria-expanded to them
	        this.$triggers = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-expanded', 'false').attr('aria-controls', id);
	
	        // Get position by checking for related CSS class
	        this.position = this.$element.is('.position-left, .position-top, .position-right, .position-bottom') ? this.$element.attr('class').match(/position\-(left|top|right|bottom)/)[1] : this.position;
	
	        // Add an overlay over the content if necessary
	        if (this.options.contentOverlay === true) {
	          var overlay = document.createElement('div');
	          var overlayPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$element).css("position") === 'fixed' ? 'is-overlay-fixed' : 'is-overlay-absolute';
	          overlay.setAttribute('class', 'js-off-canvas-overlay ' + overlayPosition);
	          this.$overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(overlay);
	          if (overlayPosition === 'is-overlay-fixed') {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$overlay).insertAfter(this.$element);
	          } else {
	            this.$content.append(this.$overlay);
	          }
	        }
	
	        this.options.isRevealed = this.options.isRevealed || new RegExp(this.options.revealClass, 'g').test(this.$element[0].className);
	
	        if (this.options.isRevealed === true) {
	          this.options.revealOn = this.options.revealOn || this.$element[0].className.match(/(reveal-for-medium|reveal-for-large)/g)[0].split('-')[2];
	          this._setMQChecker();
	        }
	
	        if (this.options.transitionTime) {
	          this.$element.css('transition-duration', this.options.transitionTime);
	        }
	
	        // Initally remove all transition/position CSS classes from off-canvas content container.
	        this._removeContentClasses();
	      }
	
	      /**
	       * Adds event handlers to the off-canvas wrapper and the exit overlay.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        this.$element.off('.zf.trigger .zf.offcanvas').on({
	          'open.zf.trigger': this.open.bind(this),
	          'close.zf.trigger': this.close.bind(this),
	          'toggle.zf.trigger': this.toggle.bind(this),
	          'keydown.zf.offcanvas': this._handleKeyboard.bind(this)
	        });
	
	        if (this.options.closeOnClick === true) {
	          var $target = this.options.contentOverlay ? this.$overlay : this.$content;
	          $target.on({ 'click.zf.offcanvas': this.close.bind(this) });
	        }
	      }
	
	      /**
	       * Applies event listener for elements that will reveal at certain breakpoints.
	       * @private
	       */
	
	    }, {
	      key: '_setMQChecker',
	      value: function _setMQChecker() {
	        var _this = this;
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', function () {
	          if (__WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(_this.options.revealOn)) {
	            _this.reveal(true);
	          } else {
	            _this.reveal(false);
	          }
	        }).one('load.zf.offcanvas', function () {
	          if (__WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(_this.options.revealOn)) {
	            _this.reveal(true);
	          }
	        });
	      }
	
	      /**
	       * Removes the CSS transition/position classes of the off-canvas content container.
	       * Removing the classes is important when another off-canvas gets opened that uses the same content container.
	       * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
	       * @private
	       */
	
	    }, {
	      key: '_removeContentClasses',
	      value: function _removeContentClasses(hasReveal) {
	        if (typeof hasReveal !== 'boolean') {
	          this.$content.removeClass(this.contentClasses.base.join(' '));
	        } else if (hasReveal === false) {
	          this.$content.removeClass('has-reveal-' + this.position);
	        }
	      }
	
	      /**
	       * Adds the CSS transition/position classes of the off-canvas content container, based on the opening off-canvas element.
	       * Beforehand any transition/position class gets removed.
	       * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
	       * @private
	       */
	
	    }, {
	      key: '_addContentClasses',
	      value: function _addContentClasses(hasReveal) {
	        this._removeContentClasses(hasReveal);
	        if (typeof hasReveal !== 'boolean') {
	          this.$content.addClass('has-transition-' + this.options.transition + ' has-position-' + this.position);
	        } else if (hasReveal === true) {
	          this.$content.addClass('has-reveal-' + this.position);
	        }
	      }
	
	      /**
	       * Handles the revealing/hiding the off-canvas at breakpoints, not the same as open.
	       * @param {Boolean} isRevealed - true if element should be revealed.
	       * @function
	       */
	
	    }, {
	      key: 'reveal',
	      value: function reveal(isRevealed) {
	        if (isRevealed) {
	          this.close();
	          this.isRevealed = true;
	          this.$element.attr('aria-hidden', 'false');
	          this.$element.off('open.zf.trigger toggle.zf.trigger');
	          this.$element.removeClass('is-closed');
	        } else {
	          this.isRevealed = false;
	          this.$element.attr('aria-hidden', 'true');
	          this.$element.off('open.zf.trigger toggle.zf.trigger').on({
	            'open.zf.trigger': this.open.bind(this),
	            'toggle.zf.trigger': this.toggle.bind(this)
	          });
	          this.$element.addClass('is-closed');
	        }
	        this._addContentClasses(isRevealed);
	      }
	
	      /**
	       * Stops scrolling of the body when offcanvas is open on mobile Safari and other troublesome browsers.
	       * @private
	       */
	
	    }, {
	      key: '_stopScrolling',
	      value: function _stopScrolling(event) {
	        return false;
	      }
	
	      // Taken and adapted from http://stackoverflow.com/questions/16889447/prevent-full-page-scrolling-ios
	      // Only really works for y, not sure how to extend to x or if we need to.
	
	    }, {
	      key: '_recordScrollable',
	      value: function _recordScrollable(event) {
	        var elem = this; // called from event handler context with this as elem
	
	        // If the element is scrollable (content overflows), then...
	        if (elem.scrollHeight !== elem.clientHeight) {
	          // If we're at the top, scroll down one pixel to allow scrolling up
	          if (elem.scrollTop === 0) {
	            elem.scrollTop = 1;
	          }
	          // If we're at the bottom, scroll up one pixel to allow scrolling down
	          if (elem.scrollTop === elem.scrollHeight - elem.clientHeight) {
	            elem.scrollTop = elem.scrollHeight - elem.clientHeight - 1;
	          }
	        }
	        elem.allowUp = elem.scrollTop > 0;
	        elem.allowDown = elem.scrollTop < elem.scrollHeight - elem.clientHeight;
	        elem.lastY = event.originalEvent.pageY;
	      }
	    }, {
	      key: '_stopScrollPropagation',
	      value: function _stopScrollPropagation(event) {
	        var elem = this; // called from event handler context with this as elem
	        var up = event.pageY < elem.lastY;
	        var down = !up;
	        elem.lastY = event.pageY;
	
	        if (up && elem.allowUp || down && elem.allowDown) {
	          event.stopPropagation();
	        } else {
	          event.preventDefault();
	        }
	      }
	
	      /**
	       * Opens the off-canvas menu.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       * @fires OffCanvas#opened
	       */
	
	    }, {
	      key: 'open',
	      value: function open(event, trigger) {
	        if (this.$element.hasClass('is-open') || this.isRevealed) {
	          return;
	        }
	        var _this = this;
	
	        if (trigger) {
	          this.$lastTrigger = trigger;
	        }
	
	        if (this.options.forceTo === 'top') {
	          window.scrollTo(0, 0);
	        } else if (this.options.forceTo === 'bottom') {
	          window.scrollTo(0, document.body.scrollHeight);
	        }
	
	        if (this.options.transitionTime && this.options.transition !== 'overlap') {
	          this.$element.siblings('[data-off-canvas-content]').css('transition-duration', this.options.transitionTime);
	        } else {
	          this.$element.siblings('[data-off-canvas-content]').css('transition-duration', '');
	        }
	
	        /**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#opened
	         */
	        this.$element.addClass('is-open').removeClass('is-closed');
	
	        this.$triggers.attr('aria-expanded', 'true');
	        this.$element.attr('aria-hidden', 'false').trigger('opened.zf.offcanvas');
	
	        this.$content.addClass('is-open-' + this.position);
	
	        // If `contentScroll` is set to false, add class and disable scrolling on touch devices.
	        if (this.options.contentScroll === false) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('is-off-canvas-open').on('touchmove', this._stopScrolling);
	          this.$element.on('touchstart', this._recordScrollable);
	          this.$element.on('touchmove', this._stopScrollPropagation);
	        }
	
	        if (this.options.contentOverlay === true) {
	          this.$overlay.addClass('is-visible');
	        }
	
	        if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
	          this.$overlay.addClass('is-closable');
	        }
	
	        if (this.options.autoFocus === true) {
	          this.$element.one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])(this.$element), function () {
	            if (!_this.$element.hasClass('is-open')) {
	              return; // exit if prematurely closed
	            }
	            var canvasFocus = _this.$element.find('[data-autofocus]');
	            if (canvasFocus.length) {
	              canvasFocus.eq(0).focus();
	            } else {
	              _this.$element.find('a, button').eq(0).focus();
	            }
	          });
	        }
	
	        if (this.options.trapFocus === true) {
	          this.$content.attr('tabindex', '-1');
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].trapFocus(this.$element);
	        }
	
	        this._addContentClasses();
	      }
	
	      /**
	       * Closes the off-canvas menu.
	       * @function
	       * @param {Function} cb - optional cb to fire after closure.
	       * @fires OffCanvas#closed
	       */
	
	    }, {
	      key: 'close',
	      value: function close(cb) {
	        if (!this.$element.hasClass('is-open') || this.isRevealed) {
	          return;
	        }
	
	        var _this = this;
	
	        this.$element.removeClass('is-open');
	
	        this.$element.attr('aria-hidden', 'true')
	        /**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#closed
	         */
	        .trigger('closed.zf.offcanvas');
	
	        this.$content.removeClass('is-open-left is-open-top is-open-right is-open-bottom');
	
	        // If `contentScroll` is set to false, remove class and re-enable scrolling on touch devices.
	        if (this.options.contentScroll === false) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('is-off-canvas-open').off('touchmove', this._stopScrolling);
	          this.$element.off('touchstart', this._recordScrollable);
	          this.$element.off('touchmove', this._stopScrollPropagation);
	        }
	
	        if (this.options.contentOverlay === true) {
	          this.$overlay.removeClass('is-visible');
	        }
	
	        if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
	          this.$overlay.removeClass('is-closable');
	        }
	
	        this.$triggers.attr('aria-expanded', 'false');
	
	        if (this.options.trapFocus === true) {
	          this.$content.removeAttr('tabindex');
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].releaseFocus(this.$element);
	        }
	
	        // Listen to transitionEnd and add class when done.
	        this.$element.one(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["c" /* transitionend */])(this.$element), function (e) {
	          _this.$element.addClass('is-closed');
	          _this._removeContentClasses();
	        });
	      }
	
	      /**
	       * Toggles the off-canvas menu open or closed.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle(event, trigger) {
	        if (this.$element.hasClass('is-open')) {
	          this.close(event, trigger);
	        } else {
	          this.open(event, trigger);
	        }
	      }
	
	      /**
	       * Handles keyboard input when detected. When the escape key is pressed, the off-canvas menu closes, and focus is restored to the element that opened the menu.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_handleKeyboard',
	      value: function _handleKeyboard(e) {
	        var _this4 = this;
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'OffCanvas', {
	          close: function close() {
	            _this4.close();
	            _this4.$lastTrigger.focus();
	            return true;
	          },
	          handled: function handled() {
	            e.stopPropagation();
	            e.preventDefault();
	          }
	        });
	      }
	
	      /**
	       * Destroys the offcanvas plugin.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.close();
	        this.$element.off('.zf.trigger .zf.offcanvas');
	        this.$overlay.off('.zf.offcanvas');
	      }
	    }]);
	
	    return OffCanvas;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_plugin__["a" /* Plugin */]);
	
	  OffCanvas.defaults = {
	    /**
	     * Allow the user to click outside of the menu to close it.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnClick: true,
	
	    /**
	     * Adds an overlay on top of `[data-off-canvas-content]`.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    contentOverlay: true,
	
	    /**
	     * Target an off-canvas content container by ID that may be placed anywhere. If null the closest content container will be taken.
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    contentId: null,
	
	    /**
	     * Define the off-canvas element is nested in an off-canvas content. This is required when using the contentId option for a nested element.
	     * @option
	     * @type {boolean}
	     * @default null
	     */
	    nested: null,
	
	    /**
	     * Enable/disable scrolling of the main content when an off canvas panel is open.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    contentScroll: true,
	
	    /**
	     * Amount of time in ms the open and close transition requires. If none selected, pulls from body style.
	     * @option
	     * @type {number}
	     * @default null
	     */
	    transitionTime: null,
	
	    /**
	     * Type of transition for the offcanvas menu. Options are 'push', 'detached' or 'slide'.
	     * @option
	     * @type {string}
	     * @default push
	     */
	    transition: 'push',
	
	    /**
	     * Force the page to scroll to top or bottom on open.
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    forceTo: null,
	
	    /**
	     * Allow the offcanvas to remain open for certain breakpoints.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    isRevealed: false,
	
	    /**
	     * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    revealOn: null,
	
	    /**
	     * Force focus to the offcanvas on open. If true, will focus the opening trigger on close.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    autoFocus: true,
	
	    /**
	     * Class used to force an offcanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
	     * @option
	     * @type {string}
	     * @default reveal-for-
	     * @todo improve the regex testing for this.
	     */
	    revealClass: 'reveal-for-',
	
	    /**
	     * Triggers optional focus trapping when opening an offcanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    trapFocus: false
	  };
	
	  /***/
	},
	/* 27 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Orbit;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_timer__ = __webpack_require__(18);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_imageLoader__ = __webpack_require__(8);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__foundation_util_touch__ = __webpack_require__(10);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Orbit module.
	   * @module foundation.orbit
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.motion
	   * @requires foundation.util.timer
	   * @requires foundation.util.imageLoader
	   * @requires foundation.util.touch
	   */
	
	  var Orbit = function (_Plugin) {
	    _inherits(Orbit, _Plugin);
	
	    function Orbit() {
	      _classCallCheck(this, Orbit);
	
	      return _possibleConstructorReturn(this, (Orbit.__proto__ || (0, _getPrototypeOf2.default)(Orbit)).apply(this, arguments));
	    }
	
	    _createClass(Orbit, [{
	      key: '_setup',
	
	      /**
	      * Creates a new instance of an orbit carousel.
	      * @class
	      * @name Orbit
	      * @param {jQuery} element - jQuery object to make into an Orbit Carousel.
	      * @param {Object} options - Overrides to the default plugin settings.
	      */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Orbit.defaults, this.$element.data(), options);
	        this.className = 'Orbit'; // ie9 back compat
	
	        __WEBPACK_IMPORTED_MODULE_7__foundation_util_touch__["a" /* Touch */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a); // Touch init is idempotent, we just need to make sure it's initialied.
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Orbit', {
	          'ltr': {
	            'ARROW_RIGHT': 'next',
	            'ARROW_LEFT': 'previous'
	          },
	          'rtl': {
	            'ARROW_LEFT': 'next',
	            'ARROW_RIGHT': 'previous'
	          }
	        });
	      }
	
	      /**
	      * Initializes the plugin by creating jQuery collections, setting attributes, and starting the animation.
	      * @function
	      * @private
	      */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        // @TODO: consider discussion on PR #9278 about DOM pollution by changeSlide
	        this._reset();
	
	        this.$wrapper = this.$element.find('.' + this.options.containerClass);
	        this.$slides = this.$element.find('.' + this.options.slideClass);
	
	        var $images = this.$element.find('img'),
	            initActive = this.$slides.filter('.is-active'),
	            id = this.$element[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__foundation_util_core__["b" /* GetYoDigits */])(6, 'orbit');
	
	        this.$element.attr({
	          'data-resize': id,
	          'id': id
	        });
	
	        if (!initActive.length) {
	          this.$slides.eq(0).addClass('is-active');
	        }
	
	        if (!this.options.useMUI) {
	          this.$slides.addClass('no-motionui');
	        }
	
	        if ($images.length) {
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__foundation_util_imageLoader__["a" /* onImagesLoaded */])($images, this._prepareForOrbit.bind(this));
	        } else {
	          this._prepareForOrbit(); //hehe
	        }
	
	        if (this.options.bullets) {
	          this._loadBullets();
	        }
	
	        this._events();
	
	        if (this.options.autoPlay && this.$slides.length > 1) {
	          this.geoSync();
	        }
	
	        if (this.options.accessible) {
	          // allow wrapper to be focusable to enable arrow navigation
	          this.$wrapper.attr('tabindex', 0);
	        }
	      }
	
	      /**
	      * Creates a jQuery collection of bullets, if they are being used.
	      * @function
	      * @private
	      */
	
	    }, {
	      key: '_loadBullets',
	      value: function _loadBullets() {
	        this.$bullets = this.$element.find('.' + this.options.boxOfBullets).find('button');
	      }
	
	      /**
	      * Sets a `timer` object on the orbit, and starts the counter for the next slide.
	      * @function
	      */
	
	    }, {
	      key: 'geoSync',
	      value: function geoSync() {
	        var _this = this;
	        this.timer = new __WEBPACK_IMPORTED_MODULE_3__foundation_util_timer__["a" /* Timer */](this.$element, {
	          duration: this.options.timerDelay,
	          infinite: false
	        }, function () {
	          _this.changeSlide(true);
	        });
	        this.timer.start();
	      }
	
	      /**
	      * Sets wrapper and slide heights for the orbit.
	      * @function
	      * @private
	      */
	
	    }, {
	      key: '_prepareForOrbit',
	      value: function _prepareForOrbit() {
	        var _this = this;
	        this._setWrapperHeight();
	      }
	
	      /**
	      * Calulates the height of each slide in the collection, and uses the tallest one for the wrapper height.
	      * @function
	      * @private
	      * @param {Function} cb - a callback function to fire when complete.
	      */
	
	    }, {
	      key: '_setWrapperHeight',
	      value: function _setWrapperHeight(cb) {
	        //rewrite this to `for` loop
	        var max = 0,
	            temp,
	            counter = 0,
	            _this = this;
	
	        this.$slides.each(function () {
	          temp = this.getBoundingClientRect().height;
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-slide', counter);
	
	          if (!/mui/g.test(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)[0].className) && _this.$slides.filter('.is-active')[0] !== _this.$slides.eq(counter)[0]) {
	            //if not the active slide, set css position and display property
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css({ 'position': 'relative', 'display': 'none' });
	          }
	          max = temp > max ? temp : max;
	          counter++;
	        });
	
	        if (counter === this.$slides.length) {
	          this.$wrapper.css({ 'height': max }); //only change the wrapper height property once.
	          if (cb) {
	            cb(max);
	          } //fire callback with max height dimension.
	        }
	      }
	
	      /**
	      * Sets the max-height of each slide.
	      * @function
	      * @private
	      */
	
	    }, {
	      key: '_setSlideHeight',
	      value: function _setSlideHeight(height) {
	        this.$slides.each(function () {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css('max-height', height);
	        });
	      }
	
	      /**
	      * Adds event listeners to basically everything within the element.
	      * @function
	      * @private
	      */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        //***************************************
	        //**Now using custom event - thanks to:**
	        //**      Yohai Ararat of Toronto      **
	        //***************************************
	        //
	        this.$element.off('.resizeme.zf.trigger').on({
	          'resizeme.zf.trigger': this._prepareForOrbit.bind(this)
	        });
	        if (this.$slides.length > 1) {
	
	          if (this.options.swipe) {
	            this.$slides.off('swipeleft.zf.orbit swiperight.zf.orbit').on('swipeleft.zf.orbit', function (e) {
	              e.preventDefault();
	              _this.changeSlide(true);
	            }).on('swiperight.zf.orbit', function (e) {
	              e.preventDefault();
	              _this.changeSlide(false);
	            });
	          }
	          //***************************************
	
	          if (this.options.autoPlay) {
	            this.$slides.on('click.zf.orbit', function () {
	              _this.$element.data('clickedOn', _this.$element.data('clickedOn') ? false : true);
	              _this.timer[_this.$element.data('clickedOn') ? 'pause' : 'start']();
	            });
	
	            if (this.options.pauseOnHover) {
	              this.$element.on('mouseenter.zf.orbit', function () {
	                _this.timer.pause();
	              }).on('mouseleave.zf.orbit', function () {
	                if (!_this.$element.data('clickedOn')) {
	                  _this.timer.start();
	                }
	              });
	            }
	          }
	
	          if (this.options.navButtons) {
	            var $controls = this.$element.find('.' + this.options.nextClass + ', .' + this.options.prevClass);
	            $controls.attr('tabindex', 0)
	            //also need to handle enter/return and spacebar key presses
	            .on('click.zf.orbit touchend.zf.orbit', function (e) {
	              e.preventDefault();
	              _this.changeSlide(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass(_this.options.nextClass));
	            });
	          }
	
	          if (this.options.bullets) {
	            this.$bullets.on('click.zf.orbit touchend.zf.orbit', function () {
	              if (/is-active/g.test(this.className)) {
	                return false;
	              } //if this is active, kick out of function.
	              var idx = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('slide'),
	                  ltr = idx > _this.$slides.filter('.is-active').data('slide'),
	                  $slide = _this.$slides.eq(idx);
	
	              _this.changeSlide(ltr, $slide, idx);
	            });
	          }
	
	          if (this.options.accessible) {
	            this.$wrapper.add(this.$bullets).on('keydown.zf.orbit', function (e) {
	              // handle keyboard event with keyboard util
	              __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Orbit', {
	                next: function next() {
	                  _this.changeSlide(true);
	                },
	                previous: function previous() {
	                  _this.changeSlide(false);
	                },
	                handled: function handled() {
	                  // if bullet is focused, make sure focus moves
	                  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).is(_this.$bullets)) {
	                    _this.$bullets.filter('.is-active').focus();
	                  }
	                }
	              });
	            });
	          }
	        }
	      }
	
	      /**
	       * Resets Orbit so it can be reinitialized
	       */
	
	    }, {
	      key: '_reset',
	      value: function _reset() {
	        // Don't do anything if there are no slides (first run)
	        if (typeof this.$slides == 'undefined') {
	          return;
	        }
	
	        if (this.$slides.length > 1) {
	          // Remove old events
	          this.$element.off('.zf.orbit').find('*').off('.zf.orbit');
	
	          // Restart timer if autoPlay is enabled
	          if (this.options.autoPlay) {
	            this.timer.restart();
	          }
	
	          // Reset all sliddes
	          this.$slides.each(function (el) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).removeClass('is-active is-active is-in').removeAttr('aria-live').hide();
	          });
	
	          // Show the first slide
	          this.$slides.first().addClass('is-active').show();
	
	          // Triggers when the slide has finished animating
	          this.$element.trigger('slidechange.zf.orbit', [this.$slides.first()]);
	
	          // Select first bullet if bullets are present
	          if (this.options.bullets) {
	            this._updateBullets(0);
	          }
	        }
	      }
	
	      /**
	      * Changes the current slide to a new one.
	      * @function
	      * @param {Boolean} isLTR - flag if the slide should move left to right.
	      * @param {jQuery} chosenSlide - the jQuery element of the slide to show next, if one is selected.
	      * @param {Number} idx - the index of the new slide in its collection, if one chosen.
	      * @fires Orbit#slidechange
	      */
	
	    }, {
	      key: 'changeSlide',
	      value: function changeSlide(isLTR, chosenSlide, idx) {
	        if (!this.$slides) {
	          return;
	        } // Don't freak out if we're in the middle of cleanup
	        var $curSlide = this.$slides.filter('.is-active').eq(0);
	
	        if (/mui/g.test($curSlide[0].className)) {
	          return false;
	        } //if the slide is currently animating, kick out of the function
	
	        var $firstSlide = this.$slides.first(),
	            $lastSlide = this.$slides.last(),
	            dirIn = isLTR ? 'Right' : 'Left',
	            dirOut = isLTR ? 'Left' : 'Right',
	            _this = this,
	            $newSlide;
	
	        if (!chosenSlide) {
	          //most of the time, this will be auto played or clicked from the navButtons.
	          $newSlide = isLTR ? //if wrapping enabled, check to see if there is a `next` or `prev` sibling, if not, select the first or last slide to fill in. if wrapping not enabled, attempt to select `next` or `prev`, if there's nothing there, the function will kick out on next step. CRAZY NESTED TERNARIES!!!!!
	          this.options.infiniteWrap ? $curSlide.next('.' + this.options.slideClass).length ? $curSlide.next('.' + this.options.slideClass) : $firstSlide : $curSlide.next('.' + this.options.slideClass) : //pick next slide if moving left to right
	          this.options.infiniteWrap ? $curSlide.prev('.' + this.options.slideClass).length ? $curSlide.prev('.' + this.options.slideClass) : $lastSlide : $curSlide.prev('.' + this.options.slideClass); //pick prev slide if moving right to left
	        } else {
	          $newSlide = chosenSlide;
	        }
	
	        if ($newSlide.length) {
	          /**
	          * Triggers before the next slide starts animating in and only if a next slide has been found.
	          * @event Orbit#beforeslidechange
	          */
	          this.$element.trigger('beforeslidechange.zf.orbit', [$curSlide, $newSlide]);
	
	          if (this.options.bullets) {
	            idx = idx || this.$slides.index($newSlide); //grab index to update bullets
	            this._updateBullets(idx);
	          }
	
	          if (this.options.useMUI && !this.$element.is(':hidden')) {
	            __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__["a" /* Motion */].animateIn($newSlide.addClass('is-active').css({ 'position': 'absolute', 'top': 0 }), this.options['animInFrom' + dirIn], function () {
	              $newSlide.css({ 'position': 'relative', 'display': 'block' }).attr('aria-live', 'polite');
	            });
	
	            __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__["a" /* Motion */].animateOut($curSlide.removeClass('is-active'), this.options['animOutTo' + dirOut], function () {
	              $curSlide.removeAttr('aria-live');
	              if (_this.options.autoPlay && !_this.timer.isPaused) {
	                _this.timer.restart();
	              }
	              //do stuff?
	            });
	          } else {
	            $curSlide.removeClass('is-active is-in').removeAttr('aria-live').hide();
	            $newSlide.addClass('is-active is-in').attr('aria-live', 'polite').show();
	            if (this.options.autoPlay && !this.timer.isPaused) {
	              this.timer.restart();
	            }
	          }
	          /**
	          * Triggers when the slide has finished animating in.
	          * @event Orbit#slidechange
	          */
	          this.$element.trigger('slidechange.zf.orbit', [$newSlide]);
	        }
	      }
	
	      /**
	      * Updates the active state of the bullets, if displayed.
	      * @function
	      * @private
	      * @param {Number} idx - the index of the current slide.
	      */
	
	    }, {
	      key: '_updateBullets',
	      value: function _updateBullets(idx) {
	        var $oldBullet = this.$element.find('.' + this.options.boxOfBullets).find('.is-active').removeClass('is-active').blur(),
	            span = $oldBullet.find('span:last').detach(),
	            $newBullet = this.$bullets.eq(idx).addClass('is-active').append(span);
	      }
	
	      /**
	      * Destroys the carousel and hides the element.
	      * @function
	      */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('.zf.orbit').find('*').off('.zf.orbit').end().hide();
	      }
	    }]);
	
	    return Orbit;
	  }(__WEBPACK_IMPORTED_MODULE_6__foundation_plugin__["a" /* Plugin */]);
	
	  Orbit.defaults = {
	    /**
	    * Tells the JS to look for and loadBullets.
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    bullets: true,
	    /**
	    * Tells the JS to apply event listeners to nav buttons
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    navButtons: true,
	    /**
	    * motion-ui animation class to apply
	    * @option
	     * @type {string}
	    * @default 'slide-in-right'
	    */
	    animInFromRight: 'slide-in-right',
	    /**
	    * motion-ui animation class to apply
	    * @option
	     * @type {string}
	    * @default 'slide-out-right'
	    */
	    animOutToRight: 'slide-out-right',
	    /**
	    * motion-ui animation class to apply
	    * @option
	     * @type {string}
	    * @default 'slide-in-left'
	    *
	    */
	    animInFromLeft: 'slide-in-left',
	    /**
	    * motion-ui animation class to apply
	    * @option
	     * @type {string}
	    * @default 'slide-out-left'
	    */
	    animOutToLeft: 'slide-out-left',
	    /**
	    * Allows Orbit to automatically animate on page load.
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    autoPlay: true,
	    /**
	    * Amount of time, in ms, between slide transitions
	    * @option
	     * @type {number}
	    * @default 5000
	    */
	    timerDelay: 5000,
	    /**
	    * Allows Orbit to infinitely loop through the slides
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    infiniteWrap: true,
	    /**
	    * Allows the Orbit slides to bind to swipe events for mobile, requires an additional util library
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    swipe: true,
	    /**
	    * Allows the timing function to pause animation on hover.
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    pauseOnHover: true,
	    /**
	    * Allows Orbit to bind keyboard events to the slider, to animate frames with arrow keys
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    accessible: true,
	    /**
	    * Class applied to the container of Orbit
	    * @option
	     * @type {string}
	    * @default 'orbit-container'
	    */
	    containerClass: 'orbit-container',
	    /**
	    * Class applied to individual slides.
	    * @option
	     * @type {string}
	    * @default 'orbit-slide'
	    */
	    slideClass: 'orbit-slide',
	    /**
	    * Class applied to the bullet container. You're welcome.
	    * @option
	     * @type {string}
	    * @default 'orbit-bullets'
	    */
	    boxOfBullets: 'orbit-bullets',
	    /**
	    * Class applied to the `next` navigation button.
	    * @option
	     * @type {string}
	    * @default 'orbit-next'
	    */
	    nextClass: 'orbit-next',
	    /**
	    * Class applied to the `previous` navigation button.
	    * @option
	     * @type {string}
	    * @default 'orbit-previous'
	    */
	    prevClass: 'orbit-previous',
	    /**
	    * Boolean to flag the js to use motion ui classes or not. Default to true for backwards compatability.
	    * @option
	     * @type {boolean}
	    * @default true
	    */
	    useMUI: true
	  };
	
	  /***/
	},
	/* 28 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return ResponsiveAccordionTabs;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_accordion__ = __webpack_require__(11);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_tabs__ = __webpack_require__(17);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  // The plugin matches the plugin classes with these plugin instances.
	  var MenuPlugins = {
	    tabs: {
	      cssClass: 'tabs',
	      plugin: __WEBPACK_IMPORTED_MODULE_5__foundation_tabs__["a" /* Tabs */]
	    },
	    accordion: {
	      cssClass: 'accordion',
	      plugin: __WEBPACK_IMPORTED_MODULE_4__foundation_accordion__["a" /* Accordion */]
	    }
	  };
	
	  /**
	   * ResponsiveAccordionTabs module.
	   * @module foundation.responsiveAccordionTabs
	   * @requires foundation.util.motion
	   * @requires foundation.accordion
	   * @requires foundation.tabs
	   */
	
	  var ResponsiveAccordionTabs = function (_Plugin) {
	    _inherits(ResponsiveAccordionTabs, _Plugin);
	
	    function ResponsiveAccordionTabs() {
	      _classCallCheck(this, ResponsiveAccordionTabs);
	
	      return _possibleConstructorReturn(this, (ResponsiveAccordionTabs.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveAccordionTabs)).apply(this, arguments));
	    }
	
	    _createClass(ResponsiveAccordionTabs, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a responsive accordion tabs.
	       * @class
	       * @name ResponsiveAccordionTabs
	       * @fires ResponsiveAccordionTabs#init
	       * @param {jQuery} element - jQuery object to make into Responsive Accordion Tabs.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, this.$element.data(), options);
	        this.rules = this.$element.data('responsive-accordion-tabs');
	        this.currentMq = null;
	        this.currentPlugin = null;
	        this.className = 'ResponsiveAccordionTabs'; // ie9 back compat
	        if (!this.$element.attr('id')) {
	          this.$element.attr('id', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */])(6, 'responsiveaccordiontabs'));
	        };
	
	        this._init();
	        this._events();
	      }
	
	      /**
	       * Initializes the Menu by parsing the classes from the 'data-responsive-accordion-tabs' attribute on the element.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	
	        // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules
	        if (typeof this.rules === 'string') {
	          var rulesTree = {};
	
	          // Parse rules from "classes" pulled from data attribute
	          var rules = this.rules.split(' ');
	
	          // Iterate through every rule found
	          for (var i = 0; i < rules.length; i++) {
	            var rule = rules[i].split('-');
	            var ruleSize = rule.length > 1 ? rule[0] : 'small';
	            var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
	
	            if (MenuPlugins[rulePlugin] !== null) {
	              rulesTree[ruleSize] = MenuPlugins[rulePlugin];
	            }
	          }
	
	          this.rules = rulesTree;
	        }
	
	        this._getAllOptions();
	
	        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isEmptyObject(this.rules)) {
	          this._checkMediaQueries();
	        }
	      }
	    }, {
	      key: '_getAllOptions',
	      value: function _getAllOptions() {
	        //get all defaults and options
	        var _this = this;
	        _this.allOptions = {};
	        for (var key in MenuPlugins) {
	          if (MenuPlugins.hasOwnProperty(key)) {
	            var obj = MenuPlugins[key];
	            try {
	              var dummyPlugin = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<ul></ul>');
	              var tmpPlugin = new obj.plugin(dummyPlugin, _this.options);
	              for (var keyKey in tmpPlugin.options) {
	                if (tmpPlugin.options.hasOwnProperty(keyKey) && keyKey !== 'zfPlugin') {
	                  var objObj = tmpPlugin.options[keyKey];
	                  _this.allOptions[keyKey] = objObj;
	                }
	              }
	              tmpPlugin.destroy();
	            } catch (e) {}
	          }
	        }
	      }
	
	      /**
	       * Initializes events for the Menu.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', function () {
	          _this._checkMediaQueries();
	        });
	      }
	
	      /**
	       * Checks the current screen width against available media queries. If the media query has changed, and the plugin needed has changed, the plugins will swap out.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_checkMediaQueries',
	      value: function _checkMediaQueries() {
	        var matchedMq,
	            _this = this;
	        // Iterate through each rule and find the last matching rule
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this.rules, function (key) {
	          if (__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(key)) {
	            matchedMq = key;
	          }
	        });
	
	        // No match? No dice
	        if (!matchedMq) return;
	
	        // Plugin already initialized? We good
	        if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return;
	
	        // Remove existing plugin-specific CSS classes
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(MenuPlugins, function (key, value) {
	          _this.$element.removeClass(value.cssClass);
	        });
	
	        // Add the CSS class for the new plugin
	        this.$element.addClass(this.rules[matchedMq].cssClass);
	
	        // Create an instance of the new plugin
	        if (this.currentPlugin) {
	          //don't know why but on nested elements data zfPlugin get's lost
	          if (!this.currentPlugin.$element.data('zfPlugin') && this.storezfData) this.currentPlugin.$element.data('zfPlugin', this.storezfData);
	          this.currentPlugin.destroy();
	        }
	        this._handleMarkup(this.rules[matchedMq].cssClass);
	        this.currentPlugin = new this.rules[matchedMq].plugin(this.$element, {});
	        this.storezfData = this.currentPlugin.$element.data('zfPlugin');
	      }
	    }, {
	      key: '_handleMarkup',
	      value: function _handleMarkup(toSet) {
	        var _this = this,
	            fromString = 'accordion';
	        var $panels = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-tabs-content=' + this.$element.attr('id') + ']');
	        if ($panels.length) fromString = 'tabs';
	        if (fromString === toSet) {
	          return;
	        };
	
	        var tabsTitle = _this.allOptions.linkClass ? _this.allOptions.linkClass : 'tabs-title';
	        var tabsPanel = _this.allOptions.panelClass ? _this.allOptions.panelClass : 'tabs-panel';
	
	        this.$element.removeAttr('role');
	        var $liHeads = this.$element.children('.' + tabsTitle + ',[data-accordion-item]').removeClass(tabsTitle).removeClass('accordion-item').removeAttr('data-accordion-item');
	        var $liHeadsA = $liHeads.children('a').removeClass('accordion-title');
	
	        if (fromString === 'tabs') {
	          $panels = $panels.children('.' + tabsPanel).removeClass(tabsPanel).removeAttr('role').removeAttr('aria-hidden').removeAttr('aria-labelledby');
	          $panels.children('a').removeAttr('role').removeAttr('aria-controls').removeAttr('aria-selected');
	        } else {
	          $panels = $liHeads.children('[data-tab-content]').removeClass('accordion-content');
	        };
	
	        $panels.css({ display: '', visibility: '' });
	        $liHeads.css({ display: '', visibility: '' });
	        if (toSet === 'accordion') {
	          $panels.each(function (key, value) {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(value).appendTo($liHeads.get(key)).addClass('accordion-content').attr('data-tab-content', '').removeClass('is-active').css({ height: '' });
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-tabs-content=' + _this.$element.attr('id') + ']').after('<div id="tabs-placeholder-' + _this.$element.attr('id') + '"></div>').detach();
	            $liHeads.addClass('accordion-item').attr('data-accordion-item', '');
	            $liHeadsA.addClass('accordion-title');
	          });
	        } else if (toSet === 'tabs') {
	          var $tabsContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-tabs-content=' + _this.$element.attr('id') + ']');
	          var $placeholder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tabs-placeholder-' + _this.$element.attr('id'));
	          if ($placeholder.length) {
	            $tabsContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="tabs-content"></div>').insertAfter($placeholder).attr('data-tabs-content', _this.$element.attr('id'));
	            $placeholder.remove();
	          } else {
	            $tabsContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="tabs-content"></div>').insertAfter(_this.$element).attr('data-tabs-content', _this.$element.attr('id'));
	          };
	          $panels.each(function (key, value) {
	            var tempValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(value).appendTo($tabsContent).addClass(tabsPanel);
	            var hash = $liHeadsA.get(key).hash.slice(1);
	            var id = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(value).attr('id') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */])(6, 'accordion');
	            if (hash !== id) {
	              if (hash !== '') {
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(value).attr('id', hash);
	              } else {
	                hash = id;
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(value).attr('id', hash);
	                __WEBPACK_IMPORTED_MODULE_0_jquery___default()($liHeadsA.get(key)).attr('href', __WEBPACK_IMPORTED_MODULE_0_jquery___default()($liHeadsA.get(key)).attr('href').replace('#', '') + '#' + hash);
	              };
	            };
	            var isActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($liHeads.get(key)).hasClass('is-active');
	            if (isActive) {
	              tempValue.addClass('is-active');
	            };
	          });
	          $liHeads.addClass(tabsTitle);
	        };
	      }
	
	      /**
	       * Destroys the instance of the current plugin on this element, as well as the window resize handler that switches the plugins out.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        if (this.currentPlugin) this.currentPlugin.destroy();
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('.zf.ResponsiveAccordionTabs');
	      }
	    }]);
	
	    return ResponsiveAccordionTabs;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  ResponsiveAccordionTabs.defaults = {};
	
	  /***/
	},
	/* 29 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return ResponsiveMenu;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_dropdownMenu__ = __webpack_require__(14);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_drilldown__ = __webpack_require__(13);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__foundation_accordionMenu__ = __webpack_require__(12);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MenuPlugins = {
	    dropdown: {
	      cssClass: 'dropdown',
	      plugin: __WEBPACK_IMPORTED_MODULE_4__foundation_dropdownMenu__["a" /* DropdownMenu */]
	    },
	    drilldown: {
	      cssClass: 'drilldown',
	      plugin: __WEBPACK_IMPORTED_MODULE_5__foundation_drilldown__["a" /* Drilldown */]
	    },
	    accordion: {
	      cssClass: 'accordion-menu',
	      plugin: __WEBPACK_IMPORTED_MODULE_6__foundation_accordionMenu__["a" /* AccordionMenu */]
	    }
	  };
	
	  // import "foundation.util.triggers.js";
	
	
	  /**
	   * ResponsiveMenu module.
	   * @module foundation.responsiveMenu
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   */
	
	  var ResponsiveMenu = function (_Plugin) {
	    _inherits(ResponsiveMenu, _Plugin);
	
	    function ResponsiveMenu() {
	      _classCallCheck(this, ResponsiveMenu);
	
	      return _possibleConstructorReturn(this, (ResponsiveMenu.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveMenu)).apply(this, arguments));
	    }
	
	    _createClass(ResponsiveMenu, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a responsive menu.
	       * @class
	       * @name ResponsiveMenu
	       * @fires ResponsiveMenu#init
	       * @param {jQuery} element - jQuery object to make into a dropdown menu.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
	        this.rules = this.$element.data('responsive-menu');
	        this.currentMq = null;
	        this.currentPlugin = null;
	        this.className = 'ResponsiveMenu'; // ie9 back compat
	
	        this._init();
	        this._events();
	      }
	
	      /**
	       * Initializes the Menu by parsing the classes from the 'data-ResponsiveMenu' attribute on the element.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	        // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules
	        if (typeof this.rules === 'string') {
	          var rulesTree = {};
	
	          // Parse rules from "classes" pulled from data attribute
	          var rules = this.rules.split(' ');
	
	          // Iterate through every rule found
	          for (var i = 0; i < rules.length; i++) {
	            var rule = rules[i].split('-');
	            var ruleSize = rule.length > 1 ? rule[0] : 'small';
	            var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
	
	            if (MenuPlugins[rulePlugin] !== null) {
	              rulesTree[ruleSize] = MenuPlugins[rulePlugin];
	            }
	          }
	
	          this.rules = rulesTree;
	        }
	
	        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isEmptyObject(this.rules)) {
	          this._checkMediaQueries();
	        }
	        // Add data-mutate since children may need it.
	        this.$element.attr('data-mutate', this.$element.attr('data-mutate') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_core__["b" /* GetYoDigits */])(6, 'responsive-menu'));
	      }
	
	      /**
	       * Initializes events for the Menu.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', function () {
	          _this._checkMediaQueries();
	        });
	        // $(window).on('resize.zf.ResponsiveMenu', function() {
	        //   _this._checkMediaQueries();
	        // });
	      }
	
	      /**
	       * Checks the current screen width against available media queries. If the media query has changed, and the plugin needed has changed, the plugins will swap out.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_checkMediaQueries',
	      value: function _checkMediaQueries() {
	        var matchedMq,
	            _this = this;
	        // Iterate through each rule and find the last matching rule
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this.rules, function (key) {
	          if (__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(key)) {
	            matchedMq = key;
	          }
	        });
	
	        // No match? No dice
	        if (!matchedMq) return;
	
	        // Plugin already initialized? We good
	        if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return;
	
	        // Remove existing plugin-specific CSS classes
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(MenuPlugins, function (key, value) {
	          _this.$element.removeClass(value.cssClass);
	        });
	
	        // Add the CSS class for the new plugin
	        this.$element.addClass(this.rules[matchedMq].cssClass);
	
	        // Create an instance of the new plugin
	        if (this.currentPlugin) this.currentPlugin.destroy();
	        this.currentPlugin = new this.rules[matchedMq].plugin(this.$element, {});
	      }
	
	      /**
	       * Destroys the instance of the current plugin on this element, as well as the window resize handler that switches the plugins out.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.currentPlugin.destroy();
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('.zf.ResponsiveMenu');
	      }
	    }]);
	
	    return ResponsiveMenu;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  ResponsiveMenu.defaults = {};
	
	  /***/
	},
	/* 30 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return ResponsiveToggle;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * ResponsiveToggle module.
	   * @module foundation.responsiveToggle
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.motion
	   */
	
	  var ResponsiveToggle = function (_Plugin) {
	    _inherits(ResponsiveToggle, _Plugin);
	
	    function ResponsiveToggle() {
	      _classCallCheck(this, ResponsiveToggle);
	
	      return _possibleConstructorReturn(this, (ResponsiveToggle.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveToggle)).apply(this, arguments));
	    }
	
	    _createClass(ResponsiveToggle, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Tab Bar.
	       * @class
	       * @name ResponsiveToggle
	       * @fires ResponsiveToggle#init
	       * @param {jQuery} element - jQuery object to attach tab bar functionality to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, ResponsiveToggle.defaults, this.$element.data(), options);
	        this.className = 'ResponsiveToggle'; // ie9 back compat
	
	        this._init();
	        this._events();
	      }
	
	      /**
	       * Initializes the tab bar by finding the target element, toggling element, and running update().
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	        var targetID = this.$element.data('responsive-toggle');
	        if (!targetID) {
	          console.error('Your tab bar needs an ID of a Menu as the value of data-tab-bar.');
	        }
	
	        this.$targetMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + targetID);
	        this.$toggler = this.$element.find('[data-toggle]').filter(function () {
	          var target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('toggle');
	          return target === targetID || target === "";
	        });
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, this.options, this.$targetMenu.data());
	
	        // If they were set, parse the animation classes
	        if (this.options.animate) {
	          var input = this.options.animate.split(' ');
	
	          this.animationIn = input[0];
	          this.animationOut = input[1] || null;
	        }
	
	        this._update();
	      }
	
	      /**
	       * Adds necessary event handlers for the tab bar to work.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	
	        this._updateMqHandler = this._update.bind(this);
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('changed.zf.mediaquery', this._updateMqHandler);
	
	        this.$toggler.on('click.zf.responsiveToggle', this.toggleMenu.bind(this));
	      }
	
	      /**
	       * Checks the current media query to determine if the tab bar should be visible or hidden.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_update',
	      value: function _update() {
	        // Mobile
	        if (!__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(this.options.hideFor)) {
	          this.$element.show();
	          this.$targetMenu.hide();
	        }
	
	        // Desktop
	        else {
	            this.$element.hide();
	            this.$targetMenu.show();
	          }
	      }
	
	      /**
	       * Toggles the element attached to the tab bar. The toggle only happens if the screen is small enough to allow it.
	       * @function
	       * @fires ResponsiveToggle#toggled
	       */
	
	    }, {
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this3 = this;
	
	        if (!__WEBPACK_IMPORTED_MODULE_1__foundation_util_mediaQuery__["a" /* MediaQuery */].atLeast(this.options.hideFor)) {
	          /**
	           * Fires when the element attached to the tab bar toggles.
	           * @event ResponsiveToggle#toggled
	           */
	          if (this.options.animate) {
	            if (this.$targetMenu.is(':hidden')) {
	              __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__["a" /* Motion */].animateIn(this.$targetMenu, this.animationIn, function () {
	                _this3.$element.trigger('toggled.zf.responsiveToggle');
	                _this3.$targetMenu.find('[data-mutate]').triggerHandler('mutateme.zf.trigger');
	              });
	            } else {
	              __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__["a" /* Motion */].animateOut(this.$targetMenu, this.animationOut, function () {
	                _this3.$element.trigger('toggled.zf.responsiveToggle');
	              });
	            }
	          } else {
	            this.$targetMenu.toggle(0);
	            this.$targetMenu.find('[data-mutate]').trigger('mutateme.zf.trigger');
	            this.$element.trigger('toggled.zf.responsiveToggle');
	          }
	        }
	      }
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('.zf.responsiveToggle');
	        this.$toggler.off('.zf.responsiveToggle');
	
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('changed.zf.mediaquery', this._updateMqHandler);
	      }
	    }]);
	
	    return ResponsiveToggle;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  ResponsiveToggle.defaults = {
	    /**
	     * The breakpoint after which the menu is always shown, and the tab bar is hidden.
	     * @option
	     * @type {string}
	     * @default 'medium'
	     */
	    hideFor: 'medium',
	
	    /**
	     * To decide if the toggle should be animated or not.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    animate: false
	  };
	
	  /***/
	},
	/* 31 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Reveal;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Reveal module.
	   * @module foundation.reveal
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.motion if using animations
	   */
	
	  var Reveal = function (_Plugin) {
	    _inherits(Reveal, _Plugin);
	
	    function Reveal() {
	      _classCallCheck(this, Reveal);
	
	      return _possibleConstructorReturn(this, (Reveal.__proto__ || (0, _getPrototypeOf2.default)(Reveal)).apply(this, arguments));
	    }
	
	    _createClass(Reveal, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Reveal.
	       * @class
	       * @name Reveal
	       * @param {jQuery} element - jQuery object to use for the modal.
	       * @param {Object} options - optional parameters.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Reveal.defaults, this.$element.data(), options);
	        this.className = 'Reveal'; // ie9 back compat
	        this._init();
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_5__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Reveal', {
	          'ESCAPE': 'close'
	        });
	      }
	
	      /**
	       * Initializes the modal by adding the overlay and close buttons, (if selected).
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	        this.id = this.$element.attr('id');
	        this.isActive = false;
	        this.cached = { mq: __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */].current };
	        this.isMobile = mobileSniff();
	
	        this.$anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-open="' + this.id + '"]').length ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-open="' + this.id + '"]') : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-toggle="' + this.id + '"]');
	        this.$anchor.attr({
	          'aria-controls': this.id,
	          'aria-haspopup': true,
	          'tabindex': 0
	        });
	
	        if (this.options.fullScreen || this.$element.hasClass('full')) {
	          this.options.fullScreen = true;
	          this.options.overlay = false;
	        }
	        if (this.options.overlay && !this.$overlay) {
	          this.$overlay = this._makeOverlay(this.id);
	        }
	
	        this.$element.attr({
	          'role': 'dialog',
	          'aria-hidden': true,
	          'data-yeti-box': this.id,
	          'data-resize': this.id
	        });
	
	        if (this.$overlay) {
	          this.$element.detach().appendTo(this.$overlay);
	        } else {
	          this.$element.detach().appendTo(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.options.appendTo));
	          this.$element.addClass('without-overlay');
	        }
	        this._events();
	        if (this.options.deepLink && window.location.hash === '#' + this.id) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).one('load.zf.reveal', this.open.bind(this));
	        }
	      }
	
	      /**
	       * Creates an overlay div to display behind the modal.
	       * @private
	       */
	
	    }, {
	      key: '_makeOverlay',
	      value: function _makeOverlay() {
	        var additionalOverlayClasses = '';
	
	        if (this.options.additionalOverlayClasses) {
	          additionalOverlayClasses = ' ' + this.options.additionalOverlayClasses;
	        }
	
	        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div></div>').addClass('reveal-overlay' + additionalOverlayClasses).appendTo(this.options.appendTo);
	      }
	
	      /**
	       * Updates position of modal
	       * TODO:  Figure out if we actually need to cache these values or if it doesn't matter
	       * @private
	       */
	
	    }, {
	      key: '_updatePosition',
	      value: function _updatePosition() {
	        var width = this.$element.outerWidth();
	        var outerWidth = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width();
	        var height = this.$element.outerHeight();
	        var outerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
	        var left, top;
	        if (this.options.hOffset === 'auto') {
	          left = parseInt((outerWidth - width) / 2, 10);
	        } else {
	          left = parseInt(this.options.hOffset, 10);
	        }
	        if (this.options.vOffset === 'auto') {
	          if (height > outerHeight) {
	            top = parseInt(Math.min(100, outerHeight / 10), 10);
	          } else {
	            top = parseInt((outerHeight - height) / 4, 10);
	          }
	        } else {
	          top = parseInt(this.options.vOffset, 10);
	        }
	        this.$element.css({ top: top + 'px' });
	        // only worry about left if we don't have an overlay or we havea  horizontal offset,
	        // otherwise we're perfectly in the middle
	        if (!this.$overlay || this.options.hOffset !== 'auto') {
	          this.$element.css({ left: left + 'px' });
	          this.$element.css({ margin: '0px' });
	        }
	      }
	
	      /**
	       * Adds event handlers for the modal.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this3 = this;
	
	        var _this = this;
	
	        this.$element.on({
	          'open.zf.trigger': this.open.bind(this),
	          'close.zf.trigger': function closeZfTrigger(event, $element) {
	            if (event.target === _this.$element[0] || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target).parents('[data-closable]')[0] === $element) {
	              // only close reveal when it's explicitly called
	              return _this3.close.apply(_this3);
	            }
	          },
	          'toggle.zf.trigger': this.toggle.bind(this),
	          'resizeme.zf.trigger': function resizemeZfTrigger() {
	            _this._updatePosition();
	          }
	        });
	
	        if (this.options.closeOnClick && this.options.overlay) {
	          this.$overlay.off('.zf.reveal').on('click.zf.reveal', function (e) {
	            if (e.target === _this.$element[0] || __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.contains(_this.$element[0], e.target) || !__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.contains(document, e.target)) {
	              return;
	            }
	            _this.close();
	          });
	        }
	        if (this.options.deepLink) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('popstate.zf.reveal:' + this.id, this._handleState.bind(this));
	        }
	      }
	
	      /**
	       * Handles modal methods on back/forward button clicks or any other event that triggers popstate.
	       * @private
	       */
	
	    }, {
	      key: '_handleState',
	      value: function _handleState(e) {
	        if (window.location.hash === '#' + this.id && !this.isActive) {
	          this.open();
	        } else {
	          this.close();
	        }
	      }
	
	      /**
	       * Opens the modal controlled by `this.$anchor`, and closes all others by default.
	       * @function
	       * @fires Reveal#closeme
	       * @fires Reveal#open
	       */
	
	    }, {
	      key: 'open',
	      value: function open() {
	        var _this4 = this;
	
	        // either update or replace browser history
	        if (this.options.deepLink) {
	          var hash = '#' + this.id;
	
	          if (window.history.pushState) {
	            if (this.options.updateHistory) {
	              window.history.pushState({}, '', hash);
	            } else {
	              window.history.replaceState({}, '', hash);
	            }
	          } else {
	            window.location.hash = hash;
	          }
	        }
	
	        this.isActive = true;
	
	        // Make elements invisible, but remove display: none so we can get size and positioning
	        this.$element.css({ 'visibility': 'hidden' }).show().scrollTop(0);
	        if (this.options.overlay) {
	          this.$overlay.css({ 'visibility': 'hidden' }).show();
	        }
	
	        this._updatePosition();
	
	        this.$element.hide().css({ 'visibility': '' });
	
	        if (this.$overlay) {
	          this.$overlay.css({ 'visibility': '' }).hide();
	          if (this.$element.hasClass('fast')) {
	            this.$overlay.addClass('fast');
	          } else if (this.$element.hasClass('slow')) {
	            this.$overlay.addClass('slow');
	          }
	        }
	
	        if (!this.options.multipleOpened) {
	          /**
	           * Fires immediately before the modal opens.
	           * Closes any other modals that are currently open
	           * @event Reveal#closeme
	           */
	          this.$element.trigger('closeme.zf.reveal', this.id);
	        }
	
	        var _this = this;
	
	        function addRevealOpenClasses() {
	          if (_this.isMobile) {
	            if (!_this.originalScrollPos) {
	              _this.originalScrollPos = window.pageYOffset;
	            }
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').addClass('is-reveal-open');
	          } else {
	            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('is-reveal-open');
	          }
	        }
	        // Motion UI method of reveal
	        if (this.options.animationIn) {
	          var afterAnimation = function afterAnimation() {
	            _this.$element.attr({
	              'aria-hidden': false,
	              'tabindex': -1
	            }).focus();
	            addRevealOpenClasses();
	            __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].trapFocus(_this.$element);
	          };
	
	          if (this.options.overlay) {
	            __WEBPACK_IMPORTED_MODULE_3__foundation_util_motion__["a" /* Motion */].animateIn(this.$overlay, 'fade-in');
	          }
	          __WEBPACK_IMPORTED_MODULE_3__foundation_util_motion__["a" /* Motion */].animateIn(this.$element, this.options.animationIn, function () {
	            if (_this4.$element) {
	              // protect against object having been removed
	              _this4.focusableElements = __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].findFocusable(_this4.$element);
	              afterAnimation();
	            }
	          });
	        }
	        // jQuery method of reveal
	        else {
	            if (this.options.overlay) {
	              this.$overlay.show(0);
	            }
	            this.$element.show(this.options.showDelay);
	          }
	
	        // handle accessibility
	        this.$element.attr({
	          'aria-hidden': false,
	          'tabindex': -1
	        }).focus();
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].trapFocus(this.$element);
	
	        addRevealOpenClasses();
	
	        this._extraHandlers();
	
	        /**
	         * Fires when the modal has successfully opened.
	         * @event Reveal#open
	         */
	        this.$element.trigger('open.zf.reveal');
	      }
	
	      /**
	       * Adds extra event handlers for the body and window if necessary.
	       * @private
	       */
	
	    }, {
	      key: '_extraHandlers',
	      value: function _extraHandlers() {
	        var _this = this;
	        if (!this.$element) {
	          return;
	        } // If we're in the middle of cleanup, don't freak out
	        this.focusableElements = __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].findFocusable(this.$element);
	
	        if (!this.options.overlay && this.options.closeOnClick && !this.options.fullScreen) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click.zf.reveal', function (e) {
	            if (e.target === _this.$element[0] || __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.contains(_this.$element[0], e.target) || !__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.contains(document, e.target)) {
	              return;
	            }
	            _this.close();
	          });
	        }
	
	        if (this.options.closeOnEsc) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('keydown.zf.reveal', function (e) {
	            __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Reveal', {
	              close: function close() {
	                if (_this.options.closeOnEsc) {
	                  _this.close();
	                }
	              }
	            });
	          });
	        }
	      }
	
	      /**
	       * Closes the modal.
	       * @function
	       * @fires Reveal#closed
	       */
	
	    }, {
	      key: 'close',
	      value: function close() {
	        if (!this.isActive || !this.$element.is(':visible')) {
	          return false;
	        }
	        var _this = this;
	
	        // Motion UI method of hiding
	        if (this.options.animationOut) {
	          if (this.options.overlay) {
	            __WEBPACK_IMPORTED_MODULE_3__foundation_util_motion__["a" /* Motion */].animateOut(this.$overlay, 'fade-out');
	          }
	
	          __WEBPACK_IMPORTED_MODULE_3__foundation_util_motion__["a" /* Motion */].animateOut(this.$element, this.options.animationOut, finishUp);
	        }
	        // jQuery method of hiding
	        else {
	            this.$element.hide(this.options.hideDelay);
	
	            if (this.options.overlay) {
	              this.$overlay.hide(0, finishUp);
	            } else {
	              finishUp();
	            }
	          }
	
	        // Conditionals to remove extra event listeners added on open
	        if (this.options.closeOnEsc) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('keydown.zf.reveal');
	        }
	
	        if (!this.options.overlay && this.options.closeOnClick) {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').off('click.zf.reveal');
	        }
	
	        this.$element.off('keydown.zf.reveal');
	
	        function finishUp() {
	          if (_this.isMobile) {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.reveal:visible').length === 0) {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').removeClass('is-reveal-open');
	            }
	            if (_this.originalScrollPos) {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').scrollTop(_this.originalScrollPos);
	              _this.originalScrollPos = null;
	            }
	          } else {
	            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.reveal:visible').length === 0) {
	              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('is-reveal-open');
	            }
	          }
	
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].releaseFocus(_this.$element);
	
	          _this.$element.attr('aria-hidden', true);
	
	          /**
	          * Fires when the modal is done closing.
	          * @event Reveal#closed
	          */
	          _this.$element.trigger('closed.zf.reveal');
	        }
	
	        /**
	        * Resets the modal content
	        * This prevents a running video to keep going in the background
	        */
	        if (this.options.resetOnClose) {
	          this.$element.html(this.$element.html());
	        }
	
	        this.isActive = false;
	        if (_this.options.deepLink) {
	          if (window.history.replaceState) {
	            window.history.replaceState('', document.title, window.location.href.replace('#' + this.id, ''));
	          } else {
	            window.location.hash = '';
	          }
	        }
	
	        this.$anchor.focus();
	      }
	
	      /**
	       * Toggles the open/closed state of a modal.
	       * @function
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle() {
	        if (this.isActive) {
	          this.close();
	        } else {
	          this.open();
	        }
	      }
	    }, {
	      key: '_destroy',
	
	      /**
	       * Destroys an instance of a modal.
	       * @function
	       */
	      value: function _destroy() {
	        if (this.options.overlay) {
	          this.$element.appendTo(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.options.appendTo)); // move $element outside of $overlay to prevent error unregisterPlugin()
	          this.$overlay.hide().off().remove();
	        }
	        this.$element.hide().off();
	        this.$anchor.off('.zf');
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('.zf.reveal:' + this.id);
	      }
	    }]);
	
	    return Reveal;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_plugin__["a" /* Plugin */]);
	
	  Reveal.defaults = {
	    /**
	     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    animationIn: '',
	    /**
	     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    animationOut: '',
	    /**
	     * Time, in ms, to delay the opening of a modal after a click if no animation used.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    showDelay: 0,
	    /**
	     * Time, in ms, to delay the closing of a modal after a click if no animation used.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    hideDelay: 0,
	    /**
	     * Allows a click on the body/overlay to close the modal.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnClick: true,
	    /**
	     * Allows the modal to close if the user presses the `ESCAPE` key.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnEsc: true,
	    /**
	     * If true, allows multiple modals to be displayed at once.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    multipleOpened: false,
	    /**
	     * Distance, in pixels, the modal should push down from the top of the screen.
	     * @option
	     * @type {number|string}
	     * @default auto
	     */
	    vOffset: 'auto',
	    /**
	     * Distance, in pixels, the modal should push in from the side of the screen.
	     * @option
	     * @type {number|string}
	     * @default auto
	     */
	    hOffset: 'auto',
	    /**
	     * Allows the modal to be fullscreen, completely blocking out the rest of the view. JS checks for this as well.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    fullScreen: false,
	    /**
	     * Percentage of screen height the modal should push up from the bottom of the view.
	     * @option
	     * @type {number}
	     * @default 10
	     */
	    btmOffsetPct: 10,
	    /**
	     * Allows the modal to generate an overlay div, which will cover the view when modal opens.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    overlay: true,
	    /**
	     * Allows the modal to remove and reinject markup on close. Should be true if using video elements w/o using provider's api, otherwise, videos will continue to play in the background.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    resetOnClose: false,
	    /**
	     * Allows the modal to alter the url on open/close, and allows the use of the `back` button to close modals. ALSO, allows a modal to auto-maniacally open on page load IF the hash === the modal's user-set id.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    deepLink: false,
	    /**
	     * Update the browser history with the open modal
	     * @option
	     * @default false
	     */
	    updateHistory: false,
	    /**
	    * Allows the modal to append to custom div.
	    * @option
	    * @type {string}
	    * @default "body"
	    */
	    appendTo: "body",
	    /**
	     * Allows adding additional class names to the reveal overlay.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    additionalOverlayClasses: ''
	  };
	
	  function iPhoneSniff() {
	    return (/iP(ad|hone|od).*OS/.test(window.navigator.userAgent)
	    );
	  }
	
	  function androidSniff() {
	    return (/Android/.test(window.navigator.userAgent)
	    );
	  }
	
	  function mobileSniff() {
	    return iPhoneSniff() || androidSniff();
	  }
	
	  /***/
	},
	/* 32 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Slider;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__ = __webpack_require__(3);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__foundation_util_touch__ = __webpack_require__(10);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Slider module.
	   * @module foundation.slider
	   * @requires foundation.util.motion
	   * @requires foundation.util.triggers
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.touch
	   */
	
	  var Slider = function (_Plugin) {
	    _inherits(Slider, _Plugin);
	
	    function Slider() {
	      _classCallCheck(this, Slider);
	
	      return _possibleConstructorReturn(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).apply(this, arguments));
	    }
	
	    _createClass(Slider, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a slider control.
	       * @class
	       * @name Slider
	       * @param {jQuery} element - jQuery object to make into a slider control.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Slider.defaults, this.$element.data(), options);
	        this.className = 'Slider'; // ie9 back compat
	
	        // Touch and Triggers inits are idempotent, we just need to make sure it's initialied.
	        __WEBPACK_IMPORTED_MODULE_5__foundation_util_touch__["a" /* Touch */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	        __WEBPACK_IMPORTED_MODULE_6__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        this._init();
	
	        __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].register('Slider', {
	          'ltr': {
	            'ARROW_RIGHT': 'increase',
	            'ARROW_UP': 'increase',
	            'ARROW_DOWN': 'decrease',
	            'ARROW_LEFT': 'decrease',
	            'SHIFT_ARROW_RIGHT': 'increase_fast',
	            'SHIFT_ARROW_UP': 'increase_fast',
	            'SHIFT_ARROW_DOWN': 'decrease_fast',
	            'SHIFT_ARROW_LEFT': 'decrease_fast',
	            'HOME': 'min',
	            'END': 'max'
	          },
	          'rtl': {
	            'ARROW_LEFT': 'increase',
	            'ARROW_RIGHT': 'decrease',
	            'SHIFT_ARROW_LEFT': 'increase_fast',
	            'SHIFT_ARROW_RIGHT': 'decrease_fast'
	          }
	        });
	      }
	
	      /**
	       * Initilizes the plugin by reading/setting attributes, creating collections and setting the initial position of the handle(s).
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        this.inputs = this.$element.find('input');
	        this.handles = this.$element.find('[data-slider-handle]');
	
	        this.$handle = this.handles.eq(0);
	        this.$input = this.inputs.length ? this.inputs.eq(0) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + this.$handle.attr('aria-controls'));
	        this.$fill = this.$element.find('[data-slider-fill]').css(this.options.vertical ? 'height' : 'width', 0);
	
	        var isDbl = false,
	            _this = this;
	        if (this.options.disabled || this.$element.hasClass(this.options.disabledClass)) {
	          this.options.disabled = true;
	          this.$element.addClass(this.options.disabledClass);
	        }
	        if (!this.inputs.length) {
	          this.inputs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()().add(this.$input);
	          this.options.binding = true;
	        }
	
	        this._setInitAttr(0);
	
	        if (this.handles[1]) {
	          this.options.doubleSided = true;
	          this.$handle2 = this.handles.eq(1);
	          this.$input2 = this.inputs.length > 1 ? this.inputs.eq(1) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + this.$handle2.attr('aria-controls'));
	
	          if (!this.inputs[1]) {
	            this.inputs = this.inputs.add(this.$input2);
	          }
	          isDbl = true;
	
	          // this.$handle.triggerHandler('click.zf.slider');
	          this._setInitAttr(1);
	        }
	
	        // Set handle positions
	        this.setHandles();
	
	        this._events();
	      }
	    }, {
	      key: 'setHandles',
	      value: function setHandles() {
	        var _this3 = this;
	
	        if (this.handles[1]) {
	          this._setHandlePos(this.$handle, this.inputs.eq(0).val(), true, function () {
	            _this3._setHandlePos(_this3.$handle2, _this3.inputs.eq(1).val(), true);
	          });
	        } else {
	          this._setHandlePos(this.$handle, this.inputs.eq(0).val(), true);
	        }
	      }
	    }, {
	      key: '_reflow',
	      value: function _reflow() {
	        this.setHandles();
	      }
	      /**
	      * @function
	      * @private
	      * @param {Number} value - floating point (the value) to be transformed using to a relative position on the slider (the inverse of _value)
	      */
	
	    }, {
	      key: '_pctOfBar',
	      value: function _pctOfBar(value) {
	        var pctOfBar = percent(value - this.options.start, this.options.end - this.options.start);
	
	        switch (this.options.positionValueFunction) {
	          case "pow":
	            pctOfBar = this._logTransform(pctOfBar);
	            break;
	          case "log":
	            pctOfBar = this._powTransform(pctOfBar);
	            break;
	        }
	
	        return pctOfBar.toFixed(2);
	      }
	
	      /**
	      * @function
	      * @private
	      * @param {Number} pctOfBar - floating point, the relative position of the slider (typically between 0-1) to be transformed to a value
	      */
	
	    }, {
	      key: '_value',
	      value: function _value(pctOfBar) {
	        switch (this.options.positionValueFunction) {
	          case "pow":
	            pctOfBar = this._powTransform(pctOfBar);
	            break;
	          case "log":
	            pctOfBar = this._logTransform(pctOfBar);
	            break;
	        }
	        var value = (this.options.end - this.options.start) * pctOfBar + this.options.start;
	
	        return value;
	      }
	
	      /**
	      * @function
	      * @private
	      * @param {Number} value - floating point (typically between 0-1) to be transformed using the log function
	      */
	
	    }, {
	      key: '_logTransform',
	      value: function _logTransform(value) {
	        return baseLog(this.options.nonLinearBase, value * (this.options.nonLinearBase - 1) + 1);
	      }
	
	      /**
	      * @function
	      * @private
	      * @param {Number} value - floating point (typically between 0-1) to be transformed using the power function
	      */
	
	    }, {
	      key: '_powTransform',
	      value: function _powTransform(value) {
	        return (Math.pow(this.options.nonLinearBase, value) - 1) / (this.options.nonLinearBase - 1);
	      }
	
	      /**
	       * Sets the position of the selected handle and fill bar.
	       * @function
	       * @private
	       * @param {jQuery} $hndl - the selected handle to move.
	       * @param {Number} location - floating point between the start and end values of the slider bar.
	       * @param {Function} cb - callback function to fire on completion.
	       * @fires Slider#moved
	       * @fires Slider#changed
	       */
	
	    }, {
	      key: '_setHandlePos',
	      value: function _setHandlePos($hndl, location, noInvert, cb) {
	        // don't move if the slider has been disabled since its initialization
	        if (this.$element.hasClass(this.options.disabledClass)) {
	          return;
	        }
	        //might need to alter that slightly for bars that will have odd number selections.
	        location = parseFloat(location); //on input change events, convert string to number...grumble.
	
	        // prevent slider from running out of bounds, if value exceeds the limits set through options, override the value to min/max
	        if (location < this.options.start) {
	          location = this.options.start;
	        } else if (location > this.options.end) {
	          location = this.options.end;
	        }
	
	        var isDbl = this.options.doubleSided;
	
	        //this is for single-handled vertical sliders, it adjusts the value to account for the slider being "upside-down"
	        //for click and drag events, it's weird due to the scale(-1, 1) css property
	        if (this.options.vertical && !noInvert) {
	          location = this.options.end - location;
	        }
	
	        if (isDbl) {
	          //this block is to prevent 2 handles from crossing eachother. Could/should be improved.
	          if (this.handles.index($hndl) === 0) {
	            var h2Val = parseFloat(this.$handle2.attr('aria-valuenow'));
	            location = location >= h2Val ? h2Val - this.options.step : location;
	          } else {
	            var h1Val = parseFloat(this.$handle.attr('aria-valuenow'));
	            location = location <= h1Val ? h1Val + this.options.step : location;
	          }
	        }
	
	        var _this = this,
	            vert = this.options.vertical,
	            hOrW = vert ? 'height' : 'width',
	            lOrT = vert ? 'top' : 'left',
	            handleDim = $hndl[0].getBoundingClientRect()[hOrW],
	            elemDim = this.$element[0].getBoundingClientRect()[hOrW],
	
	
	        //percentage of bar min/max value based on click or drag point
	        pctOfBar = this._pctOfBar(location),
	
	
	        //number of actual pixels to shift the handle, based on the percentage obtained above
	        pxToMove = (elemDim - handleDim) * pctOfBar,
	
	
	        //percentage of bar to shift the handle
	        movement = (percent(pxToMove, elemDim) * 100).toFixed(this.options.decimal);
	        //fixing the decimal value for the location number, is passed to other methods as a fixed floating-point value
	        location = parseFloat(location.toFixed(this.options.decimal));
	        // declare empty object for css adjustments, only used with 2 handled-sliders
	        var css = {};
	
	        this._setValues($hndl, location);
	
	        // TODO update to calculate based on values set to respective inputs??
	        if (isDbl) {
	          var isLeftHndl = this.handles.index($hndl) === 0,
	
	
	          //empty variable, will be used for min-height/width for fill bar
	          dim,
	
	
	          //percentage w/h of the handle compared to the slider bar
	          handlePct = ~~(percent(handleDim, elemDim) * 100);
	          //if left handle, the math is slightly different than if it's the right handle, and the left/top property needs to be changed for the fill bar
	          if (isLeftHndl) {
	            //left or top percentage value to apply to the fill bar.
	            css[lOrT] = movement + '%';
	            //calculate the new min-height/width for the fill bar.
	            dim = parseFloat(this.$handle2[0].style[lOrT]) - movement + handlePct;
	            //this callback is necessary to prevent errors and allow the proper placement and initialization of a 2-handled slider
	            //plus, it means we don't care if 'dim' isNaN on init, it won't be in the future.
	            if (cb && typeof cb === 'function') {
	              cb();
	            } //this is only needed for the initialization of 2 handled sliders
	          } else {
	            //just caching the value of the left/bottom handle's left/top property
	            var handlePos = parseFloat(this.$handle[0].style[lOrT]);
	            //calculate the new min-height/width for the fill bar. Use isNaN to prevent false positives for numbers <= 0
	            //based on the percentage of movement of the handle being manipulated, less the opposing handle's left/top position, plus the percentage w/h of the handle itself
	            dim = movement - (isNaN(handlePos) ? (this.options.initialStart - this.options.start) / ((this.options.end - this.options.start) / 100) : handlePos) + handlePct;
	          }
	          // assign the min-height/width to our css object
	          css['min-' + hOrW] = dim + '%';
	        }
	
	        this.$element.one('finished.zf.animate', function () {
	          /**
	           * Fires when the handle is done moving.
	           * @event Slider#moved
	           */
	          _this.$element.trigger('moved.zf.slider', [$hndl]);
	        });
	
	        //because we don't know exactly how the handle will be moved, check the amount of time it should take to move.
	        var moveTime = this.$element.data('dragging') ? 1000 / 60 : this.options.moveTime;
	
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__foundation_util_motion__["b" /* Move */])(moveTime, $hndl, function () {
	          // adjusting the left/top property of the handle, based on the percentage calculated above
	          // if movement isNaN, that is because the slider is hidden and we cannot determine handle width,
	          // fall back to next best guess.
	          if (isNaN(movement)) {
	            $hndl.css(lOrT, pctOfBar * 100 + '%');
	          } else {
	            $hndl.css(lOrT, movement + '%');
	          }
	
	          if (!_this.options.doubleSided) {
	            //if single-handled, a simple method to expand the fill bar
	            _this.$fill.css(hOrW, pctOfBar * 100 + '%');
	          } else {
	            //otherwise, use the css object we created above
	            _this.$fill.css(css);
	          }
	        });
	
	        /**
	         * Fires when the value has not been change for a given time.
	         * @event Slider#changed
	         */
	        clearTimeout(_this.timeout);
	        _this.timeout = setTimeout(function () {
	          _this.$element.trigger('changed.zf.slider', [$hndl]);
	        }, _this.options.changedDelay);
	      }
	
	      /**
	       * Sets the initial attribute for the slider element.
	       * @function
	       * @private
	       * @param {Number} idx - index of the current handle/input to use.
	       */
	
	    }, {
	      key: '_setInitAttr',
	      value: function _setInitAttr(idx) {
	        var initVal = idx === 0 ? this.options.initialStart : this.options.initialEnd;
	        var id = this.inputs.eq(idx).attr('id') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["b" /* GetYoDigits */])(6, 'slider');
	        this.inputs.eq(idx).attr({
	          'id': id,
	          'max': this.options.end,
	          'min': this.options.start,
	          'step': this.options.step
	        });
	        this.inputs.eq(idx).val(initVal);
	        this.handles.eq(idx).attr({
	          'role': 'slider',
	          'aria-controls': id,
	          'aria-valuemax': this.options.end,
	          'aria-valuemin': this.options.start,
	          'aria-valuenow': initVal,
	          'aria-orientation': this.options.vertical ? 'vertical' : 'horizontal',
	          'tabindex': 0
	        });
	      }
	
	      /**
	       * Sets the input and `aria-valuenow` values for the slider element.
	       * @function
	       * @private
	       * @param {jQuery} $handle - the currently selected handle.
	       * @param {Number} val - floating point of the new value.
	       */
	
	    }, {
	      key: '_setValues',
	      value: function _setValues($handle, val) {
	        var idx = this.options.doubleSided ? this.handles.index($handle) : 0;
	        this.inputs.eq(idx).val(val);
	        $handle.attr('aria-valuenow', val);
	      }
	
	      /**
	       * Handles events on the slider element.
	       * Calculates the new location of the current handle.
	       * If there are two handles and the bar was clicked, it determines which handle to move.
	       * @function
	       * @private
	       * @param {Object} e - the `event` object passed from the listener.
	       * @param {jQuery} $handle - the current handle to calculate for, if selected.
	       * @param {Number} val - floating point number for the new value of the slider.
	       * TODO clean this up, there's a lot of repeated code between this and the _setHandlePos fn.
	       */
	
	    }, {
	      key: '_handleEvent',
	      value: function _handleEvent(e, $handle, val) {
	        var value, hasVal;
	        if (!val) {
	          //click or drag events
	          e.preventDefault();
	          var _this = this,
	              vertical = this.options.vertical,
	              param = vertical ? 'height' : 'width',
	              direction = vertical ? 'top' : 'left',
	              eventOffset = vertical ? e.pageY : e.pageX,
	              halfOfHandle = this.$handle[0].getBoundingClientRect()[param] / 2,
	              barDim = this.$element[0].getBoundingClientRect()[param],
	              windowScroll = vertical ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollLeft();
	
	          var elemOffset = this.$element.offset()[direction];
	
	          // touch events emulated by the touch util give position relative to screen, add window.scroll to event coordinates...
	          // best way to guess this is simulated is if clientY == pageY
	          if (e.clientY === e.pageY) {
	            eventOffset = eventOffset + windowScroll;
	          }
	          var eventFromBar = eventOffset - elemOffset;
	          var barXY;
	          if (eventFromBar < 0) {
	            barXY = 0;
	          } else if (eventFromBar > barDim) {
	            barXY = barDim;
	          } else {
	            barXY = eventFromBar;
	          }
	          var offsetPct = percent(barXY, barDim);
	
	          value = this._value(offsetPct);
	
	          // turn everything around for RTL, yay math!
	          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__foundation_util_core__["a" /* rtl */])() && !this.options.vertical) {
	            value = this.options.end - value;
	          }
	
	          value = _this._adjustValue(null, value);
	          //boolean flag for the setHandlePos fn, specifically for vertical sliders
	          hasVal = false;
	
	          if (!$handle) {
	            //figure out which handle it is, pass it to the next function.
	            var firstHndlPos = absPosition(this.$handle, direction, barXY, param),
	                secndHndlPos = absPosition(this.$handle2, direction, barXY, param);
	            $handle = firstHndlPos <= secndHndlPos ? this.$handle : this.$handle2;
	          }
	        } else {
	          //change event on input
	          value = this._adjustValue(null, val);
	          hasVal = true;
	        }
	
	        this._setHandlePos($handle, value, hasVal);
	      }
	
	      /**
	       * Adjustes value for handle in regard to step value. returns adjusted value
	       * @function
	       * @private
	       * @param {jQuery} $handle - the selected handle.
	       * @param {Number} value - value to adjust. used if $handle is falsy
	       */
	
	    }, {
	      key: '_adjustValue',
	      value: function _adjustValue($handle, value) {
	        var val,
	            step = this.options.step,
	            div = parseFloat(step / 2),
	            left,
	            prev_val,
	            next_val;
	        if (!!$handle) {
	          val = parseFloat($handle.attr('aria-valuenow'));
	        } else {
	          val = value;
	        }
	        left = val % step;
	        prev_val = val - left;
	        next_val = prev_val + step;
	        if (left === 0) {
	          return val;
	        }
	        val = val >= prev_val + div ? next_val : prev_val;
	        return val;
	      }
	
	      /**
	       * Adds event listeners to the slider elements.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        this._eventsForHandle(this.$handle);
	        if (this.handles[1]) {
	          this._eventsForHandle(this.$handle2);
	        }
	      }
	
	      /**
	       * Adds event listeners a particular handle
	       * @function
	       * @private
	       * @param {jQuery} $handle - the current handle to apply listeners to.
	       */
	
	    }, {
	      key: '_eventsForHandle',
	      value: function _eventsForHandle($handle) {
	        var _this = this,
	            curHandle,
	            timer;
	
	        this.inputs.off('change.zf.slider').on('change.zf.slider', function (e) {
	          var idx = _this.inputs.index(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	          _this._handleEvent(e, _this.handles.eq(idx), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val());
	        });
	
	        if (this.options.clickSelect) {
	          this.$element.off('click.zf.slider').on('click.zf.slider', function (e) {
	            if (_this.$element.data('dragging')) {
	              return false;
	            }
	
	            if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).is('[data-slider-handle]')) {
	              if (_this.options.doubleSided) {
	                _this._handleEvent(e);
	              } else {
	                _this._handleEvent(e, _this.$handle);
	              }
	            }
	          });
	        }
	
	        if (this.options.draggable) {
	          this.handles.addTouch();
	
	          var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body');
	          $handle.off('mousedown.zf.slider').on('mousedown.zf.slider', function (e) {
	            $handle.addClass('is-dragging');
	            _this.$fill.addClass('is-dragging'); //
	            _this.$element.data('dragging', true);
	
	            curHandle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
	
	            $body.on('mousemove.zf.slider', function (e) {
	              e.preventDefault();
	              _this._handleEvent(e, curHandle);
	            }).on('mouseup.zf.slider', function (e) {
	              _this._handleEvent(e, curHandle);
	
	              $handle.removeClass('is-dragging');
	              _this.$fill.removeClass('is-dragging');
	              _this.$element.data('dragging', false);
	
	              $body.off('mousemove.zf.slider mouseup.zf.slider');
	            });
	          })
	          // prevent events triggered by touch
	          .on('selectstart.zf.slider touchmove.zf.slider', function (e) {
	            e.preventDefault();
	          });
	        }
	
	        $handle.off('keydown.zf.slider').on('keydown.zf.slider', function (e) {
	          var _$handle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
	              idx = _this.options.doubleSided ? _this.handles.index(_$handle) : 0,
	              oldValue = parseFloat(_this.inputs.eq(idx).val()),
	              newValue;
	
	          // handle keyboard event with keyboard util
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_keyboard__["a" /* Keyboard */].handleKey(e, 'Slider', {
	            decrease: function decrease() {
	              newValue = oldValue - _this.options.step;
	            },
	            increase: function increase() {
	              newValue = oldValue + _this.options.step;
	            },
	            decrease_fast: function decrease_fast() {
	              newValue = oldValue - _this.options.step * 10;
	            },
	            increase_fast: function increase_fast() {
	              newValue = oldValue + _this.options.step * 10;
	            },
	            min: function min() {
	              newValue = _this.options.start;
	            },
	            max: function max() {
	              newValue = _this.options.end;
	            },
	            handled: function handled() {
	              // only set handle pos when event was handled specially
	              e.preventDefault();
	              _this._setHandlePos(_$handle, newValue, true);
	            }
	          });
	          /*if (newValue) { // if pressed key has special function, update value
	            e.preventDefault();
	            _this._setHandlePos(_$handle, newValue);
	          }*/
	        });
	      }
	
	      /**
	       * Destroys the slider plugin.
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.handles.off('.zf.slider');
	        this.inputs.off('.zf.slider');
	        this.$element.off('.zf.slider');
	
	        clearTimeout(this.timeout);
	      }
	    }]);
	
	    return Slider;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_plugin__["a" /* Plugin */]);
	
	  Slider.defaults = {
	    /**
	     * Minimum value for the slider scale.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    start: 0,
	    /**
	     * Maximum value for the slider scale.
	     * @option
	     * @type {number}
	     * @default 100
	     */
	    end: 100,
	    /**
	     * Minimum value change per change event.
	     * @option
	     * @type {number}
	     * @default 1
	     */
	    step: 1,
	    /**
	     * Value at which the handle/input *(left handle/first input)* should be set to on initialization.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    initialStart: 0,
	    /**
	     * Value at which the right handle/second input should be set to on initialization.
	     * @option
	     * @type {number}
	     * @default 100
	     */
	    initialEnd: 100,
	    /**
	     * Allows the input to be located outside the container and visible. Set to by the JS
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    binding: false,
	    /**
	     * Allows the user to click/tap on the slider bar to select a value.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    clickSelect: true,
	    /**
	     * Set to true and use the `vertical` class to change alignment to vertical.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    vertical: false,
	    /**
	     * Allows the user to drag the slider handle(s) to select a value.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    draggable: true,
	    /**
	     * Disables the slider and prevents event listeners from being applied. Double checked by JS with `disabledClass`.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    disabled: false,
	    /**
	     * Allows the use of two handles. Double checked by the JS. Changes some logic handling.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    doubleSided: false,
	    /**
	     * Potential future feature.
	     */
	    // steps: 100,
	    /**
	     * Number of decimal places the plugin should go to for floating point precision.
	     * @option
	     * @type {number}
	     * @default 2
	     */
	    decimal: 2,
	    /**
	     * Time delay for dragged elements.
	     */
	    // dragDelay: 0,
	    /**
	     * Time, in ms, to animate the movement of a slider handle if user clicks/taps on the bar. Needs to be manually set if updating the transition time in the Sass settings.
	     * @option
	     * @type {number}
	     * @default 200
	     */
	    moveTime: 200, //update this if changing the transition time in the sass
	    /**
	     * Class applied to disabled sliders.
	     * @option
	     * @type {string}
	     * @default 'disabled'
	     */
	    disabledClass: 'disabled',
	    /**
	     * Will invert the default layout for a vertical<span data-tooltip title="who would do this???"> </span>slider.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    invertVertical: false,
	    /**
	     * Milliseconds before the `changed.zf-slider` event is triggered after value change.
	     * @option
	     * @type {number}
	     * @default 500
	     */
	    changedDelay: 500,
	    /**
	    * Basevalue for non-linear sliders
	    * @option
	    * @type {number}
	    * @default 5
	    */
	    nonLinearBase: 5,
	    /**
	    * Basevalue for non-linear sliders, possible values are: `'linear'`, `'pow'` & `'log'`. Pow and Log use the nonLinearBase setting.
	    * @option
	    * @type {string}
	    * @default 'linear'
	    */
	    positionValueFunction: 'linear'
	  };
	
	  function percent(frac, num) {
	    return frac / num;
	  }
	  function absPosition($handle, dir, clickPos, param) {
	    return Math.abs($handle.position()[dir] + $handle[param]() / 2 - clickPos);
	  }
	  function baseLog(base, value) {
	    return Math.log(value) / Math.log(base);
	  }
	
	  /***/
	},
	/* 33 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Sticky;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Sticky module.
	   * @module foundation.sticky
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   */
	
	  var Sticky = function (_Plugin) {
	    _inherits(Sticky, _Plugin);
	
	    function Sticky() {
	      _classCallCheck(this, Sticky);
	
	      return _possibleConstructorReturn(this, (Sticky.__proto__ || (0, _getPrototypeOf2.default)(Sticky)).apply(this, arguments));
	    }
	
	    _createClass(Sticky, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a sticky thing.
	       * @class
	       * @name Sticky
	       * @param {jQuery} element - jQuery object to make sticky.
	       * @param {Object} options - options object passed when creating the element programmatically.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Sticky.defaults, this.$element.data(), options);
	        this.className = 'Sticky'; // ie9 back compat
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_4__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        this._init();
	      }
	
	      /**
	       * Initializes the sticky element by adding classes, getting/setting dimensions, breakpoints and attributes
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	
	        var $parent = this.$element.parent('[data-sticky-container]'),
	            id = this.$element[0].id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, 'sticky'),
	            _this = this;
	
	        if ($parent.length) {
	          this.$container = $parent;
	        } else {
	          this.wasWrapped = true;
	          this.$element.wrap(this.options.container);
	          this.$container = this.$element.parent();
	        }
	        this.$container.addClass(this.options.containerClass);
	
	        this.$element.addClass(this.options.stickyClass).attr({ 'data-resize': id, 'data-mutate': id });
	        if (this.options.anchor !== '') {
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + _this.options.anchor).attr({ 'data-mutate': id });
	        }
	
	        this.scrollCount = this.options.checkEvery;
	        this.isStuck = false;
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).one('load.zf.sticky', function () {
	          //We calculate the container height to have correct values for anchor points offset calculation.
	          _this.containerHeight = _this.$element.css("display") == "none" ? 0 : _this.$element[0].getBoundingClientRect().height;
	          _this.$container.css('height', _this.containerHeight);
	          _this.elemHeight = _this.containerHeight;
	          if (_this.options.anchor !== '') {
	            _this.$anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + _this.options.anchor);
	          } else {
	            _this._parsePoints();
	          }
	
	          _this._setSizes(function () {
	            var scroll = window.pageYOffset;
	            _this._calc(false, scroll);
	            //Unstick the element will ensure that proper classes are set.
	            if (!_this.isStuck) {
	              _this._removeSticky(scroll >= _this.topPoint ? false : true);
	            }
	          });
	          _this._events(id.split('-').reverse().join('-'));
	        });
	      }
	
	      /**
	       * If using multiple elements as anchors, calculates the top and bottom pixel values the sticky thing should stick and unstick on.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_parsePoints',
	      value: function _parsePoints() {
	        var top = this.options.topAnchor == "" ? 1 : this.options.topAnchor,
	            btm = this.options.btmAnchor == "" ? document.documentElement.scrollHeight : this.options.btmAnchor,
	            pts = [top, btm],
	            breaks = {};
	        for (var i = 0, len = pts.length; i < len && pts[i]; i++) {
	          var pt;
	          if (typeof pts[i] === 'number') {
	            pt = pts[i];
	          } else {
	            var place = pts[i].split(':'),
	                anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + place[0]);
	
	            pt = anchor.offset().top;
	            if (place[1] && place[1].toLowerCase() === 'bottom') {
	              pt += anchor[0].getBoundingClientRect().height;
	            }
	          }
	          breaks[i] = pt;
	        }
	
	        this.points = breaks;
	        return;
	      }
	
	      /**
	       * Adds event handlers for the scrolling element.
	       * @private
	       * @param {String} id - pseudo-random id for unique scroll event listener.
	       */
	
	    }, {
	      key: '_events',
	      value: function _events(id) {
	        var _this = this,
	            scrollListener = this.scrollListener = 'scroll.zf.' + id;
	        if (this.isOn) {
	          return;
	        }
	        if (this.canStick) {
	          this.isOn = true;
	          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off(scrollListener).on(scrollListener, function (e) {
	            if (_this.scrollCount === 0) {
	              _this.scrollCount = _this.options.checkEvery;
	              _this._setSizes(function () {
	                _this._calc(false, window.pageYOffset);
	              });
	            } else {
	              _this.scrollCount--;
	              _this._calc(false, window.pageYOffset);
	            }
	          });
	        }
	
	        this.$element.off('resizeme.zf.trigger').on('resizeme.zf.trigger', function (e, el) {
	          _this._eventsHandler(id);
	        });
	
	        this.$element.on('mutateme.zf.trigger', function (e, el) {
	          _this._eventsHandler(id);
	        });
	
	        if (this.$anchor) {
	          this.$anchor.on('mutateme.zf.trigger', function (e, el) {
	            _this._eventsHandler(id);
	          });
	        }
	      }
	
	      /**
	       * Handler for events.
	       * @private
	       * @param {String} id - pseudo-random id for unique scroll event listener.
	       */
	
	    }, {
	      key: '_eventsHandler',
	      value: function _eventsHandler(id) {
	        var _this = this,
	            scrollListener = this.scrollListener = 'scroll.zf.' + id;
	
	        _this._setSizes(function () {
	          _this._calc(false);
	          if (_this.canStick) {
	            if (!_this.isOn) {
	              _this._events(id);
	            }
	          } else if (_this.isOn) {
	            _this._pauseListeners(scrollListener);
	          }
	        });
	      }
	
	      /**
	       * Removes event handlers for scroll and change events on anchor.
	       * @fires Sticky#pause
	       * @param {String} scrollListener - unique, namespaced scroll listener attached to `window`
	       */
	
	    }, {
	      key: '_pauseListeners',
	      value: function _pauseListeners(scrollListener) {
	        this.isOn = false;
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off(scrollListener);
	
	        /**
	         * Fires when the plugin is paused due to resize event shrinking the view.
	         * @event Sticky#pause
	         * @private
	         */
	        this.$element.trigger('pause.zf.sticky');
	      }
	
	      /**
	       * Called on every `scroll` event and on `_init`
	       * fires functions based on booleans and cached values
	       * @param {Boolean} checkSizes - true if plugin should recalculate sizes and breakpoints.
	       * @param {Number} scroll - current scroll position passed from scroll event cb function. If not passed, defaults to `window.pageYOffset`.
	       */
	
	    }, {
	      key: '_calc',
	      value: function _calc(checkSizes, scroll) {
	        if (checkSizes) {
	          this._setSizes();
	        }
	
	        if (!this.canStick) {
	          if (this.isStuck) {
	            this._removeSticky(true);
	          }
	          return false;
	        }
	
	        if (!scroll) {
	          scroll = window.pageYOffset;
	        }
	
	        if (scroll >= this.topPoint) {
	          if (scroll <= this.bottomPoint) {
	            if (!this.isStuck) {
	              this._setSticky();
	            }
	          } else {
	            if (this.isStuck) {
	              this._removeSticky(false);
	            }
	          }
	        } else {
	          if (this.isStuck) {
	            this._removeSticky(true);
	          }
	        }
	      }
	
	      /**
	       * Causes the $element to become stuck.
	       * Adds `position: fixed;`, and helper classes.
	       * @fires Sticky#stuckto
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_setSticky',
	      value: function _setSticky() {
	        var _this = this,
	            stickTo = this.options.stickTo,
	            mrgn = stickTo === 'top' ? 'marginTop' : 'marginBottom',
	            notStuckTo = stickTo === 'top' ? 'bottom' : 'top',
	            css = {};
	
	        css[mrgn] = this.options[mrgn] + 'em';
	        css[stickTo] = 0;
	        css[notStuckTo] = 'auto';
	        this.isStuck = true;
	        this.$element.removeClass('is-anchored is-at-' + notStuckTo).addClass('is-stuck is-at-' + stickTo).css(css)
	        /**
	         * Fires when the $element has become `position: fixed;`
	         * Namespaced to `top` or `bottom`, e.g. `sticky.zf.stuckto:top`
	         * @event Sticky#stuckto
	         */
	        .trigger('sticky.zf.stuckto:' + stickTo);
	        this.$element.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function () {
	          _this._setSizes();
	        });
	      }
	
	      /**
	       * Causes the $element to become unstuck.
	       * Removes `position: fixed;`, and helper classes.
	       * Adds other helper classes.
	       * @param {Boolean} isTop - tells the function if the $element should anchor to the top or bottom of its $anchor element.
	       * @fires Sticky#unstuckfrom
	       * @private
	       */
	
	    }, {
	      key: '_removeSticky',
	      value: function _removeSticky(isTop) {
	        var stickTo = this.options.stickTo,
	            stickToTop = stickTo === 'top',
	            css = {},
	            anchorPt = (this.points ? this.points[1] - this.points[0] : this.anchorHeight) - this.elemHeight,
	            mrgn = stickToTop ? 'marginTop' : 'marginBottom',
	            notStuckTo = stickToTop ? 'bottom' : 'top',
	            topOrBottom = isTop ? 'top' : 'bottom';
	
	        css[mrgn] = 0;
	
	        css['bottom'] = 'auto';
	        if (isTop) {
	          css['top'] = 0;
	        } else {
	          css['top'] = anchorPt;
	        }
	
	        this.isStuck = false;
	        this.$element.removeClass('is-stuck is-at-' + stickTo).addClass('is-anchored is-at-' + topOrBottom).css(css)
	        /**
	         * Fires when the $element has become anchored.
	         * Namespaced to `top` or `bottom`, e.g. `sticky.zf.unstuckfrom:bottom`
	         * @event Sticky#unstuckfrom
	         */
	        .trigger('sticky.zf.unstuckfrom:' + topOrBottom);
	      }
	
	      /**
	       * Sets the $element and $container sizes for plugin.
	       * Calls `_setBreakPoints`.
	       * @param {Function} cb - optional callback function to fire on completion of `_setBreakPoints`.
	       * @private
	       */
	
	    }, {
	      key: '_setSizes',
	      value: function _setSizes(cb) {
	        this.canStick = __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */].is(this.options.stickyOn);
	        if (!this.canStick) {
	          if (cb && typeof cb === 'function') {
	            cb();
	          }
	        }
	        var _this = this,
	            newElemWidth = this.$container[0].getBoundingClientRect().width,
	            comp = window.getComputedStyle(this.$container[0]),
	            pdngl = parseInt(comp['padding-left'], 10),
	            pdngr = parseInt(comp['padding-right'], 10);
	
	        if (this.$anchor && this.$anchor.length) {
	          this.anchorHeight = this.$anchor[0].getBoundingClientRect().height;
	        } else {
	          this._parsePoints();
	        }
	
	        this.$element.css({
	          'max-width': newElemWidth - pdngl - pdngr + 'px'
	        });
	
	        var newContainerHeight = this.$element[0].getBoundingClientRect().height || this.containerHeight;
	        if (this.$element.css("display") == "none") {
	          newContainerHeight = 0;
	        }
	        this.containerHeight = newContainerHeight;
	        this.$container.css({
	          height: newContainerHeight
	        });
	        this.elemHeight = newContainerHeight;
	
	        if (!this.isStuck) {
	          if (this.$element.hasClass('is-at-bottom')) {
	            var anchorPt = (this.points ? this.points[1] - this.$container.offset().top : this.anchorHeight) - this.elemHeight;
	            this.$element.css('top', anchorPt);
	          }
	        }
	
	        this._setBreakPoints(newContainerHeight, function () {
	          if (cb && typeof cb === 'function') {
	            cb();
	          }
	        });
	      }
	
	      /**
	       * Sets the upper and lower breakpoints for the element to become sticky/unsticky.
	       * @param {Number} elemHeight - px value for sticky.$element height, calculated by `_setSizes`.
	       * @param {Function} cb - optional callback function to be called on completion.
	       * @private
	       */
	
	    }, {
	      key: '_setBreakPoints',
	      value: function _setBreakPoints(elemHeight, cb) {
	        if (!this.canStick) {
	          if (cb && typeof cb === 'function') {
	            cb();
	          } else {
	            return false;
	          }
	        }
	        var mTop = emCalc(this.options.marginTop),
	            mBtm = emCalc(this.options.marginBottom),
	            topPoint = this.points ? this.points[0] : this.$anchor.offset().top,
	            bottomPoint = this.points ? this.points[1] : topPoint + this.anchorHeight,
	
	
	        // topPoint = this.$anchor.offset().top || this.points[0],
	        // bottomPoint = topPoint + this.anchorHeight || this.points[1],
	        winHeight = window.innerHeight;
	
	        if (this.options.stickTo === 'top') {
	          topPoint -= mTop;
	          bottomPoint -= elemHeight + mTop;
	        } else if (this.options.stickTo === 'bottom') {
	          topPoint -= winHeight - (elemHeight + mBtm);
	          bottomPoint -= winHeight - mBtm;
	        } else {
	          //this would be the stickTo: both option... tricky
	        }
	
	        this.topPoint = topPoint;
	        this.bottomPoint = bottomPoint;
	
	        if (cb && typeof cb === 'function') {
	          cb();
	        }
	      }
	
	      /**
	       * Destroys the current sticky element.
	       * Resets the element to the top position first.
	       * Removes event listeners, JS-added css properties and classes, and unwraps the $element if the JS added the $container.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this._removeSticky(true);
	
	        this.$element.removeClass(this.options.stickyClass + ' is-anchored is-at-top').css({
	          height: '',
	          top: '',
	          bottom: '',
	          'max-width': ''
	        }).off('resizeme.zf.trigger').off('mutateme.zf.trigger');
	        if (this.$anchor && this.$anchor.length) {
	          this.$anchor.off('change.zf.sticky');
	        }
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off(this.scrollListener);
	
	        if (this.wasWrapped) {
	          this.$element.unwrap();
	        } else {
	          this.$container.removeClass(this.options.containerClass).css({
	            height: ''
	          });
	        }
	      }
	    }]);
	
	    return Sticky;
	  }(__WEBPACK_IMPORTED_MODULE_3__foundation_plugin__["a" /* Plugin */]);
	
	  Sticky.defaults = {
	    /**
	     * Customizable container template. Add your own classes for styling and sizing.
	     * @option
	     * @type {string}
	     * @default '&lt;div data-sticky-container&gt;&lt;/div&gt;'
	     */
	    container: '<div data-sticky-container></div>',
	    /**
	     * Location in the view the element sticks to. Can be `'top'` or `'bottom'`.
	     * @option
	     * @type {string}
	     * @default 'top'
	     */
	    stickTo: 'top',
	    /**
	     * If anchored to a single element, the id of that element.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    anchor: '',
	    /**
	     * If using more than one element as anchor points, the id of the top anchor.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    topAnchor: '',
	    /**
	     * If using more than one element as anchor points, the id of the bottom anchor.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    btmAnchor: '',
	    /**
	     * Margin, in `em`'s to apply to the top of the element when it becomes sticky.
	     * @option
	     * @type {number}
	     * @default 1
	     */
	    marginTop: 1,
	    /**
	     * Margin, in `em`'s to apply to the bottom of the element when it becomes sticky.
	     * @option
	     * @type {number}
	     * @default 1
	     */
	    marginBottom: 1,
	    /**
	     * Breakpoint string that is the minimum screen size an element should become sticky.
	     * @option
	     * @type {string}
	     * @default 'medium'
	     */
	    stickyOn: 'medium',
	    /**
	     * Class applied to sticky element, and removed on destruction. Foundation defaults to `sticky`.
	     * @option
	     * @type {string}
	     * @default 'sticky'
	     */
	    stickyClass: 'sticky',
	    /**
	     * Class applied to sticky container. Foundation defaults to `sticky-container`.
	     * @option
	     * @type {string}
	     * @default 'sticky-container'
	     */
	    containerClass: 'sticky-container',
	    /**
	     * Number of scroll events between the plugin's recalculating sticky points. Setting it to `0` will cause it to recalc every scroll event, setting it to `-1` will prevent recalc on scroll.
	     * @option
	     * @type {number}
	     * @default -1
	     */
	    checkEvery: -1
	  };
	
	  /**
	   * Helper function to calculate em values
	   * @param Number {em} - number of em's to calculate into pixels
	   */
	  function emCalc(em) {
	    return parseInt(window.getComputedStyle(document.body, null).fontSize, 10) * em;
	  }
	
	  /***/
	},
	/* 34 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Toggler;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_motion__ = __webpack_require__(6);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_plugin__ = __webpack_require__(2);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_triggers__ = __webpack_require__(5);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Toggler module.
	   * @module foundation.toggler
	   * @requires foundation.util.motion
	   * @requires foundation.util.triggers
	   */
	
	  var Toggler = function (_Plugin) {
	    _inherits(Toggler, _Plugin);
	
	    function Toggler() {
	      _classCallCheck(this, Toggler);
	
	      return _possibleConstructorReturn(this, (Toggler.__proto__ || (0, _getPrototypeOf2.default)(Toggler)).apply(this, arguments));
	    }
	
	    _createClass(Toggler, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of Toggler.
	       * @class
	       * @name Toggler
	       * @fires Toggler#init
	       * @param {Object} element - jQuery object to add the trigger to.
	       * @param {Object} options - Overrides to the default plugin settings.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Toggler.defaults, element.data(), options);
	        this.className = '';
	        this.className = 'Toggler'; // ie9 back compat
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_3__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        this._init();
	        this._events();
	      }
	
	      /**
	       * Initializes the Toggler plugin by parsing the toggle class from data-toggler, or animation classes from data-animate.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        var input;
	        // Parse animation classes if they were set
	        if (this.options.animate) {
	          input = this.options.animate.split(' ');
	
	          this.animationIn = input[0];
	          this.animationOut = input[1] || null;
	        }
	        // Otherwise, parse toggle class
	        else {
	            input = this.$element.data('toggler');
	            // Allow for a . at the beginning of the string
	            this.className = input[0] === '.' ? input.slice(1) : input;
	          }
	
	        // Add ARIA attributes to triggers
	        var id = this.$element[0].id;
	        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-controls', id);
	        // If the target is hidden, add aria-hidden
	        this.$element.attr('aria-expanded', this.$element.is(':hidden') ? false : true);
	      }
	
	      /**
	       * Initializes events for the toggle trigger.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        this.$element.off('toggle.zf.trigger').on('toggle.zf.trigger', this.toggle.bind(this));
	      }
	
	      /**
	       * Toggles the target class on the target element. An event is fired from the original trigger depending on if the resultant state was "on" or "off".
	       * @function
	       * @fires Toggler#on
	       * @fires Toggler#off
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle() {
	        this[this.options.animate ? '_toggleAnimate' : '_toggleClass']();
	      }
	    }, {
	      key: '_toggleClass',
	      value: function _toggleClass() {
	        this.$element.toggleClass(this.className);
	
	        var isOn = this.$element.hasClass(this.className);
	        if (isOn) {
	          /**
	           * Fires if the target element has the class after a toggle.
	           * @event Toggler#on
	           */
	          this.$element.trigger('on.zf.toggler');
	        } else {
	          /**
	           * Fires if the target element does not have the class after a toggle.
	           * @event Toggler#off
	           */
	          this.$element.trigger('off.zf.toggler');
	        }
	
	        this._updateARIA(isOn);
	        this.$element.find('[data-mutate]').trigger('mutateme.zf.trigger');
	      }
	    }, {
	      key: '_toggleAnimate',
	      value: function _toggleAnimate() {
	        var _this = this;
	
	        if (this.$element.is(':hidden')) {
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_motion__["a" /* Motion */].animateIn(this.$element, this.animationIn, function () {
	            _this._updateARIA(true);
	            this.trigger('on.zf.toggler');
	            this.find('[data-mutate]').trigger('mutateme.zf.trigger');
	          });
	        } else {
	          __WEBPACK_IMPORTED_MODULE_1__foundation_util_motion__["a" /* Motion */].animateOut(this.$element, this.animationOut, function () {
	            _this._updateARIA(false);
	            this.trigger('off.zf.toggler');
	            this.find('[data-mutate]').trigger('mutateme.zf.trigger');
	          });
	        }
	      }
	    }, {
	      key: '_updateARIA',
	      value: function _updateARIA(isOn) {
	        this.$element.attr('aria-expanded', isOn ? true : false);
	      }
	
	      /**
	       * Destroys the instance of Toggler on the element.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.off('.zf.toggler');
	      }
	    }]);
	
	    return Toggler;
	  }(__WEBPACK_IMPORTED_MODULE_2__foundation_plugin__["a" /* Plugin */]);
	
	  Toggler.defaults = {
	    /**
	     * Tells the plugin if the element should animated when toggled.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    animate: false
	  };
	
	  /***/
	},
	/* 35 */
	/***/function (module, __webpack_exports__, __webpack_require__) {
	
	  "use strict";
	  /* harmony export (binding) */
	  __webpack_require__.d(__webpack_exports__, "a", function () {
	    return Tooltip;
	  });
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__foundation_util_core__ = __webpack_require__(1);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__ = __webpack_require__(4);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__foundation_util_triggers__ = __webpack_require__(5);
	  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__foundation_positionable__ = __webpack_require__(15);
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  var _get = function get(object, property, receiver) {
	    if (object === null) object = Function.prototype;var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);if (desc === undefined) {
	      var parent = (0, _getPrototypeOf2.default)(object);if (parent === null) {
	        return undefined;
	      } else {
	        return get(parent, property, receiver);
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;if (getter === undefined) {
	        return undefined;
	      }return getter.call(receiver);
	    }
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Tooltip module.
	   * @module foundation.tooltip
	   * @requires foundation.util.box
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.triggers
	   */
	
	  var Tooltip = function (_Positionable) {
	    _inherits(Tooltip, _Positionable);
	
	    function Tooltip() {
	      _classCallCheck(this, Tooltip);
	
	      return _possibleConstructorReturn(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).apply(this, arguments));
	    }
	
	    _createClass(Tooltip, [{
	      key: '_setup',
	
	      /**
	       * Creates a new instance of a Tooltip.
	       * @class
	       * @name Tooltip
	       * @fires Tooltip#init
	       * @param {jQuery} element - jQuery object to attach a tooltip to.
	       * @param {Object} options - object to extend the default configuration.
	       */
	      value: function _setup(element, options) {
	        this.$element = element;
	        this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, Tooltip.defaults, this.$element.data(), options);
	        this.className = 'Tooltip'; // ie9 back compat
	
	        this.isActive = false;
	        this.isClick = false;
	
	        // Triggers init is idempotent, just need to make sure it is initialized
	        __WEBPACK_IMPORTED_MODULE_3__foundation_util_triggers__["a" /* Triggers */].init(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	
	        this._init();
	      }
	
	      /**
	       * Initializes the tooltip by setting the creating the tip element, adding it's text, setting private variables and setting attributes on the anchor.
	       * @private
	       */
	
	    }, {
	      key: '_init',
	      value: function _init() {
	        __WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */]._init();
	        var elemId = this.$element.attr('aria-describedby') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__foundation_util_core__["b" /* GetYoDigits */])(6, 'tooltip');
	
	        this.options.tipText = this.options.tipText || this.$element.attr('title');
	        this.template = this.options.template ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.options.template) : this._buildTemplate(elemId);
	
	        if (this.options.allowHtml) {
	          this.template.appendTo(document.body).html(this.options.tipText).hide();
	        } else {
	          this.template.appendTo(document.body).text(this.options.tipText).hide();
	        }
	
	        this.$element.attr({
	          'title': '',
	          'aria-describedby': elemId,
	          'data-yeti-box': elemId,
	          'data-toggle': elemId,
	          'data-resize': elemId
	        }).addClass(this.options.triggerClass);
	
	        _get(Tooltip.prototype.__proto__ || (0, _getPrototypeOf2.default)(Tooltip.prototype), '_init', this).call(this);
	        this._events();
	      }
	    }, {
	      key: '_getDefaultPosition',
	      value: function _getDefaultPosition() {
	        // handle legacy classnames
	        var position = this.$element[0].className.match(/\b(top|left|right|bottom)\b/g);
	        return position ? position[0] : 'top';
	      }
	    }, {
	      key: '_getDefaultAlignment',
	      value: function _getDefaultAlignment() {
	        return 'center';
	      }
	    }, {
	      key: '_getHOffset',
	      value: function _getHOffset() {
	        if (this.position === 'left' || this.position === 'right') {
	          return this.options.hOffset + this.options.tooltipWidth;
	        } else {
	          return this.options.hOffset;
	        }
	      }
	    }, {
	      key: '_getVOffset',
	      value: function _getVOffset() {
	        if (this.position === 'top' || this.position === 'bottom') {
	          return this.options.vOffset + this.options.tooltipHeight;
	        } else {
	          return this.options.vOffset;
	        }
	      }
	
	      /**
	       * builds the tooltip element, adds attributes, and returns the template.
	       * @private
	       */
	
	    }, {
	      key: '_buildTemplate',
	      value: function _buildTemplate(id) {
	        var templateClasses = (this.options.tooltipClass + ' ' + this.options.positionClass + ' ' + this.options.templateClasses).trim();
	        var $template = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div></div>').addClass(templateClasses).attr({
	          'role': 'tooltip',
	          'aria-hidden': true,
	          'data-is-active': false,
	          'data-is-focus': false,
	          'id': id
	        });
	        return $template;
	      }
	
	      /**
	       * sets the position class of an element and recursively calls itself until there are no more possible positions to attempt, or the tooltip element is no longer colliding.
	       * if the tooltip is larger than the screen width, default to full width - any user selected margin
	       * @private
	       */
	
	    }, {
	      key: '_setPosition',
	      value: function _setPosition() {
	        _get(Tooltip.prototype.__proto__ || (0, _getPrototypeOf2.default)(Tooltip.prototype), '_setPosition', this).call(this, this.$element, this.template);
	      }
	
	      /**
	       * reveals the tooltip, and fires an event to close any other open tooltips on the page
	       * @fires Tooltip#closeme
	       * @fires Tooltip#show
	       * @function
	       */
	
	    }, {
	      key: 'show',
	      value: function show() {
	        if (this.options.showOn !== 'all' && !__WEBPACK_IMPORTED_MODULE_2__foundation_util_mediaQuery__["a" /* MediaQuery */].is(this.options.showOn)) {
	          // console.error('The screen is too small to display this tooltip');
	          return false;
	        }
	
	        var _this = this;
	        this.template.css('visibility', 'hidden').show();
	        this._setPosition();
	        this.template.removeClass('top bottom left right').addClass(this.position);
	        this.template.removeClass('align-top align-bottom align-left align-right align-center').addClass('align-' + this.alignment);
	
	        /**
	         * Fires to close all other open tooltips on the page
	         * @event Closeme#tooltip
	         */
	        this.$element.trigger('closeme.zf.tooltip', this.template.attr('id'));
	
	        this.template.attr({
	          'data-is-active': true,
	          'aria-hidden': false
	        });
	        _this.isActive = true;
	        // console.log(this.template);
	        this.template.stop().hide().css('visibility', '').fadeIn(this.options.fadeInDuration, function () {
	          //maybe do stuff?
	        });
	        /**
	         * Fires when the tooltip is shown
	         * @event Tooltip#show
	         */
	        this.$element.trigger('show.zf.tooltip');
	      }
	
	      /**
	       * Hides the current tooltip, and resets the positioning class if it was changed due to collision
	       * @fires Tooltip#hide
	       * @function
	       */
	
	    }, {
	      key: 'hide',
	      value: function hide() {
	        // console.log('hiding', this.$element.data('yeti-box'));
	        var _this = this;
	        this.template.stop().attr({
	          'aria-hidden': true,
	          'data-is-active': false
	        }).fadeOut(this.options.fadeOutDuration, function () {
	          _this.isActive = false;
	          _this.isClick = false;
	        });
	        /**
	         * fires when the tooltip is hidden
	         * @event Tooltip#hide
	         */
	        this.$element.trigger('hide.zf.tooltip');
	      }
	
	      /**
	       * adds event listeners for the tooltip and its anchor
	       * TODO combine some of the listeners like focus and mouseenter, etc.
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        var _this = this;
	        var $template = this.template;
	        var isFocus = false;
	
	        if (!this.options.disableHover) {
	
	          this.$element.on('mouseenter.zf.tooltip', function (e) {
	            if (!_this.isActive) {
	              _this.timeout = setTimeout(function () {
	                _this.show();
	              }, _this.options.hoverDelay);
	            }
	          }).on('mouseleave.zf.tooltip', function (e) {
	            clearTimeout(_this.timeout);
	            if (!isFocus || _this.isClick && !_this.options.clickOpen) {
	              _this.hide();
	            }
	          });
	        }
	
	        if (this.options.clickOpen) {
	          this.$element.on('mousedown.zf.tooltip', function (e) {
	            e.stopImmediatePropagation();
	            if (_this.isClick) {
	              //_this.hide();
	              // _this.isClick = false;
	            } else {
	              _this.isClick = true;
	              if ((_this.options.disableHover || !_this.$element.attr('tabindex')) && !_this.isActive) {
	                _this.show();
	              }
	            }
	          });
	        } else {
	          this.$element.on('mousedown.zf.tooltip', function (e) {
	            e.stopImmediatePropagation();
	            _this.isClick = true;
	          });
	        }
	
	        if (!this.options.disableForTouch) {
	          this.$element.on('tap.zf.tooltip touchend.zf.tooltip', function (e) {
	            _this.isActive ? _this.hide() : _this.show();
	          });
	        }
	
	        this.$element.on({
	          // 'toggle.zf.trigger': this.toggle.bind(this),
	          // 'close.zf.trigger': this.hide.bind(this)
	          'close.zf.trigger': this.hide.bind(this)
	        });
	
	        this.$element.on('focus.zf.tooltip', function (e) {
	          isFocus = true;
	          if (_this.isClick) {
	            // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
	            // a real focus, otherwise on hover and come back we get bad behavior
	            if (!_this.options.clickOpen) {
	              isFocus = false;
	            }
	            return false;
	          } else {
	            _this.show();
	          }
	        }).on('focusout.zf.tooltip', function (e) {
	          isFocus = false;
	          _this.isClick = false;
	          _this.hide();
	        }).on('resizeme.zf.trigger', function () {
	          if (_this.isActive) {
	            _this._setPosition();
	          }
	        });
	      }
	
	      /**
	       * adds a toggle method, in addition to the static show() & hide() functions
	       * @function
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle() {
	        if (this.isActive) {
	          this.hide();
	        } else {
	          this.show();
	        }
	      }
	
	      /**
	       * Destroys an instance of tooltip, removes template element from the view.
	       * @function
	       */
	
	    }, {
	      key: '_destroy',
	      value: function _destroy() {
	        this.$element.attr('title', this.template.text()).off('.zf.trigger .zf.tooltip').removeClass('has-tip top right left').removeAttr('aria-describedby aria-haspopup data-disable-hover data-resize data-toggle data-tooltip data-yeti-box');
	
	        this.template.remove();
	      }
	    }]);
	
	    return Tooltip;
	  }(__WEBPACK_IMPORTED_MODULE_4__foundation_positionable__["a" /* Positionable */]);
	
	  Tooltip.defaults = {
	    disableForTouch: false,
	    /**
	     * Time, in ms, before a tooltip should open on hover.
	     * @option
	     * @type {number}
	     * @default 200
	     */
	    hoverDelay: 200,
	    /**
	     * Time, in ms, a tooltip should take to fade into view.
	     * @option
	     * @type {number}
	     * @default 150
	     */
	    fadeInDuration: 150,
	    /**
	     * Time, in ms, a tooltip should take to fade out of view.
	     * @option
	     * @type {number}
	     * @default 150
	     */
	    fadeOutDuration: 150,
	    /**
	     * Disables hover events from opening the tooltip if set to true
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    disableHover: false,
	    /**
	     * Optional addtional classes to apply to the tooltip template on init.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    templateClasses: '',
	    /**
	     * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
	     * @option
	     * @type {string}
	     * @default 'tooltip'
	     */
	    tooltipClass: 'tooltip',
	    /**
	     * Class applied to the tooltip anchor element.
	     * @option
	     * @type {string}
	     * @default 'has-tip'
	     */
	    triggerClass: 'has-tip',
	    /**
	     * Minimum breakpoint size at which to open the tooltip.
	     * @option
	     * @type {string}
	     * @default 'small'
	     */
	    showOn: 'small',
	    /**
	     * Custom template to be used to generate markup for tooltip.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    template: '',
	    /**
	     * Text displayed in the tooltip template on open.
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    tipText: '',
	    touchCloseText: 'Tap to close.',
	    /**
	     * Allows the tooltip to remain open if triggered with a click or touch event.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    clickOpen: true,
	    /**
	     * DEPRECATED Additional positioning classes, set by the JS
	     * @option
	     * @type {string}
	     * @default ''
	     */
	    positionClass: '',
	    /**
	     * Position of tooltip. Can be left, right, bottom, top, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    position: 'auto',
	    /**
	     * Alignment of tooltip relative to anchor. Can be left, right, bottom, top, center, or auto.
	     * @option
	     * @type {string}
	     * @default 'auto'
	     */
	    alignment: 'auto',
	    /**
	     * Allow overlap of container/window. If false, tooltip will first try to
	     * position as defined by data-position and data-alignment, but reposition if
	     * it would cause an overflow.  @option
	     * @type {boolean}
	     * @default false
	     */
	    allowOverlap: false,
	    /**
	     * Allow overlap of only the bottom of the container. This is the most common
	     * behavior for dropdowns, allowing the dropdown to extend the bottom of the
	     * screen but not otherwise influence or break out of the container.
	     * Less common for tooltips.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    allowBottomOverlap: false,
	    /**
	     * Distance, in pixels, the template should push away from the anchor on the Y axis.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    vOffset: 0,
	    /**
	     * Distance, in pixels, the template should push away from the anchor on the X axis
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    hOffset: 0,
	    /**
	     * Distance, in pixels, the template spacing auto-adjust for a vertical tooltip
	     * @option
	     * @type {number}
	     * @default 14
	     */
	    tooltipHeight: 14,
	    /**
	     * Distance, in pixels, the template spacing auto-adjust for a horizontal tooltip
	     * @option
	     * @type {number}
	     * @default 12
	     */
	    tooltipWidth: 12,
	    /**
	    * Allow HTML in tooltip. Warning: If you are loading user-generated content into tooltips,
	    * allowing HTML may open yourself up to XSS attacks.
	    * @option
	    * @type {boolean}
	    * @default false
	    */
	    allowHtml: false
	  };
	
	  /**
	   * TODO utilize resize event trigger
	   */
	
	  /***/
	},
	/* 36 */
	/***/function (module, exports, __webpack_require__) {
	
	  module.exports = __webpack_require__(19);
	
	  /***/
	}]
	/******/);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// NOTE: in WP we use the WP intern jQuery version
	// globally "export" jquery for our plugins
	// import jQuery from 'jquery';
	
	// import version from './lib/version';
	
	__webpack_require__(116);
	
	__webpack_require__(96);
	
	__webpack_require__(100);
	
	var _oldBrowser = __webpack_require__(99);
	
	var _oldBrowser2 = _interopRequireDefault(_oldBrowser);
	
	var _scrollUp = __webpack_require__(95);
	
	var _scrollUp2 = _interopRequireDefault(_scrollUp);
	
	__webpack_require__(104);
	
	__webpack_require__(108);
	
	__webpack_require__(102);
	
	__webpack_require__(110);
	
	__webpack_require__(109);
	
	__webpack_require__(112);
	
	__webpack_require__(111);
	
	__webpack_require__(106);
	
	__webpack_require__(107);
	
	__webpack_require__(105);
	
	var _cards = __webpack_require__(101);
	
	var _cards2 = _interopRequireDefault(_cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = {
	    shuffle: __webpack_require__(164)
	};
	
	// ////////////////////////////////////////////////////////////
	// init foundation
	
	
	// ////////////////////////////////////////////////////////////
	// track contact form 7 submissions
	jQuery(function ($) {
	    var $menuButton = $('.menu-toggle .hamburger'),
	        $offCanvasInner = $('.off-canvas-wrapper-inner'),
	        $primaryNav = $('.primary-nav');
	
	    $primaryNav.css('opacity', 1);
	
	    $(document).foundation().on('opened.zf.offcanvas', function () {
	        $menuButton.addClass('is-active');
	
	        $offCanvasInner.addClass('js-off-canvas-opened');
	        $offCanvasInner.removeClass('js-off-canvas-closed');
	    }).on('closed.zf.offcanvas', function () {
	        $menuButton.removeClass('is-active');
	
	        $offCanvasInner.addClass('js-off-canvas-closed');
	        $offCanvasInner.removeClass('js-off-canvas-opened');
	    });
	
	    $('[data-random]').each(function (index, el) {
	        var $el = $(el);
	
	        $el.append(_.shuffle($el.children().toArray())).addClass('is-init');
	    });
	
	    $('.js--history-back').on('click', function () {
	        history.back();
	    });
	
	    $('.js--leading-slash').before('<span class="show-on-post"> / </span>');
	
	    $('a').has('img').addClass('no-link-icon');
	
	    // you can listen to breakpoint changes like so:
	    // $(window).on('changed.zf.mediaquery', (event, current, old) => {
	    //    console.log(`Breakpoint changed from "${old}" to "${current}"`);
	    // });
	});
	
	// ////////////////////////////////////////////////////////////
	// browser alerts
	
	(0, _oldBrowser2.default)();
	
	// ////////////////////////////////////////////////////////////
	// scroll events
	
	(0, _scrollUp2.default)();
	
	// ////////////////////////////////////////////////////////////
	// sliding header
	
	
	// ////////////////////////////////////////////////////////////
	// login button/form
	
	
	// ////////////////////////////////////////////////////////////
	// form helpers
	
	
	// ////////////////////////////////////////////////////////////
	// password-lost form
	
	
	// ////////////////////////////////////////////////////////////
	// modal
	
	
	// ////////////////////////////////////////////////////////////
	// teaser
	
	
	// ////////////////////////////////////////////////////////////
	// table
	
	
	// ////////////////////////////////////////////////////////////
	// masonry
	
	
	// ////////////////////////////////////////////////////////////
	// swiper
	
	
	// ////////////////////////////////////////////////////////////
	// map
	
	
	// ////////////////////////////////////////////////////////////
	// cards
	
	(0, _cards2.default)();

/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$selector = _ref.selector,
	        selector = _ref$selector === undefined ? '.browser-alert--browsehappy' : _ref$selector,
	        _ref$closeSelector = _ref.closeSelector,
	        closeSelector = _ref$closeSelector === undefined ? '.js-close-browser-alert-info' : _ref$closeSelector;
	
	    jQuery(function ($) {
	        var $element = $(selector),
	            oldBrowser = (0, _oldBrowserCheck2.default)({
	            ie: '11',
	            firefox: '40',
	            chrome: '40',
	            opera: '31',
	            safari: '8',
	            android: '4.4'
	        });
	
	        if (oldBrowser) {
	            $element.show();
	
	            // init the close click to fade out the element
	            $(closeSelector).click(function (event) {
	                event.preventDefault();
	                $element.fadeOut();
	            });
	        }
	    });
	};
	
	var _oldBrowserCheck = __webpack_require__(94);
	
	var _oldBrowserCheck2 = _interopRequireDefault(_oldBrowserCheck);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	var sentPageview = false;
	
	jQuery(function ($) {
	    // send pageview when cf7 hook was fired
	    $(document).on('wpcf7mailsent', function () {
	        if (window.dataLayer) {
	            window.dataLayer.push({
	                event: 'VirtualPageview',
	                virtualPageURL: location.pathname + 'success/',
	                virtualPageTitle: 'CF7 Success'
	            });
	        }
	        sentPageview = true;
	    });
	
	    // when the hook hasn't fired, check if the class indicating this event exists and fire pageview
	    if (!sentPageview && $('.wpcf7-mail-sent-ok').length) {
	        setTimeout(function () {
	            if (window.dataLayer) {
	                window.dataLayer.push({
	                    event: 'VirtualPageview',
	                    virtualPageURL: location.pathname + 'success/',
	                    virtualPageTitle: 'CF7 Success'
	                });
	            }
	            sentPageview = true;
	        }, 500);
	    }
	});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(117);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = cards;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Manages clickability of card components.
	 * Clickable card components are identified by attributes `data-card` and `data-clickable`.
	 * Non-clickable card sub-components are identified by attribute `data-card-not-clickable`.
	 * @see https://inclusive-components.design/cards/
	 */
	function cards() {
	    var selector = '[data-card][data-clickable]',
	        ignoreClicksTo = '[data-card-not-clickable]',
	        linkSelector = '[data-card-link]',
	        listenerOptions = { passive: true };
	
	    var downTimestamp = void 0,
	        downTarget = void 0,
	        downCoords = void 0,
	        upTimestamp = void 0,
	        upTarget = void 0,
	        upCoords = void 0,
	        moveThreshold = 10;
	
	    document.addEventListener('mousedown', function (event) {
	        if (event.target.closest(selector)) {
	            downTimestamp = performance.now();
	            downTarget = event.target.closest(selector);
	            downCoords = {
	                x: event.clientX,
	                y: event.clientY
	            };
	        }
	    }, listenerOptions);
	
	    document.addEventListener('mouseup', function (event) {
	        if (!event.target.closest(selector) || event.target.closest(ignoreClicksTo)) {
	            return;
	        }
	
	        upTimestamp = performance.now();
	        upTarget = event.target.closest(selector);
	        upCoords = {
	            x: event.clientX,
	            y: event.clientY
	        };
	
	        var clickableCard = upTarget,
	            link = clickableCard && clickableCard.querySelector(linkSelector);
	
	        if (upTimestamp - downTimestamp < 200 && downTarget === upTarget && (downTarget.matches('a') === false || downTarget.matches(linkSelector)) && Math.abs(downCoords.x - upCoords.x) <= moveThreshold && Math.abs(downCoords.y - upCoords.y) <= moveThreshold && Boolean(clickableCard) && Boolean(link) && upTarget !== link) {
	            // simulate a click on the link
	            link.click();
	        }
	    }, (0, _assign2.default)({}, listenerOptions, { capture: true }));
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global wpbp_app */
	// only load our form helpers if we have a form on the current page
	jQuery(function ($) {
	    if ($('form').length || window.patternlab) {
	        __webpack_require__.e/* nsure */(4, function (require) {
	            var selectAll = void 0,
	                fileInput = void 0,
	                floatingLabel = void 0,
	                $viewportMeta = $('meta[name="viewport"]'),
	                viewportMetaContent = $viewportMeta.attr('content'),
	                zoomEnableTimeout = function zoomEnableTimeout() {},
	                $showSummary = void 0,
	                $copyData = void 0,
	                scrollTo = __webpack_require__(84).default;
	
	            // prevent mobile zoom in
	            $('input, select, textarea').bind('touchstart focus blur', function (event) {
	                if (event.type === 'blur') {
	                    zoomEnableTimeout = setTimeout(function () {
	                        $viewportMeta.attr('content', viewportMetaContent);
	                    }, 100);
	                } else {
	                    clearTimeout(zoomEnableTimeout);
	                    $viewportMeta.attr('content', viewportMetaContent + ',maximum-scale=1');
	                }
	            });
	
	            // include form validation via parsley (with German language)
	            __webpack_require__(103);
	
	            // enable an (de)select all radiobutton and checkboxes possibility
	            selectAll = __webpack_require__(92).default;
	            selectAll();
	
	            // style advanced file inputs
	            fileInput = __webpack_require__(89).default;
	            fileInput({
	                multibleFilesLabel: ':anz Dateien ausgewählt'
	            });
	
	            // automatically attach an loading indicator to submit buttons on form submit
	            floatingLabel = __webpack_require__(90).default;
	            floatingLabel();
	
	            $showSummary = $('.js--show-summary');
	
	            if ($showSummary.length) {
	                $showSummary.each(function (i, el) {
	                    var $summaryButton = $(el),
	                        onFormSubmit = function onFormSubmit(event) {
	                        return event.preventDefault();
	                    },
	                        $form = $summaryButton.closest('form').on('submit.js-show-summary', onFormSubmit);
	
	                    $summaryButton.on('click', function () {
	                        $form.parsley().whenValidate().then(function () {
	                            $form.find('label').each(function (i, label) {
	                                var $label = $(label),
	                                    $input = $label.find('input, select, textarea'),
	                                    val = void 0,
	                                    $detail = void 0;
	
	                                if (!$input.length) {
	                                    return;
	                                }
	
	                                if ($input.is('select')) {
	                                    val = $input.find('option[value=\'' + $input.val() + '\']').text();
	                                } else if ($input.is('[type="checkbox"]')) {
	                                    if ($input.prop('checked')) {
	                                        $input.clone().attr('type', 'hidden').insertAfter($input);
	                                    }
	
	                                    $input.prop('disabled', true);
	                                    return;
	                                } else {
	                                    val = $input.val();
	                                }
	
	                                $detail = $label.siblings('.js--summary__detail');
	
	                                if ($detail.length) {
	                                    $detail.find('span').text(val);
	                                    $detail.show();
	                                } else {
	                                    $('<div class="js--summary__detail">\n                                        <strong>' + $label.find('.label-floating__label').text() + '</strong>: <span>' + val + '</span>\n                                    </div>').insertAfter($label);
	                                }
	
	                                $label.hide();
	                            });
	
	                            $summaryButton.hide();
	                            $copyData.hide();
	                            $form.closest('.wpcf7').siblings('p').hide();
	                            $('.js--initial-text').hide();
	                            $('.js--review-text').show();
	                            $form.off('submit.js-show-summary').find('.js--summary-controls').show();
	
	                            scrollTo({ duration: 500 });
	                        });
	                    });
	
	                    $('.js--summary-back').on('click', function (event) {
	                        var $button = $(event.target),
	                            $form = $button.closest('form');
	
	                        $form.on('submit.js-show-summary', onFormSubmit).find('.js--summary__detail').hide().end().find('label').show().end().find('input[disabled] + input[type="hidden"]').remove().end().find('input[disabled]').prop('disabled', false);
	
	                        $form.closest('.wpcf7').siblings('p').show();
	                        $('.js--initial-text').show();
	                        $('.js--review-text').hide();
	                        $copyData.show();
	                        $button.closest('.js--summary-controls').hide();
	                        $summaryButton.show();
	                    });
	
	                    $form.closest('.wpcf7').on('wpcf7mailsent', function () {
	                        /* eslint-disable camelcase */
	                        if (wpbp_app && wpbp_app.redirect) {
	                            location.href = wpbp_app.redirect;
	                        }
	                        /* eslint-enable */
	                    });
	                });
	            }
	
	            $copyData = $('.js--copy-data').on('click', function (event) {
	                var $button = $(event.target),
	                    $form = $button.closest('form');
	
	                $form.find('input[name="firma_abweichend"]').val($form.find('input[name="firma"]').val()).trigger('focusout');
	                $form.find('input[name="vorname_abweichend"]').val($form.find('input[name="vorname"]').val()).trigger('focusout');
	                $form.find('input[name="nachname_abweichend"]').val($form.find('input[name="nachname"]').val()).trigger('focusout');
	                $form.find('input[name="adresse_abweichend"]').val($form.find('input[name="adresse"]').val()).trigger('focusout');
	                $form.find('input[name="zip_abweichend"]').val($form.find('input[name="zip"]').val()).trigger('focusout');
	                $form.find('input[name="ort_abweichend"]').val($form.find('input[name="ort"]').val()).trigger('focusout');
	                $form.find('input[name="land_abweichend"]').val($form.find('input[name="land"]').val()).trigger('focusout');
	                $form.find('input[name="position_abweichend"]').val($form.find('input[name="position"]').val()).trigger('focusout');
	                $form.find('input[name="email_abweichend"]').val($form.find('input[name="email"]').val()).trigger('focusout');
	            });
	        });
	    }
	});

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(86);
	
	jQuery(function ($) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	        __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(157), __webpack_require__(86)]; (function () {
	            var $headroom = $('.headroom'),
	                $headroomSpacing = $('.headroom-spacing');
	
	            $(window).on('resize', function () {
	                if ($headroom.is('.headroom--fixed')) {
	                    $headroom.css('margin-top', 0);
	                }
	
	                $headroomSpacing.css('padding-top', $headroom.outerHeight());
	            }).trigger('resize');
	
	            $headroom.headroom({
	                offset: $headroom.height(),
	                tolerance: 20, // mostly used for touch-pads/-screens
	                classes: {
	                    initial: 'headroom--headroom',
	                    pinned: 'headroom--fixed',
	                    unpinned: 'headroom--unfixed',
	                    top: 'headroom--top',
	                    notTop: 'headroom--not-top'
	                },
	                onTop: function onTop() {
	                    $headroom.removeClass('headroom--fixed').css('margin-top', 0);
	
	                    $headroom.data('headroom').offset = $headroom.height();
	
	                    $headroomSpacing.css('padding-top', $headroom.outerHeight());
	                },
	                onPin: function onPin() {
	                    $headroom.data('headroom').offset = 0;
	
	                    $headroomSpacing.css('padding-top', $headroom.outerHeight());
	                },
	                onUnpin: function onUnpin() {
	                    $headroom.css('margin-top', 0);
	                }
	            });
	        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	    });
	});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _version = __webpack_require__(113);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	jQuery(function ($) {
	    var $maps = $('.map');
	
	    if ($maps.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(180)]; (function ($script) {
	                // load google maps
	                $script('https://maps.googleapis.com/maps/api/js?key=AIzaSyC8L4lKytcd0KbYEAfhT0aqzGkjh2Phr9M', function () {
	                    // loop over map container
	                    $maps.each(function (i, container) {
	                        var $container = $(container),
	                            map = new google.maps.Map($container.find('.map__iframe')[0]),
	                            markers = [],
	                            bounds = new google.maps.LatLngBounds();
	
	                        // add placemarks to the map
	                        $container.find('.map__list__item div').each(function (i, item) {
	                            var $item = $(item),
	                                pinFile = 'assets/img/placemarks/marker.png',
	                                position = new google.maps.LatLng($item.data('lat'), $item.data('lng'));
	
	                            markers.push(position);
	
	                            (0, _version2.default)(pinFile).then(function (pin) {
	                                var marker = new google.maps.Marker({
	                                    map: map,
	                                    position: position,
	                                    title: $item.data('title'),
	                                    cursor: 'pointer',
	                                    icon: {
	                                        size: new google.maps.Size(600, 495),
	                                        scaledSize: new google.maps.Size(36, 33),
	                                        origin: new google.maps.Point(0, 0),
	                                        anchor: new google.maps.Point(24, 43),
	                                        url: pin
	                                    }
	                                });
	
	                                marker.addListener('click', function () {
	                                    $item.find('a')[0].click();
	                                });
	                            });
	                        });
	
	                        // set the bounds based on the markers
	                        markers.forEach(function (position) {
	                            bounds.extend(position);
	                        });
	
	                        map.fitBounds(bounds);
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    var $masonry = $('.masonry');
	
	    if ($masonry.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(160), __webpack_require__(161), __webpack_require__(165)]; (function (imagesLoaded, jQueryBridget, Masonry) {
	                // init jQuery on imageloaded
	                imagesLoaded.makeJQueryPlugin($);
	
	                // make Masonry a jQuery plugin
	                jQueryBridget('masonry', Masonry, $);
	
	                // loop over all our masonry blocks and init them
	                $masonry.each(function (i, container) {
	                    var $container = $(container);
	
	                    $container.imagesLoaded(function () {
	                        $container.masonry({
	                            columnWidth: '.masonry__sizer',
	                            itemSelector: '.masonry__item',
	                            percentPosition: true,
	                            fitWidth: $container.data('fit-width') || false,
	                            horizontalOrder: true
	                        });
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    var $swiper = $('.swiper-container');
	
	    if ($swiper.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(87)]; (function (Swiper) {
	                // loop over swiper instances and init them
	                $swiper.each(function (i, container) {
	                    var $container = $(container),
	                        centeredSlides = $container.data('centered-slides'),
	                        height = $container.data('height') || undefined;
	
	                    new Swiper(container, {
	                        loop: true,
	                        autoHeight: height === 'auto',
	                        height: !isNaN(height) ? height : undefined,
	                        centeredSlides: centeredSlides !== true && centeredSlides !== false ? true : centeredSlides,
	                        slidesPerView: 'auto',
	                        autoplay: $container.data('autoplay') || false,
	                        spaceBetween: $container.data('space-between') || 0,
	
	                        nextButton: $container.parent().find('.swiper-button-next'),
	                        prevButton: $container.parent().find('.swiper-button-prev'),
	
	                        onSlideChangeEnd: function onSlideChangeEnd() {
	                            // force repaint after slide, some browser have render issues otherwise
	                            $container.each(function () {
	                                this.style.display = 'none';
	                                this.offsetHeight;
	                                this.style.display = 'block';
	                            });
	                        }
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function ($) {
	    var $body = $('body'),
	        $loginBtn = $('.js-login');
	
	    $loginBtn.on('click', function (event) {
	        if (!$loginBtn.data('logged-in')) {
	            event.preventDefault();
	            $loginBtn.toggleClass('is-form-open');
	            $body.toggleClass('is-login-form-open');
	        }
	    });
	
	    $('#loginform-header').on('submit', function (event) {
	        event.preventDefault();
	
	        var $form = $(this),
	            $inputs = $form.find('input, button'),
	            redirectUrl = $form.attr('action'),
	            userName = $form.find('[name="log"]').val(),
	            password = $form.find('[name="pwd"]').val(),
	            remember = $form.find('[name="rememberme"]').val(),
	            security = $form.find('#sec').val();
	
	        if (!redirectUrl) {
	            if ($form.find('[name="redirect_to"]').length) {
	                redirectUrl = $form.find('[name="redirect_to"]').val();
	            } else if (location.search.indexOf('redirect_to') != -1) {
	                redirectUrl = location.search.split('redirect_to=')[1].substr(0, location.search.indexOf('&') >= 0 ? location.search.indexOf('&') : undefined);
	            } else {
	                redirectUrl = undefined;
	            }
	        }
	
	        $inputs.prop('disabled', true);
	
	        $.post(wpbp_app.ajax_url, {
	            action: 'wpbp-login',
	            userName: userName,
	            password: password,
	            remember: remember,
	            redirectUrl: redirectUrl,
	            security: security
	        }).done(function (res) {
	            $form.find('.is-loading').removeClass('is-loading');
	
	            if (!res.error || res.error == 'valid') {
	                $inputs.prop('disabled', false);
	            }
	
	            document.location.href = res.redirecturl;
	        });
	    });
	}); /* global wpbp_app */

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// only load our form helpers if we have a form on the current page
	jQuery(function ($) {
	    if ($('.js-modal').length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function () {
	            __webpack_require__(177);
	            $('.js-modal').iziModal();
	        });
	    }
	});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global wpbp_app */
	jQuery(function ($) {
	    var $form = $('#password-lost');
	
	    if ($form.length) {
	        __webpack_require__.e/* nsure */(5, function (require) {
	            !/* require */(/* empty */[__webpack_require__(53), __webpack_require__(52)]);
	            $form.parsley().on('form:submit', function () {
	                var $email = $form.find('[name="user_email"]'),
	                    email = $email.val(),
	                    $inputs = $email.add($form.find('.btn[type="submit"]')),
	                    security = $form.find('#pwsec').val();
	
	                $inputs.prop('disabled', true);
	
	                $.post(wpbp_app.ajax_url, {
	                    action: 'wpbp-password-lost',
	                    user_email: email,
	                    security: security
	                }).then(function () {
	                    $form.remove();
	
	                    $('.success').html('\n                            <a class="link" href="' + wpbp_app.passwordLost.loginUrl + '">' + wpbp_app.passwordLost.loginLinkLabel + '</a>\n                        ');
	                });
	
	                // prevent submission
	                return false;
	            });
	        });
	    }
	});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function ($) {
	    var $table = $('table'),
	        direction = {
	        left: 1,
	        right: -1
	    };
	
	    if ($table.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function () {
	            $table.each(function () {
	                var $table = $(this),
	                    $tableScroll = $table.closest('.table-scroll'),
	                    scrollOffset = 20,
	                    tableScrolling = void 0,
	                    distancePerTick = 10,
	                    table = this,
	                    tableScroll = void 0,
	                    canShowIndicators = void 0,
	                    $indicators = void 0,
	                    $indicatorLeft = void 0,
	                    $indicatorRight = void 0;
	
	                if (!$tableScroll.length) {
	                    $tableScroll = $('<div class="table-scroll" />').insertBefore($table).append($table);
	                }
	
	                tableScroll = $tableScroll[0];
	
	                $tableScroll.wrap($('<div class="table-scroll-indicators" />'));
	
	                $indicatorLeft = $('<div class="table-scroll-indicators__indicator table-scroll-indicators__indicator--left">\n                    <button class="btn btn--icon"><i class="icon icon--arrow-2ndLevel-left"></i></button>\n                </div>').prependTo($tableScroll);
	
	                $indicatorRight = $('<div class="table-scroll-indicators__indicator table-scroll-indicators__indicator--right">\n                    <button class="btn btn--icon"><i class="icon icon--arrow-2ndLevel-right"></i></button>\n                </div>').appendTo($tableScroll);
	
	                $indicators = $().add($indicatorLeft).add($indicatorRight);
	
	                function showIndicators() {
	                    $indicatorLeft.toggleClass('is-visible', canShowIndicators && tableScroll.scrollLeft !== 0);
	                    $indicatorRight.toggleClass('is-visible', canShowIndicators && tableScroll.scrollLeft < table.scrollWidth - $tableScroll.width());
	                }
	
	                function hideIndicators() {
	                    $indicators.removeClass('is-visible');
	                }
	
	                $(window).on('resize', function () {
	                    $indicators.height($table.outerHeight());
	
	                    canShowIndicators = table.scrollWidth > $tableScroll.width() + scrollOffset;
	
	                    if (canShowIndicators) {
	                        showIndicators();
	                    } else {
	                        hideIndicators();
	                    }
	                }).trigger('resize');
	
	                $tableScroll.on('scroll', function () {
	                    showIndicators();
	                });
	
	                function scrollStop() {
	                    clearInterval(tableScrolling);
	                }
	
	                function scrollStart(direction) {
	                    scrollStop();
	
	                    tableScrolling = setInterval(function () {
	                        tableScroll.scrollLeft -= distancePerTick * direction;
	                    }, 10);
	                }
	
	                function startLeftScrolling(event) {
	                    event.preventDefault();scrollStart(direction.left);
	                }
	                function startRightScrolling(event) {
	                    event.preventDefault();scrollStart(direction.right);
	                }
	                function stopScrolling(event) {
	                    event.preventDefault();scrollStop();
	                }
	
	                $('.table-scroll-indicators__indicator--left .btn').on('mousedown', startLeftScrolling).on('touchstart', startLeftScrolling).on('mouseup', stopScrolling).on('mouseleave', stopScrolling).on('touchend', stopScrolling).on('touchleave', stopScrolling).on('touchcancel', stopScrolling);
	
	                $('.table-scroll-indicators__indicator--right .btn').on('mousedown', startRightScrolling).on('touchstart', startRightScrolling).on('mouseup', stopScrolling).on('mouseleave', stopScrolling).on('touchend', stopScrolling).on('touchleave', stopScrolling).on('touchcancel', stopScrolling);
	            });
	        });
	    }
	});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(10);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function ($) {
	    if ($('.teaser--slider').length) {
	        __webpack_require__.e/* nsure */(1, function (require) {
	            var Swiper = __webpack_require__(87);
	
	            $('.teaser--slider').each(function (index, slider) {
	                var $tabItems = $(slider).find('.teaser__tabs__item'),
	                    activeClass = 'is-active',
	                    imageSwiper = new Swiper('.teaser__images', {
	                    centeredSlides: false,
	                    height: 'auto',
	                    autoplay: 5000,
	                    slidesPerView: 1,
	                    autoplayDisableOnInteraction: false,
	                    onTransitionStart: function onTransitionStart(swiper) {
	                        $tabItems.removeClass(activeClass);
	                        $tabItems.eq(swiper.realIndex).addClass(activeClass);
	                    }
	                });
	
	                $tabItems.on('click', function (event) {
	                    var $item = $(this);
	
	                    if (!$item.is('.' + activeClass)) {
	                        event.preventDefault();
	                        event.stopImmediatePropagation();
	                        $tabItems.removeClass(activeClass);
	                        $item.addClass(activeClass);
	                        imageSwiper.slideTo($item.index(), 300, false);
	                    }
	                });
	            });
	        });
	    }
	});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(128);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(126);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// load the manifest
	window.manifest = jQuery.getJSON('/assets/manifest.json');
	
	exports.default = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(filePath) {
	        var cdn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var manifest, host;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return window.manifest;
	
	                    case 2:
	                        manifest = _context.sent;
	                        host = cdn ? CONFIG.cdn : '';
	
	                        if (!manifest[filePath]) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', host + '/' + manifest[filePath]);
	
	                    case 6:
	                        return _context.abrupt('return', host + '/' + filePath);
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function (_x2) {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var objectfit = function objectfit($el) {
	    if (!('object-fit' in document.body.style)) {
	        jQuery(function ($) {
	            var $objectFitContainer = void 0;
	
	            if (!$el || !$el.length) {
	                $objectFitContainer = $('.object-fit');
	            } else {
	                $objectFitContainer = $el.find('.object-fit');
	            }
	
	            $objectFitContainer.each(function () {
	                var $container = $(this),
	                    imgUrl = $container.find('img').prop('src'),
	                    objectfitFallbackUrl = $container.find('img').data('objectfit');
	
	                if (objectfitFallbackUrl) {
	                    imgUrl = objectfitFallbackUrl;
	                }
	
	                if (imgUrl) {
	                    $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
	                }
	            });
	        });
	    }
	};
	
	objectfit();
	
	exports.default = objectfit;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(129), __esModule: true };

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(130), __esModule: true };

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(131), __esModule: true };

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(132), __esModule: true };

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(133), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(135), __esModule: true };

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(136), __esModule: true };

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(42);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(125);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(124);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(174);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(144);
	module.exports = __webpack_require__(2).Object.assign;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(145);
	var $Object = __webpack_require__(2).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(146);
	var $Object = __webpack_require__(2).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147);
	var $Object = __webpack_require__(2).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(148);
	module.exports = __webpack_require__(2).Object.getPrototypeOf;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	module.exports = __webpack_require__(2).Object.keys;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(150);
	module.exports = __webpack_require__(2).Object.setPrototypeOf;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(151);
	__webpack_require__(49);
	__webpack_require__(152);
	__webpack_require__(153);
	module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(50);
	__webpack_require__(51);
	module.exports = __webpack_require__(76).f('iterator');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(23);
	var gOPS = __webpack_require__(68);
	var pIE = __webpack_require__(47);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(14);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(27)('meta');
	var isObject = __webpack_require__(8);
	var has = __webpack_require__(11);
	var setDesc = __webpack_require__(9).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(17)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(23);
	var gOPS = __webpack_require__(68);
	var pIE = __webpack_require__(47);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(44);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(17)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(13);
	var gOPN = __webpack_require__(85).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(8);
	var anObject = __webpack_require__(4);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(15)(Function.call, __webpack_require__(67).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(5);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(141) });


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(34) });


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(9).f });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(13);
	var $getOwnPropertyDescriptor = __webpack_require__(67).f;
	
	__webpack_require__(69)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(30);
	var $getPrototypeOf = __webpack_require__(45);
	
	__webpack_require__(69)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(30);
	var $keys = __webpack_require__(23);
	
	__webpack_require__(69)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(143).set });


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(1);
	var has = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(48);
	var META = __webpack_require__(140).KEY;
	var $fails = __webpack_require__(17);
	var shared = __webpack_require__(29);
	var setToStringTag = __webpack_require__(19);
	var uid = __webpack_require__(27);
	var wks = __webpack_require__(3);
	var wksExt = __webpack_require__(76);
	var wksDefine = __webpack_require__(75);
	var enumKeys = __webpack_require__(138);
	var isArray = __webpack_require__(139);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var toIObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(40);
	var createDesc = __webpack_require__(24);
	var _create = __webpack_require__(34);
	var gOPNExt = __webpack_require__(142);
	var $GOPD = __webpack_require__(67);
	var $DP = __webpack_require__(9);
	var $keys = __webpack_require__(23);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(85).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(47).f = $propertyIsEnumerable;
	  __webpack_require__(68).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(18)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(7)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('asyncIterator');


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('observable');


/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeRandom = Math.random;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Gets `n` random elements at unique keys from `collection` up to the
	 * size of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} [n=1] The number of elements to sample.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the random elements.
	 * @example
	 *
	 * _.sampleSize([1, 2, 3], 2);
	 * // => [3, 1]
	 *
	 * _.sampleSize([1, 2, 3], 4);
	 * // => [2, 3, 1]
	 */
	function sampleSize(collection, n, guard) {
	  var index = -1,
	      result = toArray(collection),
	      length = result.length,
	      lastIndex = length - 1;
	
	  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	    n = 1;
	  } else {
	    n = baseClamp(toInteger(n), 0, length);
	  }
	  while (++index < n) {
	    var rand = baseRandom(index, lastIndex),
	        value = result[rand];
	
	    result[rand] = result[index];
	    result[index] = value;
	  }
	  result.length = n;
	  return result;
	}
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  return sampleSize(collection, MAX_ARRAY_LENGTH);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (iteratorSymbol && value[iteratorSymbol]) {
	    return iteratorToArray(value[iteratorSymbol]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = shuffle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.3.7 2017-09-06*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
	        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo 3DS",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UC Browser": "UC Browser[VER]",
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = userAgent || '';
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
	         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
	         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
	         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
	         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
	         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
	         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
	         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
	         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
	         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
	         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
	         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
	         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
	         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.3.7 2017-09-06';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(181);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(175);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js